webpackJsonp([13],{

/***/ 102:
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: popover.js v3.3.2
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.2'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }

  Popover.prototype.tip = function () {
    if (!this.$tip) this.$tip = $(this.options.template)
    return this.$tip
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && option == 'destroy') return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);


/***/ }),

/***/ 103:
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.2
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       =
    this.options    =
    this.enabled    =
    this.timeout    =
    this.hoverState =
    this.$element   = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.2'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $(this.options.viewport.selector || this.options.viewport)

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (self && self.$tip && self.$tip.is(':visible')) {
      self.hoverState = 'in'
      return
    }

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var $container   = this.options.container ? $(this.options.container) : this.$element.parent()
        var containerDim = this.getPosition($container)

        placement = placement == 'bottom' && pos.bottom + actualHeight > containerDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < containerDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > containerDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < containerDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  = offset.top  + marginTop
    offset.left = offset.left + marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isHorizontal) {
    this.arrow()
      .css(isHorizontal ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isHorizontal ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = this.tip()
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      that.$element
        .removeAttr('aria-describedby')
        .trigger('hidden.bs.' + that.type)
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && this.$tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof ($e.attr('data-original-title')) != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var elOffset  = isBody ? { top: 0, left: 0 } : $element.offset()
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.width) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    return (this.$tip = this.$tip || $(this.options.template))
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && option == 'destroy') return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);


/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

MOVE.LDP.CrabWalk = function (LDP) {
  var pageIndex, totalCount;

  var init = function init() {
    var prevPropLink = $('.ldp-pager .prev'),
        nextPropLink = $('.ldp-pager .next'),
        propLinks = MOVE.Helper.getPropertyLinksFromStorage(),
        criteria = MOVE.Helper.getSearchCriteriaFromCookie(),
        is_crawalk_disable = MOVE.DOMHelper.isCrabwalkDisable();

    if (is_crawalk_disable) {
      MOVE.DOMHelper.enableCrabwalk();
      return;
    }
    if (criteria && propLinks) {
      $('.ldp-pager').removeClass('hide');
      var linkIndex = matchedPropertyIndex(propLinks.links, MOVE.LDP.model.getData().canonical);

      if (linkIndex >= 0) {
        pageIndex = propLinks.pageIndex ? parseInt(propLinks.pageIndex, 10) : 1;
        totalCount = propLinks.totalCount;
        var pageSize = criteria.pgsz ? criteria.pgsz : 20,
            lastIndex = propLinks.links.length - 1,
            totalPage = Math.ceil(totalCount / pageSize);
        /*
         Next Link Initiator:
         Case 1: If the Link Index is the last in the SRP result set and page Index is
         equal to total page.
        Case 2: If the Link Index is gt, eq 0
        */
        if (linkIndex === lastIndex && pageIndex === totalPage) {
          // We have reached the last next page of crab walk, not do anything
          disablePropLink(nextPropLink);
        } else if (linkIndex >= 0) {
          initPropLink(nextPropLink, propLinks.links[linkIndex + 1]);
        }

        /*
         Previous Link Initiator:
         Case 1: If the Link Index in the SRP Array list is not first initiate it.
        Case 2: If the Link Index in the SRP Array list is first and the SRP Result set
        Page index is not equal to 1.
        */
        if (linkIndex !== 0) {
          initPropLink(prevPropLink, propLinks.links[linkIndex - 1]);
        } else if (linkIndex === 0 && pageIndex !== 1) {
          initPropLink(prevPropLink);
        }
      } else {
        if (MOVE_DATA.propertyDetails.status_display == "Off Market") {
          $('.ldp-pager').addClass('hide');
        }
      }
    }
  };

  var disablePropLink = function disablePropLink($link) {
    $link.addClass('disabled');
  };

  var initPropLink = function initPropLink($link, link) {
    $link.removeClass('disabled');
    if (link) {
      $link.attr('href', link);
    }
    $link.click(propLinkClicked);
  };

  var matchedPropertyIndex = function matchedPropertyIndex(propLinks, url) {
    return _.findIndex(propLinks, function (link) {
      var walker = link.split('?');
      if (walker.length > 1) {
        // The possible query params for LDP are listing id
        return url.includes(walker[0]) && (walker[1].includes(MOVE.LDP.model.getData().listing_id) || MOVE.LDP.model.getData().canonical.includes(walker[0]));
      } else {
        return url.includes(link);
      }
    });
  };

  var propLinkClicked = function propLinkClicked() {
    var href = $(this).attr('href');
    if (href === '#') {
      getNextSetProperties($(this));
      return false;
    } else {
      window.location.href = href;
    }
  };

  var getNextSetProperties = function getNextSetProperties($link) {
    var isNextLink = $link.attr('class') === 'next';
    pageIndex = isNextLink ? pageIndex + 1 : pageIndex - 1;
    $.ajax({
      url: "/next_set_properties",
      method: "GET",
      data: {
        page_index: pageIndex
      },
      dataType: 'json',
      success: function success(response) {
        if (response) {
          if (response.propLinks.length > 0) {
            // Multi listings are added at the end of response.
            // Remove them from the list at the end to make sure crab walk works as expected.
            var propertyLinks = _.uniq(response.propLinks, function (propLink) {
              return propLink.split('?')[0];
            });
            MOVE.Helper.setPropertyLinksToStorage(propertyLinks, totalCount, pageIndex);
            var index = isNextLink ? 0 : propertyLinks.length - 1;
            window.location.href = '/realestateandhomes-detail/' + propertyLinks[index];
          }
        }
      }
    });
  };

  LDP.CrabWalk = {
    init: init
  };

  return LDP.CrabWalk;
}(MOVE.LDP || {});

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

// For LDP New Relic Page view table we want to track some custom metrics
// they should be coming here

MOVE.LDP.NrCustomPageViewTracking = function (LDP) {

  var init = function init() {
    if (typeof window.newrelic !== 'undefined' && !!MOVE_DATA.propertyDetails) {
      window.newrelic.setCustomAttribute('property_type', MOVE_DATA.propertyDetails.property_status);
    }
  };

  LDP.NrCustomPageViewTracking = {
    init: init
  };

  return LDP.NrCustomPageViewTracking;
}(MOVE.LDP || {});

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

// RDC horizontal plugin


(function ($) {
  'use strict';

  var RDC_HORIZONTAL_CAROUSEL_DEFAULT = {
    nav: false,
    autoWidth: true,
    center: false,
    slideBy: 1,
    startPosition: 0,
    lazyLoad: true,
    loop: false,
    items: 1,
    margin: 5,
    rewind: false,
    dots: false,
    loadLoad: false,
    responsive: {},
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    moveBy: 'item', //'item', 'set', or numbers
    showNav: 'show' // 'show', 'hover', 'none'
  };

  // Constructor
  var RdcHorizontalCarousel = function RdcHorizontalCarousel(obj, option) {
    var that = this;
    this.$wrapper = $(obj);
    this.$carousel = $(obj).find('.owl-carousel');
    this.carouselOption = $.extend({}, RDC_HORIZONTAL_CAROUSEL_DEFAULT, option || {});
    var carouselOption = this.carouselOption;

    this.showHideNav = function (e) {
      if (e.item.index === 0) {
        this.hideLeftNav();
      } else {
        this.showLeftNav();
      }
      if (e.item.index + 1 === e.item.count || e.page.size === e.item.count) {
        // If the last item is already the first active item
        // If all items are showing in one page(for autoWidth:false)
        this.hideRightNav();
      } else if (e.item.index + this.fullItemsInViewport() < e.item.count) {
        // When at least one is still not showing fully
        this.showRightNav();
      } else {
        this.hideRightNav();
      }
    };

    this.showLeftNav = function () {
      this.$wrapper.removeClass('hide-left-nav');
      this.$wrapper.find('.rdc-prev-set').removeClass('hide');
    };

    this.showRightNav = function () {
      this.$wrapper.removeClass('hide-right-nav');
      this.$wrapper.find('.rdc-next-set').removeClass('hide');
    };

    this.hideLeftNav = function () {
      this.$wrapper.addClass('hide-left-nav');
      this.$wrapper.find('.rdc-prev-set').addClass('hide');
    };

    this.hideRightNav = function () {
      this.$wrapper.addClass('hide-right-nav');
      this.$wrapper.find('.rdc-next-set').addClass('hide');
    };

    this.fullItemsInViewport = function () {
      var isFullLdpAB = MOVE_DATA.full_ldp_modules === 'V1' || MOVE_DATA.full_ldp_modules === 'V2';
      var width = this.$carousel.find('.owl-item.active').first().width();
      var owlItemClass = isFullLdpAB && option && option.id === 'ldp-unit-wrapper' && !width ? '.owl-item' : '.owl-item.active';

      // Return how many items are showing fully
      return Math.floor((this.$carousel.width() + this.carouselOption.margin) / (this.$carousel.find(owlItemClass).first().width() + this.carouselOption.margin));
    };

    this.itemsInViewport = function () {
      // Return how many items are showing (including partially)
      return Math.ceil(this.$carousel.width() / (this.$carousel.find('.owl-item.active').first().width() + this.carouselOption.margin));
    };

    this.getMoveBy = function () {
      if (this.carouselOption.moveBy === 'set') {
        if (this.fullItemsInViewport() === 0) {
          return 1;
        } else {
          return this.fullItemsInViewport();
        }
      } else if (Number.isInteger(this.carouselOption.moveBy) && this.carouselOption.moveBy > 0) {
        return this.carouselOption.moveBy;
      }
      return 1;
    };

    this.initNavListener = function () {
      var move_item = this.getMoveBy();
      var that = this;
      var $prevSetBtn = this.$wrapper.find('.rdc-prev-set'),
          $nextSetBtn = this.$wrapper.find('.rdc-next-set');

      $prevSetBtn.off('click').on('click', function () {
        for (var i = 0; i < move_item; i++) {
          that.$carousel.trigger('prev.owl.carousel', [150]);
        }
      });
      $nextSetBtn.off('click').on('click', function () {
        for (var i = 0; i < move_item; i++) {
          that.$carousel.trigger('next.owl.carousel', [150]);
        }
      });
    };

    // ADD initialized event
    this.$carousel.on('initialized.owl.carousel', function (e) {
      // for navigation display
      if (carouselOption.showNav === 'none') {
        return;
      }
      if (carouselOption.showNav === 'hover') {
        that.$wrapper.addClass('hover-nav');
      }
      if (carouselOption.loop) {
        that.showLeftNav();
        that.showRightNav();
      } else {
        that.showHideNav(e);

        // Recalculate if showing nav button based on option.showNav and showing
        // Recalculate when page orientation changed
        that.$carousel.on('changed.owl.carousel resized.owl.carousel', function (e) {
          that.showHideNav(e);
        });
      }
      that.$carousel.on('resized.owl.carousel', function () {
        that.initNavListener();
      });
      // for on-click listener
      that.initNavListener();
    });

    // Initialize Owl-Carousel
    this.$carousel.owlCarousel(carouselOption);
  };

  RdcHorizontalCarousel.VERSION = '0.1.0';

  // Carousel Plugin Definition
  function Plugin(option) {
    $(this).attr('data-rdc-carousel', 'active');
    new RdcHorizontalCarousel(this, option);
  }

  $.fn.RdcHorizontalCarousel = Plugin;
  $.fn.RdcHorizontalCarousel.Constructor = RdcHorizontalCarousel;
})($);

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DOWN_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DOWN_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MORTGAGE_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PROPERTY_TAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HOME_INSURANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PRINCIPAL_INTEREST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MORTGAGE_INSURANCE; });
/* unused harmony export MORTGAGE_INSURANCE_FIELD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HOA_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ERROR_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MORTGAGE_PERCENT_ERROR_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MONTHLY_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return BENEFITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MOBILE_SENTENCE_DP_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MOBILE_SENTENCE_LOAN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MOBILE_SENTENCE_MRTG_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PRE_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WAS_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIDE_EFFECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CLEAR_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SYNC_BOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return HIGHLIGHT_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLANK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return BENEFITS_STORE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DOWN_PERCENT_STORE_KEY; });
/* unused harmony export DOWN_PAYMENT_STORE_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return TYPE_STORE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return MORTGAGE_PERCENT_STORE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PRICE_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PRICE_MAX; });
var PRICE = 'home_price';
var DOWN_PAYMENT = 'down_payment_amount';
var DOWN_PERCENT = 'down_payment_percent';
var MORTGAGE_PERCENT = 'mortgage_percent';
var PROPERTY_TAX = "property_tax";
var HOME_INSURANCE = "home_insurance";
var PRINCIPAL_INTEREST = "principle_interest";
var MORTGAGE_INSURANCE = "mortgage_insurance";
var MORTGAGE_INSURANCE_FIELD = "mortgage_insurance_field";
var HOA_FEES = "hoa_fees";
var ERROR_LABEL = 'pmytoptions-homeprice-err';
var MORTGAGE_PERCENT_ERROR_LABEL = 'pmytoptions-mortgamt-err';
var MONTHLY_PAYMENT = "rent_per_month";
var TYPE = "mortgage_loan_type";
var BENEFITS = "apply-benefits";
var MOBILE_SENTENCE_DP_PERCENT = "#mobile-sentence-dp-percent";
var MOBILE_SENTENCE_LOAN_TYPE = "#mobile-sentence-loan-type";
var MOBILE_SENTENCE_MRTG_PERCENT = "#mobile-sentence-mrtg-percent";
// not sure why this is called veterans checkbox
var PRE_APPROVED = "veterans-checkbox";

var CHANGE = "calculator.field.change";
var WAS_CHANGED = "calculator.field.changed";
var SIDE_EFFECT = "calculator.field.side.effect";

var ERROR = "calculator.field.error";
var CLEAR_ERRORS = "calculator.field.errors.clear";
var SYNC_BOUND = "calculator.field.sync.bound.fields";

var PERCENT = "%";
var HIGHLIGHT_FIELDS = "highlight-fields";
var BLANK = "";

// local storage keys
var BENEFITS_STORE_KEY = "local_stored_veterans_checked";
var DOWN_PERCENT_STORE_KEY = "local_stored_estimate_dp_percent";
var DOWN_PAYMENT_STORE_KEY = "local_stored_estimate_dp_amount";
var TYPE_STORE_KEY = "local_stored_selected_mortgage_type";
var MORTGAGE_PERCENT_STORE_KEY = "local_stored_mortgage_percent";

var PRICE_MIN = 1000;
var PRICE_MAX = 999999999;

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

MOVE.SmartyStreetSuggest = function (MOVE) {

  var liveAddressSuggest = function liveAddressSuggest(params) {
    if ($.LiveAddress !== undefined && !$.isEmptyObject(params)) {
      var selector = params.addresses[0].freeform;

      if (selector === '#ldp-commute-address') {
        return liveAddress(params);
      } else {
        $(selector).on('keyup keydown', function (e) {
          if ([MOVE.CONSTANTS.UP_KEY, MOVE.CONSTANTS.DOWN_KEY].includes(e.which)) {
            $('.smarty-autocomplete').addClass('complete-address');
          }
        });

        return liveAddress(params, MOVE.SellSearch.performGeoValidation);
      }
    }
  };

  var defaultAddressParams = function defaultAddressParams() {
    return {
      key: key(),
      target: "US",
      autoVerify: false,
      geolocate: true,
      geolocatePrecision: "state",
      enforceVerification: false,
      submitVerify: false
    };
  };

  var key = function key() {
    var domainName = window.location.hostname,
        key = null;

    if (domainName.includes('.move.com')) {
      key = '13317493615359104';
    } else if (domainName.includes('.realtor.com')) {
      key = '13317493616182871';
    }
    return key;
  };

  var liveAddress = function liveAddress(userParams, callback) {
    var addressParams = $.extend(defaultAddressParams(), userParams !== undefined ? userParams : {});
    if (addressParams.key !== null) {
      var $liveAddress = $.LiveAddress(addressParams);
      $liveAddress.on('AutocompleteUsed', function (event, data, previousHandler) {
        if (typeof callback === "function") {
          callback();
        }

        previousHandler(event, data);
      });

      $liveAddress.on('AutocompleteReceived', function (event, data, previousHandler) {
        if (data.json && data.json.suggestions && data.json.suggestions.length === 1) {
          var delimiters = /[,.]/g,
              suggestion = data.json.suggestions[0].text.toLowerCase().replace(delimiters, ''),
              lastInput = data.addr.lastStreetInput.toLowerCase().replace(delimiters, '');

          if (suggestion === lastInput || normalizeAddress(suggestion) === normalizeAddress(lastInput)) {
            data.suggContainer.addClass('complete-address');
          } else {
            data.suggContainer.removeClass('complete-address');
          }
        } else {
          data.suggContainer.removeClass('complete-address');
        }

        previousHandler(event, data);
      });

      return $liveAddress;
    }
  };

  var normalizeAddress = function normalizeAddress(address) {
    return address.replace(/\b(drive|lane|circle|boulevard|court|street|road|avenue|parkway|northeast|northwest|southeast|southwest|north|east|south|west|dr|ln|cir|blvd|ct|st|rd|ave|pkwy|ne|nw|se|sw|n|e|s|w)\b/g, '').replace(/\s/g, '');
  };

  MOVE.SmartyStreetSuggest = {
    liveAddressSuggest: liveAddressSuggest
  };

  return MOVE.SmartyStreetSuggest;
}(MOVE || {});

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

MOVE.HeroImages = function (MOVE) {
  "use strict";

  var init = function init(options) {
    var heroImages = $(options.target);
    // owl carousel
    heroImages.owlCarousel({
      lazyLoad: options.lazyLoad,
      items: 1,
      loop: true,
      autoplay: true,
      autoplayTimeout: 11000,
      animateOut: options.effect
    }); // /owlCarousel
  }; // /init closing brackets

  MOVE.HeroImages = {
    init: init
  };

  return MOVE.HeroImages;
}(MOVE || {});

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SIDE_EFFECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return popState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onPopState; });
var _callbacks;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SIDE_EFFECT = 'SIDE_EFFECT';
var REDIRECT = 'REDIRECT';

var isValid = function isValid(_ref) {
  var type = _ref.type;
  return Array.isArray(callbacks[type]);
};

var callbacks = (_callbacks = {}, _defineProperty(_callbacks, SIDE_EFFECT, []), _defineProperty(_callbacks, REDIRECT, []), _callbacks);

// condition determines whether to execute handler
var addCallback = function addCallback(_ref2) {
  var type = _ref2.type,
      condition = _ref2.condition,
      handler = _ref2.handler;
  return callbacks[type].push({ condition: condition, handler: handler });
};

// pop one or more states
var popState = function popState(num) {
  return window.history.go(num ? -num : -1);
};

// approach for srp -- give option prefer sideeffects over redirects
// sideeffects must return true {preventRedirect} to prevent redirect
var onPopState = function onPopState(_ref3) {
  var type = _ref3.type,
      condition = _ref3.condition,
      handler = _ref3.handler;

  if (isValid({ type: type })) addCallback({ type: type, condition: condition, handler: handler });
};

window.addEventListener("popstate", function (_ref4) {
  var state = _ref4.state;

  var preventRedirect = false;
  callbacks[SIDE_EFFECT].forEach(function (_ref5) {
    var condition = _ref5.condition,
        handler = _ref5.handler;

    // side effects call handlers
    // if handler returns {preventRedirect}
    // no redirect handlers are executed
    if (condition(state || {})) {
      var result = handler(state) || {};
      preventRedirect = preventRedirect || result.preventRedirect;
    }
  });

  if (preventRedirect) return;else callbacks[REDIRECT].forEach(function (_ref6) {
    var condition = _ref6.condition,
        handler = _ref6.handler;

    if (condition(state || {})) {
      window.location.href = handler(state);
    }
  });
});

/***/ }),

/***/ 1785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_critical__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_critical_bootstrap__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_critical_hero_images__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_critical_hero_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_critical_hero_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_critical_user_activity__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_critical_user_activity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_critical_user_activity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_liveaddress_src_jquery_liveaddress__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_liveaddress_src_jquery_liveaddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_liveaddress_src_jquery_liveaddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_non_critical_smarty_street_suggest__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_non_critical_smarty_street_suggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_non_critical_smarty_street_suggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_non_critical_rdc_horizontal_carousel__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_non_critical_rdc_horizontal_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_non_critical_rdc_horizontal_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ldp_common_platform_ldp__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ldp_common_platform_ldp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ldp_common_platform_ldp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_critical_commute_time__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ldp_common_platform_critical_components_crab_walk__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ldp_common_platform_critical_components_crab_walk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_ldp_common_platform_critical_components_crab_walk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ldp_common_platform_critical_components_nr_custom_page_view_tracking__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ldp_common_platform_critical_components_nr_custom_page_view_tracking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_ldp_common_platform_critical_components_nr_custom_page_view_tracking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ldp_common_platform_critical_components_ldp_photos__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ldp_common_platform_critical_components_ldp_photos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_ldp_common_platform_critical_components_ldp_photos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ldp_common_platform_models_property_details__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ldp_common_platform_controllers_property_details__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ldp_common_platform_views_schedule_tour__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_app__);

















/***/ }),

/***/ 19:
/***/ (function(module, exports) {

(function () {

    //bootstrap application
    MOVE.init();
})();

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PropertyDetailsModel; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var instance = void 0;

var PropertyDetailsModel = function () {
  _createClass(PropertyDetailsModel, null, [{
    key: "instance",
    get: function get() {
      return instance;
    }
  }]);

  function PropertyDetailsModel(_ref) {
    var data = _ref.data;

    _classCallCheck(this, PropertyDetailsModel);

    instance = this;

    this.data = data;
  }

  _createClass(PropertyDetailsModel, [{
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "getHeadLines",
    value: function getHeadLines() {
      return (this.data || {}).headline;
    }
  }]);

  return PropertyDetailsModel;
}();

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

/**
 LiveAddress International API jQuery Plugin
 by SmartyStreets - smartystreets.com

 (c) 2016 SmartyStreets

 LICENSED UNDER THE GNU GENERAL PUBLIC LICENSE VERSION 3
 (http://opensource.org/licenses/gpl-3.0.html)

 Documentation:      http://smartystreets.com/kb/liveaddress-api/website-forms
 Version:        (See variable below for version)
 Minified:        (See documentation or GitHub repository for minified script file)
 Latest stable version:  (See documentation)
 Bleeding-edge release:  https://github.com/smartystreets/jquery.liveaddress

 Feel free to contribute to this project on GitHub by
 submitting pull requests and reporting issues.
 **/


(function ($, window, document) {
	"use strict"; //  http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/

	/*
	 *	PRIVATE MEMBERS
	 */

	var instance; // Contains public-facing functions and variables
	var ui = new UI; // Internal use only, for UI-related tasks
	var version = "3.1.3"; // Version of this copy of the script

	var defaults = {
		candidates: 3, // Number of suggestions to show if ambiguous
		autocomplete: 10, // Number of autocomplete suggestions; set to 0 or false to disable
		requestUrlInternational: "https://international-street.api.smartystreets.com/verify", // International API endpoint
		requestUrlUS: "https://api.smartystreets.com/street-address", // US API endpoint
		timeout: 5000, // How long to wait before the request times out (5000 = 5 seconds)
		speed: "medium", // Animation speed
		ambiguousMessage: "Matched multiple addresses.<br>Which address did you mean?", // Message when address is ambiguous
		invalidMessage: "You entered an unknown address", // Message when address is invalid
		invalidCountryMessage: "Unknown country", // Message when the country is invalid
		missingSecondaryMessage: "Did you forget your apt/suite number?", // Message when address is missing a secondary number
		certifyMessage: "Use it the way I typed it.",
		missingInputMessage: "You didn't enter enough information<br>",
		changeMessage: "Take me back so I can try again.",
		fieldSelector: "input[type=text], input:not([type]), textarea, select", // Selector for possible address-related form elements
		submitSelector: "[type=submit], [type=image], [type=button]:last, button:last", // Selector to find a likely submit button or submit image (in a form)
		target: "US"
	};
	var config = {}; // Configuration settings as set by the user or just the defaults
	var forms = []; // List of forms (which hold lists of addresses)
	var defaultSelector = 'body'; // Default selector which should be over the whole page (must be compatible with the .find() function; not document)
	var mappedAddressCount = 0; // The number of currently-mapped addresses
	var acceptableFields = [
		"freeform", "address1", "address2", "address3", "address4", "organization", "locality", "administrative_area", "postal_code", "country"
	]; // API input field names

	/*
	 *	ENTRY POINT
	 */

	$.LiveAddress = function (arg) {
		return $(defaultSelector).LiveAddress(arg);
	};

	$.fn.LiveAddress = function (arg) {
		var matched = this,
			wasChained = matched.prevObject ? !!matched.prevObject.prevObject : false;

		// Make sure the jQuery version is compatible
		var vers = $.fn.jquery.split(".");
		if (vers.length >= 2) {
			if (vers[0] < 1 || (vers[0] == 1 && vers[1] < 5)) {
				console.log("jQuery version " + $.fn.jquery + " found, but LiveAddress requires jQuery version 1.5 or higher. Aborting.");
				return false;
			}
		} else
			return false;

		if (arg.debug)
			console.log("LiveAddress API jQuery Plugin version " + version + " (Debug mode)");

		// Mapping fields requires that the document be fully loaded in order to attach UI elements
		if (document.readyState === "complete")
			window.loaded = true;
		else
			$(window).load(function () {
				window.loaded = true;
			});

		// Determine if user passed in an API key or a settings/config object
		if (typeof arg === 'string') {
			// Use the default configuration
			config = {
				key: arg
			};
		} else if (typeof arg === 'object') {
			// Use the user's configuration on top of the default
			config = arg;
		}

		// Enforce some defaults
		config.candidates = config.candidates || defaults.candidates;
		config.ui = typeof config.ui === 'undefined' ? true : config.ui;
		config.autoVerify = config.autoVerify !== true && config.autoVerify !== false ? true : config.autoVerify;
		config.submitVerify = typeof config.submitVerify === 'undefined' ? true : config.submitVerify;
		config.timeout = config.timeout || defaults.timeout;
		config.ambiguousMessage = config.ambiguousMessage || defaults.ambiguousMessage;
		config.invalidMessage = config.invalidMessage || defaults.invalidMessage;
		config.invalidCountryMessage = config.invalidCountryMessage || defaults.invalidCountryMessage;
		config.missingSecondaryMessage = config.missingSecondaryMessage || defaults.missingSecondaryMessage;
		config.certifyMessage = config.certifyMessage || defaults.certifyMessage;
		config.missingInputMessage = config.missingInputMessage || defaults.missingInputMessage;
		config.changeMessage = config.changeMessage || defaults.changeMessage;
		config.fieldSelector = config.fieldSelector || defaults.fieldSelector;
		config.submitSelector = config.submitSelector || defaults.submitSelector;
		config.requestUrlInternational = config.requestUrlInternational || defaults.requestUrlInternational;
		config.requestUrlUS = config.requestUrlUS || defaults.requestUrlUS;
		config.autocomplete = typeof config.autocomplete === 'undefined' ? defaults.autocomplete : config.autocomplete;
		config.cityFilter = typeof config.cityFilter === 'undefined' ? "" : config.cityFilter;
		config.stateFilter = typeof config.stateFilter === 'undefined' ? "" : config.stateFilter;
		config.cityStatePreference = typeof config.cityStatePreference === 'undefined' ? "" : config.cityStatePreference;
		config.geolocate = typeof config.geolocate === 'undefined' ? true : config.geolocate;
		config.geolocatePrecision = typeof config.geolocatePrecision === 'undefined' ? 'city' : config.geolocatePrecision;
		config.waitForStreet = typeof config.waitForStreet === 'undefined' ? false : config.waitForStreet;
		config.verifySecondary = typeof config.verifySecondary === 'undefined' ? false : config.verifySecondary;
		config.geocode = typeof config.geocode === 'undefined' ? false : config.geocode;
		config.enforceVerification = typeof config.enforceVerification === 'undefined' ? false : config.enforceVerification;
		config.agent = typeof config.agent === 'undefined' ? "" : config.agent;

		config.candidates = config.candidates < 1 ? 0 : (config.candidates > 10 ? 10 : config.candidates);

		// Parameter used for internal uses. If set to true, freeform will fail. Use with caution
		config.xIncludeInvalid = typeof config.xIncludeInvalid === 'undefined' ? false : config.xIncludeInvalid;

		if (typeof config.autocomplete === 'number')
			config.autocomplete = config.autocomplete < 1 ? false : (config.autocomplete > 10 ? 10 : config.autocomplete);

		config.target = config.target || defaults.target;
		config.target = config.target.toUpperCase().replace(/\s+/g, "").split("|");

		/*
		 *	EXPOSED (PUBLIC) FUNCTIONS
		 */
		instance = {
			events: {
				FieldsMapped: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "FieldsMapped", "(Fields mapped to their respective addresses)", event, data);

					// We wait until the window is all loaded in case some elements are still loading
					window.loaded ? ui.postMappingOperations() : $(window).load(ui.postMappingOperations);
				},

				MapInitialized: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "MapInitialized", "(Mapped fields have been wired up to the window" +
							(config.ui ? ", document, and UI" : " and document") + ")", event, data);
				},

				AutocompleteInvoked: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "AutocompleteInvoked",
							"(A request is about to be sent to the autocomplete service)", event, data);
					ui.requestAutocomplete(event, data);
				},

				AutocompleteReceived: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "AutocompleteReceived",
							"(A response has just been received from the autocomplete service)", event, data);
					ui.showAutocomplete(event, data);
				},

				AutocompleteUsed: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "AutocompleteUsed",
							"(A suggested address was used from the autocomplete service)", event, data);
				},

				AddressChanged: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "AddressChanged", "(Address changed)", event, data);

					// If autoVerify is on, AND there's enough input in the address,
					// AND it hasn't been verified automatically before -OR- it's a freeform address,
					// AND autoVerification isn't suppressed (from an Undo click, even on a freeform address)
					// AND it has a DOM element (it's not just a programmatic Address object)
					// AND the address is "active" for verification
					// AND the autocomplete suggestions aren't visible
					// AND the form, if any, isn't already chewing on an address...
					// THEN verification has been invoked.
					if (config.autoVerify && data.address.enoughInput() && (data.address.verifyCount == 0 ||
						data.address.isFreeform() || data.address.usedAutocomplete) && !data.suppressAutoVerification && data.address.hasDomFields() &&
						data.address.active && !data.address.autocompleteVisible() &&
						(data.address.form && !data.address.form.processing))
						trigger("VerificationInvoked", {
							address: data.address
						});
					data.address.usedAutocomplete = false;
				},

				VerificationInvoked: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "VerificationInvoked", "(Address verification invoked)", event, data);

					// Abort now if an address in the same form is already being processed
					if (!data.address || (data.address && data.address.form && data.address.form.processing)) {
						if (config.debug)
							console.log("NOTICE: VerificationInvoked event handling aborted. Address is missing or an address in the " +
								"same form is already processing.");
						return;
					} else if (data.address.status() == "accepted" && !data.verifyAccepted) {
						if (config.debug)
							console.log("NOTICE: VerificationInvoked raised on an accepted or un-changed address. Nothing to do.");
						return trigger("Completed", data);
					} else if (data.address.form)
						data.address.form.processing = true;

					data.address.verify(data.invoke, data.invokeFn);
				},

				RequestSubmitted: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "RequestSubmitted", "(Request submitted to server)", event, data);

					ui.showLoader(data.address);
				},

				ResponseReceived: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "ResponseReceived",
							"(Response received from server, but has not been inspected)", event, data);

					ui.hideLoader(data.address);

					if (typeof data.invoke === "function")
						data.invoke(data.response); // User-defined callback function; we're all done here.

					if (data.response.isInvalid())
						trigger("AddressWasInvalid", data);
					else if (data.response.isAmbiguous())
						trigger("AddressWasAmbiguous", data);
					else if (config.verifySecondary && data.response.isMissingSecondary())
						trigger("AddressWasMissingSecondary", data);
					else if (data.response.isValid())
						trigger("AddressWasValid", data);
				},

				RequestTimedOut: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "RequestTimedOut", "(Request timed out)", event, data);

					if (data.address.form)
						delete data.address.form.processing; // Tell the potentially duplicate event handlers that we're done.

					// If this was a form submit, don't let a network failure hold them back; just accept it and move on
					if (data.invoke)
						data.address.accept(data, false);

					ui.enableFields(data.address);
					ui.hideLoader(data.address);
				},

				AddressWasValid: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "AddressWasValid", "(Response indicates input address was valid)", event, data);

					var addr = data.address;
					var resp = data.response;

					data.response.chosen = resp.raw[0];
					addr.replaceWith(resp.raw[0], true, event);
					addr.accept(data);
				},

				AddressWasAmbiguous: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "AddressWasAmbiguous", "(Response indiciates input address was ambiguous)", event, data);

					ui.showAmbiguous(data);
				},

				AddressWasInvalid: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "AddressWasInvalid", "(Response indicates input address was invalid)", event, data);

					ui.showInvalid(data);
				},

				CountryWasInvalid: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "CountryWasInvalid", "(Pre-verification check indicates that the country was invalid)", event, data);
					ui.showInvalidCountry(data);
				},

				AddressWasMissingSecondary: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "AddressWasMissingSecondary",
							"(Response indicates input address was missing secondary", event, data);

					ui.showMissingSecondary(data);
				},

				AddressWasMissingInput: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "AddressWasMissingInput", "(Pre-verification check indicates that there was not enough input)", event, data);
					ui.showMissingInput(data);
				},

				OriginalInputSelected: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "OriginalInputSelected", "(User chose to use original input)", event, data);

					data.address.accept(data, false);
				},

				UsedSuggestedAddress: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "UsedSuggestedAddress", "(User chose to a suggested address)", event, data);

					data.response.chosen = data.chosenCandidate;
					data.address.replaceWith(data.chosenCandidate, true, event);
					data.address.accept(data);
				},

				InvalidAddressRejected: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "InvalidAddressRejected", "(User chose to correct an invalid address)", event, data);

					if (data.address.form)
						delete data.address.form.processing; // We're done with this address and ready for the next, potentially

					trigger("Completed", data);
				},

				AddressAccepted: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "AddressAccepted", "(Address marked accepted)", event, data);

					if (!data)
						data = {};

					if (data.address && data.address.form)
						delete data.address.form.processing; // We're done with this address and ready for the next, potentially

					// If this was the result of a form submit, re-submit the form (whether by clicking the button or raising form submit event)
					if (data.invoke && data.invokeFn)
						submitForm(data.invoke, data.invokeFn);

					trigger("Completed", data);
				},

				Completed: function (event, data) {
					if (config.debug)
						console.log("EVENT:", "Completed", "(All done)", event, data);

					if (data.address) {
						ui.enableFields(data.address);
						if (data.address.form)
							delete data.address.form.processing; // We're done with this address and ready for the next, potentially
					}
				}
			},
			on: function (eventType, userHandler) {
				if (!this.events[eventType] || typeof userHandler !== 'function')
					return false;

				var previousHandler = this.events[eventType];
				this.events[eventType] = function (event, data) {
					userHandler(event, data, previousHandler);
				};
			},
			mapFields: function (map) {
				var doMap = function (map) {
					if (typeof map === 'object')
						return ui.mapFields(map, matched);
					else if (!map && typeof config.addresses === 'object')
						return ui.mapFields(config.addresses, matched);
					else
						return false;
				};
				if ($.isReady)
					doMap(map);
				else
					$(function () {
						if (!wasChained)
							matched = $(matched.selector);
						doMap(map);
					});
			},
			makeAddress: function (addressData) {
				if (typeof addressData !== "object")
					return instance.getMappedAddressByID(addressData) || new Address({
							address1: addressData
						});
				else
					return new Address(addressData);
			},
			verify: function (input, callback) {
				var addr = instance.makeAddress(input); // Below means, force re-verify even if accepted/unchanged.
				trigger("VerificationInvoked", {
					address: addr,
					verifyAccepted: true,
					invoke: callback
				});
			},
			getMappedAddresses: function () {
				var addr = [];
				for (var i = 0; i < forms.length; i++)
					for (var j = 0; j < forms[i].addresses.length; j++)
						addr.push(forms[i].addresses[j]);
				return addr;
			},
			getMappedAddressByID: function (addressID) {
				for (var i = 0; i < forms.length; i++)
					for (var j = 0; j < forms[i].addresses.length; j++)
						if (forms[i].addresses[j].id() == addressID)
							return forms[i].addresses[j];
			},
			setKey: function (htmlkey) {
				config.key = htmlkey;
			},
			setCityFilter: function (cities) {
				config.cityFilter = cities;
			},
			setStateFilter: function (states) {
				config.stateFilter = states;
			},
			setCityStatePreference: function (pref) {
				config.cityStatePreference = pref;
			},
			activate: function (addressID) {
				var addr = instance.getMappedAddressByID(addressID);
				if (addr) {
					addr.active = true;
					ui.showSmartyUI(addressID);
				}
			},
			deactivate: function (addressID) {
				if (!addressID)
					return ui.clean();
				var addr = instance.getMappedAddressByID(addressID);
				if (addr) {
					addr.active = false;
					addr.verifyCount = 0;
					addr.unaccept();
					ui.hideSmartyUI(addressID);
				}
			},
			autoVerify: function (setting) {
				if (typeof setting === 'undefined')
					return config.autoVerify;
				else if (setting === false)
					config.autoVerify = false;
				else if (setting === true)
					config.autoVerify = true;
				for (var i = 0; i < forms.length; i++) {
					for (var j = 0; j < forms[i].addresses.length; j++) {
						forms[i].addresses[j].verifyCount = 0;
					}
				}
			},
			version: version
		};

		// Unbind old handlers then bind each handler to an event
		for (var prop in instance.events) {
			$(document).unbind(prop, HandleEvent);
			bind(prop);
		}

		// Map the fields
		if (config.target.indexOf("US") >= 0 || config.target.indexOf("INTERNATIONAL") >= 0) {
			instance.mapFields();
		} else if (config.debug) {
			console.log("Proper target not set in configuration. Please use 'US' or 'INTERNATIONAL'.");
		}

		return instance;
	};

	/*
	 *	PRIVATE FUNCTIONS / OBJECTS
	 */

	/*
	 The UI object auto-maps the fields and controls
	 interaction with the user during the address
	 verification process.
	 */
	function UI() {
		var submitHandler; // Function which is later bound to handle form submits
		var formDataProperty = "smarty-form"; // Indicates whether we've stored the form already
		var autocompleteResponse; // The latest response from the autocomplete server
		var autocplCounter = 0; // A counter so that only the most recent JSONP request is used
		var autocplRequests = []; // The array that holds autocomplete requests in order
		var loaderWidth = 24,
			loaderHeight = 8; // TODO: Update these if the image changes
		var uiCss = "<style>" + ".smarty-dots { display: none; position: absolute; z-index: 999; width: " +
			loaderWidth + "px; height: " + loaderHeight + "px; " +
			"background-image: url('data:image/gif;base64,R0lGODlhGAAIAOMAALSytOTi5MTCxPTy9Ly6vPz6/Ozq7MzKzLS2tOTm5PT29Ly+v" +
			"Pz+/MzOzP///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQJBgAOACwAAAAAGAAIAAAEUtA5NZi8jNrr2FBScQAAYVyKQC6gZBDkUTRkXUhLDSw" +
			"hojc+XcAx0JEGjoRxCRgWjcjAkqZr5WoIiSJIaohIiATqimglg4KWwrDBDNiczgDpiAAAIfkECQYAFwAsAAAAABgACACEVFZUtLK05OLkxMbE9" +
			"PL0jI6MvL68bG5s7Ors1NbU/Pr8ZGJkvLq8zM7MXFpctLa05ObkzMrM9Pb0nJqcxMLE7O7s/P78////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
			"ABWDgZVWQcp2nJREWmhLSKRWOcySoRAWBEZ8IBi+imAAcxwXhZODxDCfFwxloLI6A7OBCoPKWEG/giqxRuOLKRSA2lpVM6kM2dTZmyBuK0Aw8f" +
			"hcQdQMxIwImLiMSLYkVPyEAIfkECQYAFwAsAAAAABgACACEBAIEpKak1NbU7O7svL68VFZU/Pr8JCIktLK05OLkzMrMDA4M9Pb0vLq87Ors9PL" +
			"0xMLEZGZk/P78tLa05ObkzM7MFBIU////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWLgJVGCcZ2n9DASmq7nUwDAQaAPhCAEgzqNncIQodEWg" +
			"xNht7tdDBMmorIw0gKXh3T3uCSYgV3VitUiwrskZTspGpFKsJMRRVdkNBuKseT5Tg4TUQo+BgkCfygSDCwuIgN/IQAh+QQJBgAXACwAAAAAGAA" +
			"IAIRUVlS0srTk4uR8enz08vTExsRsbmzs6uyMjoz8+vzU1tRkYmS8urzMzsxcWly0trTk5uR8fnz09vTMyszs7uycmpz8/vz///8AAAAAAAAAA" +
			"AAAAAAAAAAAAAAAAAAAAAAFYOBlUVBynad1QBaaEtIpIY5jKOgxAM5w5IxAYJKo8HgLwmnnAAAGsodQ2FgcnYUL5Nh0QLTTqbXryB6cXcBPEBY" +
			"aybEL0wm9SNqFWfOWY0Z+JxBSAXkiFAImLiolLoZxIQAh+QQJBgAQACwAAAAAGAAIAIQEAgS0srTc2tz08vTMyszk5uT8+vw0MjS8ury0trTk4" +
			"uT09vTMzszs6uz8/vw0NjT///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFWiAELYMjno4gmCfkDItoEEG" +
			"ANKfwAMAjnA1EjWBg1I4G14HHO5gMiWOAEZUqIAIm86eQeo/XrBbA/RqlMceS6RxVa4xZLVHI7QCHn6hQRbAWDSwoKoIiLzEQIQAh+QQJBgAXA" +
			"CwAAAAAGAAIAIRUVlS0srTk4uR8enz08vTExsRsbmzs6uyMjoz8+vzU1tRkYmS8urzMzsxcWly0trTk5uR8fnz09vTMyszs7uycmpz8/vz///8" +
			"AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFY+B1SYQlntYBmeeVQJSZTEHAHCcUOUCEiwqDw4GQNGrIhGgA4DkGIsIC0ARUHsia4AKpOiGXghewy" +
			"Gq5YwCu4Gw6jlnJ0gu9SKvWRKH2AIt0TQN+F0FNRSISMS0XKSuLCQKKIQAh+QQJBgAXACwAAAAAGAAIAIQEAgSkpqTU1tTs7uy8vrxUVlT8+vw" +
			"kIiS0srTk4uTMyswMDgz09vS8urzs6uz08vTEwsRkZmT8/vy0trTk5uTMzswUEhT///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFZOB1MY8kn" +
			"hJpnpchUKahIEjjnAxEE8xJHABA4VGhGQ0ighFBEA0swWBkYgxMEpfHkva4BKLBxRaBHdACCHT3C14U0VbkRWlsXgYLcERGJQxOD3Q8PkBCfyM" +
			"DKygMDIoiDAIJJiEAIfkECQYAFwAsAAAAABgACACEVFZUtLK05OLkxMbE9PL0jI6MvL68bG5s7Ors1NbU/Pr8ZGJkvLq8zM7MXFpctLa05Obkz" +
			"MrM9Pb0nJqcxMLE7O7s/P78////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWPgdUmEJZ4WaZ6XAlWmEgUBg5wSRRvSmRwOR0HSoBkVIoMxYBA" +
			"RFgBHdPJYBgSXijVAuAykUsBii5VsK96oelFc9i5K40MkgYInigHtAcHFH28XP1EFXSMwLBcWFRIrJwoCiCEAOw=='); }" +
			".smarty-ui { position: absolute; z-index: 999; text-shadow: none; text-align: left; text-decoration: none; }" +
			".smarty-popup { border: 3px solid #4C4C4C; padding: 0; background: #F6F6F6; " +
			"box-shadow: 0px 10px 35px rgba(0, 0, 0, .8); }" + ".smarty-popup-header { background: #DDD; height: 12px; " +
			"text-transform: uppercase; font: bold 12px/1em 'Arial Black', sans-serif; padding: 12px; }" +
			".smarty-popup-ambiguous-header { color: #333; height: 20px; }" + ".smarty-popup-invalid-header { color: #CC0000; }" +
			".smarty-popup-missing-input-header { color: #CC0000; height: 58px; }" +
			".smarty-popup-close { color: #CC0000 !important; text-decoration: none !important; position: absolute; " +
			"right: 15px; top: 10px; display: block; padding: 4px 6px; text-transform: uppercase; }" +
			".smarty-popup-close:hover { color: #FFF !important; background: #CC0000; }" +
			".smarty-choice-list .smarty-choice { background: #FFF; padding: 10px 15px; color: #1A1A1A; }" +
			".smarty-choice { display: block; font: 300 14px/1.5em sans-serif; text-decoration: none !important; " +
			"border-top: 1px solid #CCC; }" + ".smarty-choice-list .smarty-choice:hover { color: #EEE !important; " +
			"background: #333; text-decoration: none !important; }" + ".smarty-choice-alt { border-top: 1px solid #4C4C4C; " +
			"background: #F6F6F6 !important; box-shadow: inset 0 4px 15px -5px rgba(0, 0, 0, .45); }" + ".smarty-choice-alt" +
			" .smarty-choice-abort, .smarty-choice-override { padding: 6px 15px; color: #B3B3B3 !important; " +
			"font-size: 12px; text-decoration: none !important; }" + ".smarty-choice-alt " +
			".smarty-choice:first-child { border-top: 0; }" + ".smarty-choice-abort:hover { color: #333 !important; }" +
			".smarty-choice-override:hover { color: #CC0000 !important; }" + ".smarty-tag { position: absolute; " +
			"display: block; overflow: hidden; font: 15px/1.2em sans-serif; text-decoration: none !important; width: 20px; " +
			"height: 18px; border-radius: 25px; transition: all .25s; -moz-transition: all .25s; " +
			"-webkit-transition: all .25s; -o-transition: all .25s; }" + ".smarty-tag:hover { width: 70px; " +
			"text-decoration: none !important; color: #999; }" + ".smarty-tag:hover .smarty-tag-text " +
			"{ color: #000 !important; }" + ".smarty-tag-grayed { border: 1px solid #B4B4B4 !important; " +
			"color: #999 !important; background: #DDD !important; box-shadow: inset 0 9px 15px #FFF; }" +
			".smarty-tag-green { border: 1px solid #407513 !important; color: #407513 !important; " +
			"background: #A6D187 !important; box-shadow: inset 0 9px 15px #E3F6D5; }" + ".smarty-tag-grayed:hover " +
			"{ border-color: #333 !important; }" + ".smarty-tag-check { padding-left: 4px; " +
			"text-decoration: none !important; }" + ".smarty-tag-text { font-size: 12px !important; position: absolute; " +
			"top: 0; left: 16px; width: 50px !important; text-align: center !important; }" + ".smarty-autocomplete " +
			"{ border: 1px solid #777; background: white; overflow: hidden; white-space: nowrap; " +
			"box-shadow: 1px 1px 3px #555; }" + ".smarty-suggestion { display: block; color: #444; " +
			"text-decoration: none !important; font-size: 12px; padding: 1px 5px; }" + ".smarty-active-suggestion " +
			"{ background: #EEE; color: #000; border: none; outline: none; }" + ".smarty-no-suggestions " +
			"{ padding: 1px 5px; font-size: 12px; color: #AAA; font-style: italic; }" + "</style>";

		this.postMappingOperations = function () {
			// Injects materials into the DOM, binds to form submit events, etc... very important.

			if (config.ui) {
				// Prepend CSS to head tag to allow cascading and give their style rules priority
				$('head').prepend(uiCss);

				// For each address on the page, inject the loader and "address verified" markup after the last element
				var addresses = instance.getMappedAddresses();
				for (var i = 0; i < addresses.length; i++) {
					var id = addresses[i].id();
					$('body').append('<div class="smarty-ui"><div title="Loading..." class="smarty-dots smarty-addr-' + id + '"></div></div>');
					var offset = uiTagOffset(addresses[i].corners(true));
					$('body').append('<div class="smarty-ui" style="top: ' + offset.top + 'px; left: ' + offset.left +
						'px;"><a href="javascript:" class="smarty-tag smarty-tag-grayed smarty-addr-' + id +
						'" title="Address not verified. Click to verify." data-addressid="' + id +
						'"><span class="smarty-tag-check">&#10003;</span><span class="smarty-tag-text">Verify</span></a></div>');

					// Move the UI elements around when browser window is resized
					$(window).resize({
						addr: addresses[i]
					}, function (e) {
						var addr = e.data.addr;
						var offset = uiTagOffset(addr.corners(true)); // Position of lil' tag
						$('.smarty-tag.smarty-addr-' + addr.id())
							.parent('.smarty-ui')
							.css('top', offset.top + 'px')
							.css('left', offset.left + 'px');

						var addrOffset = addr.corners(); // Position of any popup windows
						$('.smarty-popup.smarty-addr-' + addr.id())
							.parent('.smarty-ui')
							.css('top', addrOffset.top + 'px')
							.css('left', addrOffset.left + 'px');

						if (config.autocomplete) { // Position of autocomplete boxes
							var containerUi = $('.smarty-autocomplete.smarty-addr-' + addr.id()).closest('.smarty-ui');
							var domFields = addr.getDomFields();
							var mainInput = '';
							if (domFields['address1']) {
								mainInput = 'address1';
							} else if (domFields['freeform']) {
								mainInput = 'freeform';
							}
							if (mainInput !== '') {
								containerUi.css({
									"left": $(domFields[mainInput]).offset().left + "px",
									"top": ($(domFields[mainInput]).offset().top + $(domFields[mainInput]).outerHeight(false)) + "px"
								});
							}
						}
					});
				}

				$('body').delegate('.smarty-tag-grayed', 'click', function (e) {
					// "Verify" clicked -- manually invoke verification
					var addrId = $(this).data('addressid');
					instance.verify(addrId);
				});

				$('body').delegate('.smarty-undo', 'click', function (e) {
					// "Undo" clicked -- replace field values with previous input
					var addrId = $(this).parent().data('addressid');
					var addr = instance.getMappedAddressByID(addrId);
					addr.undo(true);
					// If fields are re-mapped after an address was verified, it loses its "accepted" status even if no values were changed.
					// Thus, in some rare occasions, the undo link and the "verified!" text may not disappear when the user clicks "Undo",
					// The undo functionality still works in those cases, but with no visible changes, the address doesn't fire "AddressChanged"...
				});

				// Prepare autocomplete UI
				if (config.autocomplete && config.key) {
					// For every mapped address, wire up autocomplete
					for (var i = 0; i < forms.length; i++) {
						var f = forms[i];

						for (var j = 0; j < f.addresses.length; j++) {
							var addr = f.addresses[j];
							var domFields = addr.getDomFields();
							var mainInput = '';
							if (domFields['address1']) {
								mainInput = 'address1';
							} else if (domFields['freeform']) {
								mainInput = 'freeform';
							}
							if (mainInput !== '') {
								var strField = $(domFields[mainInput]);
								var containerUi = $('<div class="smarty-ui"></div>');
								var autoUi = $('<div class="smarty-autocomplete"></div>');

								autoUi.addClass('smarty-addr-' + addr.id());
								containerUi.data("addrID", addr.id());
								containerUi.append(autoUi);

								containerUi.css({
									"position": "absolute",
									"left": strField.offset().left + "px",
									"top": (strField.offset().top + strField.outerHeight(false)) + "px"
								});

								containerUi.hide().appendTo("body");

								containerUi.delegate(".smarty-suggestion", "click", {
									addr: addr,
									containerUi: containerUi
								}, function (event) {
									var sugg = autocompleteResponse.suggestions[$(this).data('suggIndex')];
									useAutocompleteSuggestion(event.data.addr, sugg, event.data.containerUi);
								});

								containerUi.delegate(".smarty-suggestion", "mouseover", function () {
									$('.smarty-active-suggestion').removeClass('smarty-active-suggestion');
									$(this).addClass('smarty-active-suggestion');
								});

								containerUi.delegate(".smarty-active-suggestion", "mouseleave", function () {
									$(this).removeClass('smarty-active-suggestion');
								});
								strField.attr("autocomplete", "off"); // Tell Firefox to keep quiet

								strField.blur({
									containerUi: containerUi
								}, function (event) {
									setTimeout((function (event) {
										return function () {
											if (event.data) event.data.containerUi.hide();
										};
									})(event), 300); // This line is proudly IE9-compatible
								});

								strField.keydown({
									containerUi: containerUi,
									addr: addr
								}, function (event) {
									var suggContainer = $('.smarty-autocomplete', event.data.containerUi);
									var currentChoice = $('.smarty-active-suggestion:visible', suggContainer).first();
									var choiceSelectionIsNew = false;

									if (event.keyCode == 9) { // Tab key
										if (currentChoice.length > 0) {
											var domFields = event.data.addr.getDomFields();
											if (domFields['zipcode'])
												$(domFields['zipcode']).focus();
											else
												$(domFields[mainInput]).blur();
											useAutocompleteSuggestion(event.data.addr, autocompleteResponse.suggestions[currentChoice.data("suggIndex")], event.data.containerUi);
											return addr.isFreeform() ? true : suppress(event);
										} else
											event.data.containerUi.hide();
									} else if (event.keyCode == 40) { // Down arrow
										if (!currentChoice.hasClass('smarty-suggestion')) {
											currentChoice = $('.smarty-suggestion', suggContainer).first().mouseover();
											choiceSelectionIsNew = true;
										}

										if (!choiceSelectionIsNew) {
											if (currentChoice.next('.smarty-addr-' + event.data.addr.id() + ' .smarty-suggestion').length > 0)
												currentChoice.next('.smarty-suggestion').mouseover();
											else
												currentChoice.removeClass('smarty-active-suggestion');
										}

										moveCursorToEnd(this);
									} else if (event.keyCode == 38) { // Up arrow
										if (!currentChoice.hasClass('smarty-suggestion')) {
											currentChoice = $('.smarty-suggestion', suggContainer).last().mouseover();
											choiceSelectionIsNew = true;
										}

										if (!choiceSelectionIsNew) {
											if (currentChoice.prev('.smarty-addr-' + event.data.addr.id() + ' .smarty-suggestion').length > 0)
												currentChoice.prev('.smarty-suggestion').mouseover();
											else
												currentChoice.removeClass('smarty-active-suggestion');
										}

										moveCursorToEnd(this);
									}
								});

								// Flip the on switch!
								strField.keyup({
									form: f,
									addr: addr,
									streetField: strField,
									containerUi: containerUi
								}, doAutocomplete);
							}
						}

						$(document).keyup(function (event) {
							if (event.keyCode == 27) // Esc key
								$('.smarty-autocomplete').closest('.smarty-ui').hide();
						});
					}

					// Try .5 and 1.5 seconds after the DOM loads to re-position UI elements; hack for Firefox.
					setTimeout(function () {
						$(window).resize();
					}, 500);
					setTimeout(function () {
						$(window).resize();
					}, 1500);
				}

			}

			if (config.submitVerify) {
				// Bind to form submits through form submit and submit button click events
				for (var i = 0; i < forms.length; i++) {
					var f = forms[i];

					submitHandler = function (e) {
						// Don't invoke verification if it's already processing or autocomplete is open and the user was pressing Enter to use a suggestion
						if ((e.data.form && e.data.form.processing) || $('.smarty-active-suggestion:visible').length > 0)
							return suppress(e);

						/*
						 IMPORTANT!
						 Prior to version 2.4.8, the plugin would call syncWithDom() at submit-time
						 in case programmatic changes were made to the address input fields, including
						 browser auto-fills. The sync function would detect those changes and force
						 a re-verification to not let invalid addresses through. Unfortunately, this
						 frequently caused infinite loops (runaway lookups), ultimately preventing
						 form submission, which is unacceptable. As a safety measure to protect our
						 customer's subscriptions, we've removed syncWithDom(). The website owner is
						 responsible for making sure that any changes to address field values raise the
						 "change" event on that element. Example: $('#city').val('New City').change();
						 */

						if (!e.data.form.allActiveAddressesAccepted()) {
							// We could verify all the addresses at once, but that can overwhelm the user.
							// An API request is usually quick, so let's do one at a time: it's much cleaner.
							var unaccepted = e.data.form.activeAddressesNotAccepted();
							if (unaccepted.length > 0)
								trigger("VerificationInvoked", {
									address: unaccepted[0],
									invoke: e.data.invoke,
									invokeFn: e.data.invokeFn
								});
							return suppress(e);
						}
					};

					// Performs the tricky operation of uprooting existing event handlers that we have references to
					// (either by jQuery's data cache or HTML attributes) planting ours, then laying theirs on top
					var bindSubmitHandler = function (domElement, eventName) {
						if (!domElement || !eventName)
							return;

						var oldHandlers = [],
							eventsRef = $._data(domElement, 'events');

						// If there are previously-bound-event-handlers (from jQuery), get those.
						if (eventsRef && eventsRef[eventName] && eventsRef[eventName].length > 0) {
							// Get a reference to the old handlers previously bound by jQuery
							oldHandlers = $.extend(true, [], eventsRef[eventName]);
						}

						// Unbind them...
						$(domElement).unbind(eventName);

						// ... then bind ours first ...
						$(domElement)[eventName]({
							form: f,
							invoke: domElement,
							invokeFn: eventName
						}, submitHandler);

						// ... then bind theirs last:
						// First bind their onclick="..." or onsubmit="..." handles...
						if (typeof domElement['on' + eventName] === 'function') {
							var temp = domElement['on' + eventName];
							domElement['on' + eventName] = null;
							$(domElement)[eventName](temp);
						}

						// ... then finish up with their old jQuery handles.
						for (var j = 0; j < oldHandlers.length; j++)
							$(domElement)[eventName](oldHandlers[j].data, oldHandlers[j].handler);
					};

					// Take any existing handlers (bound via jQuery) and re-bind them for AFTER our handler(s).
					var formSubmitElements = $(config.submitSelector, f.dom);

					// Highlight the submit button
					if (config.debug) {
						for (var j = 0; j < formSubmitElements.length; j++) {
							formSubmitElements[j].style.color = '#4BA341';
						}
					}

					// Form submit() events are apparently invoked by CLICKING the submit button (even jQuery does this at its core for binding)
					// (but jQuery, when raising a form submit event with .submit() will NOT necessarily click the submit button)
					formSubmitElements.each(function (idx) {
						bindSubmitHandler(this, 'click'); // These get fired first
					});

				}
			}

			trigger("MapInitialized");
		};

		function doAutocomplete(event) {
			var addr = event.data.addr;
			var streetField = event.data.streetField;
			var input = $.trim(event.data.streetField.val());
			var containerUi = event.data.containerUi;
			var suggContainer = $('.smarty-autocomplete', containerUi);

			if (!input) {
				addr.lastStreetInput = input;
				suggContainer.empty();
				containerUi.hide();
			}

			if (event.keyCode == 13) { // Enter/return
				if ($('.smarty-active-suggestion:visible').length > 0)
					useAutocompleteSuggestion(addr, autocompleteResponse.suggestions[$('.smarty-active-suggestion:visible').first().data('suggIndex')], containerUi);
				containerUi.hide();
				streetField.blur();
				return suppress(event);
			}

			if (event.keyCode == 40) { // Down arrow
				moveCursorToEnd(streetField[0]);
				return;
			}

			if (event.keyCode == 38) { // Up arrow
				moveCursorToEnd(streetField[0]);
				return;
			}

			if (!input || input == addr.lastStreetInput || !addr.isDomestic())
				return;

			addr.lastStreetInput = input; // Used so that autocomplete only fires on real changes (i.e. not just whitespace)
			if (addr.isDomestic() && config.target.indexOf("US") >= 0) {
				trigger('AutocompleteInvoked', {
					containerUi: containerUi,
					suggContainer: suggContainer,
					streetField: streetField,
					input: input,
					addr: addr
				});
			}
		}

		this.requestAutocomplete = function (event, data) {
			if (data.input && data.addr.isDomestic() && autocompleteResponse)
				data.containerUi.show();

			var autocplrequest = {
				callback: function (counter, json) {
					var patt = new RegExp("^\\w+\\s\\w+|^[A-Za-z]+$|^[A-Za-z]+\\s\\w*");
					var filtering = patt.test(data.input);
					autocompleteResponse = json;
					data.suggContainer.empty();

					if (!json.suggestions || json.suggestions.length == 0) {
						data.suggContainer.html('<div class="smarty-no-suggestions">No suggestions</div>');
						return;
					}

					if (config.waitForStreet && filtering == false) {
						var message = "";
						if (config.stateFilter || config.cityFilter || config.geolocate || config.cityStatePreference) {
							message = "filtered";
						} else {
							message = "address";
						}
						data.suggContainer.html('<div class="smarty-no-suggestions">Type more for ' + message + ' suggestions</div>')
					} else {
						for (var j = 0; j < json.suggestions.length; j++) {
							var suggAddr = json.suggestions[j].text.replace(/<|>/g, "");
							suggAddr = suggAddr.replace(new RegExp('(' + data.input + ')', 'ig'), '<b>$1</b>');
							var link = $('<a href="javascript:" class="smarty-suggestion">' + suggAddr + '</a>');
							link.data("suggIndex", j);

							data.suggContainer.append(link);
						}
					}

					data.suggContainer.css({
						"width": Math.max(data.streetField.outerWidth(false), 250) + "px"
					});

					data.containerUi.show();

					// Delete all older callbacks so they don't get executed later because of latency
					autocplRequests.splice(0, counter);
				},
				number: autocplCounter++
			};

			autocplRequests[autocplrequest.number] = autocplrequest;

			$.getJSON("https://autocomplete-api.smartystreets.com/suggest?callback=?", {
				"auth-id": config.key,
				"auth-token": config.token,
				prefix: data.input,
				city_filter: config.cityFilter,
				state_filter: config.stateFilter,
				prefer: config.cityStatePreference,
				suggestions: config.autocomplete,
				geolocate: config.geolocate,
				geolocate_precision: config.geolocatePrecision,
				agent: "plugin:jquery@" + instance.version + "\|" + config.agent
			}, function (json) {
				trigger("AutocompleteReceived", $.extend(data, {
					json: json,
					autocplrequest: autocplrequest
				}));
			});
		};

		this.showAutocomplete = function (event, data) {
			if (autocplRequests[data.autocplrequest.number])
				autocplRequests[data.autocplrequest.number].callback(data.autocplrequest.number, data.json);
		};

		function useAutocompleteSuggestion(addr, suggestion, containerUi) {
			var domfields = addr.getDomFields();
			containerUi.hide(); // It's important that the suggestions are hidden before AddressChanged event fires

			if (addr.isFreeform())
				$(domfields['freeform']).val(suggestion.text).change();
			else {
				if (domfields['postal_code']) {
					$(domfields['postal_code']).val("").change();
				}
				if (domfields['address1'])
					$(domfields['address1']).val(suggestion.street_line).change();
				// State filled in before city so autoverify is not invoked without finishing using the suggestion
				if (domfields['administrative_area']) {
					if (domfields['administrative_area'].options) { // Checks for dropdown
						for (var i = 0; i < domfields['administrative_area'].options.length; i++) {
							// Checks for abbreviation match and maps full state name to abbreviation
							if (domfields['administrative_area'].options[i].text.toUpperCase() === suggestion.state || allStatesByName[domfields['administrative_area'].options[i].text.toUpperCase()] === suggestion.state) {
								$(domfields['administrative_area'])[0].selectedIndex = i;
								$(domfields['administrative_area']).change();
								break;
							}
						}
					} else {
						$(domfields['administrative_area']).val(suggestion.state).change();
					}
				}
				if (domfields['locality']) {
					$(domfields['locality']).val("").change();
					addr.usedAutocomplete = true;
					$(domfields['locality']).val(suggestion.city).change();
				}
			}
			if (domfields['country'] && !domfields['country'].options) {
				$(domfields['country']).val("USA").change();
			}
			trigger("AutocompleteUsed", {
				address: addr,
				suggestion: suggestion
			});
		}

		// Computes where the little checkmark tag of the UI goes, relative to the boundaries of the last field
		function uiTagOffset(corners) {
			return {
				top: corners.top + corners.height / 2 - 10,
				left: corners.right - 6
			};
		}

		// This function is used to find and properly map elements to their field type
		function filterDomElement(domElement, names, labels) {
			/*
			 Where we look to find a match, in this order:
			 name, id, <label> tags, placeholder, title
			 Our searches first conduct fairly liberal "contains" searches:
			 if the attribute even contains the name or label, we map it.
			 The names and labels we choose to find are very particular.
			 */

			var name = lowercase(domElement.name);
			var id = lowercase(domElement.id);
			var selectorSafeID = id.replace(/[\[|\]|\(|\)|\:|\'|\"|\=|\||\#|\.|\!|\||\@|\^|\&|\*]/g, '\\\\$&');
			var placeholder = lowercase(domElement.placeholder);
			var title = lowercase(domElement.title);

			// First look through name and id attributes of the element, the most common
			for (var i = 0; i < names.length; i++)
				if (name.indexOf(names[i]) > -1 || id.indexOf(names[i]) > -1)
					return true;

			// If we can't find it in name or id, look at labels associated to the element.
			// Webkit automatically associates labels with form elements for us. But for other
			// browsers, we have to find them manually, which this next block does.
			if (!('labels' in domElement)) {
				var lbl = $('label[for="' + selectorSafeID + '"]')[0] || $(domElement).parents('label')[0];
				domElement.labels = !lbl ? [] : [lbl];
			}

			// Iterate through the <label> tags now to search for a match.
			for (var i = 0; i < domElement.labels.length; i++) {
				// This inner loop compares each label value with what we're looking for
				for (var j = 0; j < labels.length; j++)
					if ($(domElement.labels[i]).text().toLowerCase().indexOf(labels[j]) > -1)
						return true;
			}

			// Still not found? Then look in "placeholder" or "title"...
			for (var i = 0; i < labels.length; i++)
				if (placeholder.indexOf(labels[i]) > -1 || title.indexOf(labels[i]) > -1)
					return true;

			// Got all the way to here? Probably not a match then.
			return false;
		}

		// User aborted the verification process (X click or esc keyup)
		function userAborted(uiPopup, e) {
			// Even though there may be more than one bound, and this disables the others,
			// this is for simplicity: and I figure, it won't happen too often.
			// (Otherwise "Completed" events are raised by pressing Esc even if nothing is happening)
			$(document).unbind('keyup');
			$(uiPopup).slideUp(defaults.speed, function () {
				$(this).parent('.smarty-ui').remove();
			});
			trigger("Completed", e.data);
		}

		// When we're done with a "pop-up" where the user chooses what to do,
		// we need to remove all other events bound on that whole "pop-up"
		// so that it doesn't interfere with any future "pop-ups".
		function undelegateAllClicks(selectors) {
			if (Array.isArray(selectors) || typeof selectors == "object") {
				for (var selector in selectors) {
					$('body').undelegate(selectors[selector], 'click');
				}
			} else if (typeof selectors === "string") {
				$('body').undelegate(selectors, 'click');
			} else {
				alert("ERROR: Not an array, string, or object passed in to undelegate all clicks");
			}
		}

		// Utility function
		function moveCursorToEnd(el) { // Courtesy of http://css-tricks.com/snippets/javascript/move-cursor-to-end-of-input/
			if (typeof el.selectionStart == "number")
				el.selectionStart = el.selectionEnd = el.value.length;
			else if (typeof el.createTextRange != "undefined") {
				el.focus();
				var range = el.createTextRange();
				range.collapse(false);
				range.select();
			}
		}

		//shows the SmartyUI when activating 1 address
		this.showSmartyUI = function (addressID) {
			var smartyui = $('.deactivated.smarty-addr-' + addressID);
			smartyui.push(smartyui[0].parentElement);
			smartyui.removeClass("deactivated");
			smartyui.addClass("activated");
			smartyui.show();
		};

		//hides the SmartyUI when deactivating 1 address
		this.hideSmartyUI = function (addressID) {
			var smartyui = $('.smarty-addr-' + addressID + ':visible');
			var autocompleteui = $('.smarty-autocomplete.smarty-addr-' + addressID);
			smartyui.addClass("deactivated");
			smartyui.parent().addClass("deactivated");
			autocompleteui.addClass("deactivated");
			smartyui.hide();
			smartyui.parent().hide();
			autocompleteui.hide();
		};

		// If anything was previously mapped, this resets it all for a new mapping.
		this.clean = function () {
			if (forms.length == 0)
				return;

			if (config.debug)
				console.log("Cleaning up old form map data and bindings...");

			// Spare none alive!

			for (var i = 0; i < forms.length; i++) {
				$(forms[i].dom).data(formDataProperty, '');

				// Clean up each form's DOM by resetting the address fields to the way they were
				for (var j = 0; j < forms[i].addresses.length; j++) {
					var doms = forms[i].addresses[j].getDomFields();
					for (var prop in doms) {
						if (config.debug) {
							$(doms[prop]).css('background', 'none').attr('placeholder', '');
							var submitButtons = $(config.submitSelector);
							for (var k = 0; k < submitButtons.length; k++) {
								submitButtons[k].style.color = 'black';
							}
						}
						$(doms[prop]).unbind('change');
					}
					if (doms['address1'])
						$(doms['address1']).unbind('keyup').unbind('keydown').unbind('blur');
					else if (doms['freeform'])
						$(doms['freeform']).unbind('keyup').unbind('keydown').unbind('blur');
				}

				// Unbind our form submit and submit-button click handlers
				$.each(forms, function (idx) {
					$(this.dom).unbind('submit', submitHandler);
				});
				$(config.submitSelector, forms[i].dom).each(function (idx) {
					$(this).unbind('click', submitHandler);
				});
			}

			$('.smarty-ui').undelegate('.smarty-suggestion', 'click').undelegate('.smarty-suggestion', 'mouseover').undelegate('.smarty-suggestion', 'mouseleave').remove();
			$('body').undelegate('.smarty-undo', 'click');
			$('body').undelegate('.smarty-tag-grayed', 'click');
			$(window).unbind('resize');
			$(document).unbind('keyup');

			forms = [];
			mappedAddressCount = 0;

			if (config.debug)
				console.log("Done cleaning up; ready for new mapping.");
		};

		function disableBrowserAutofill(dom) {
			//Does not disable autofill if config.autocomplete is disabled
			if (config.autocomplete > 0) {
				for (var i = 0; i < dom.getElementsByTagName("input").length; i++) {
					dom.getElementsByTagName("input")[i].autocomplete = "smartystreets";
				}
			}
		}

		function addDefaultToStateDropdown(dom) {
			if (dom.getElementsByTagName("option").length > 0) {
				if (arrayContains(stateNames, dom.getElementsByTagName("option")[0].text.toUpperCase()) ||
					arrayContains(stateAbbreviations, dom.getElementsByTagName("option")[0].text.toUpperCase())) {
					var option = document.createElement("OPTION");
					option.innerText = "Pick a state";
					option.selected = true;
					$(dom.getElementsByTagName("select")[0]).prepend(option);
					$(dom).change();
				}
			}
		}

		// ** MANUAL MAPPING ** //
		this.mapFields = function (map, context) {
			// "map" should be an array of objects mapping field types
			// to a field by selector, all supplied by the user.
			// "context" should be the set of elements in which fields will be mapped
			// Context can be acquired like: $('#something').not('#something-else').LiveAddress( ... ); ...

			if (config.debug)
				console.log("Manually mapping fields given this data:", map);

			this.clean();
			var formsFound = [];
			map = map instanceof Array ? map : [map];

			for (var addrIdx in map) {
				var address = map[addrIdx];

				if (!address.country && config.target.indexOf("US") < 0)
					continue;

				// Convert selectors into actual DOM references
				for (var fieldType in address) {
					if (fieldType != "id") {
						if (!arrayContains(acceptableFields, fieldType)) { // Make sure the field name is allowed
							if (config.debug)
								console.log("NOTICE: Field named " + fieldType + " is not allowed. Skipping...");
							delete address[fieldType];
							continue;
						}
						var matched = $(address[fieldType], context);
						if (matched.length == 0) { // Don't try to map an element that couldn't be matched or found at all
							if (config.debug)
								console.log("NOTICE: No matches found for selector " + address[fieldType] + ". Skipping...");
							delete address[fieldType];
						} else if (matched.parents('form').length == 0) { // We should only map elements inside a <form> tag; otherwise we can't bind to submit handlers later
							if (config.debug)
								console.log("NOTICE: Element with selector \"" + address[fieldType] + "\" is not inside a <form> tag. Skipping...");
							delete address[fieldType];
						} else
							address[fieldType] = matched[0];
					}
				}
				if (config.target.indexOf("INTERNATIONAL") >= 0) {
					if (!((address.country && address.freeform) || (address.country && address.address1 && address.postal_code) || (address.country && address.address1 && address.locality && address.administrative_area))) {
						if (config.debug)
							console.log("NOTICE: Address map (index " + addrIdx + ") was not mapped to a complete street address. Skipping...");
						continue;
					}
				} else {
					if (!((address.freeform) || (address.address1 && address.postal_code) || (address.address1 && address.locality && address.administrative_area))) {
						if (config.debug)
							console.log("NOTICE: Address map (index " + addrIdx + ") was not mapped to a complete street address. Skipping...");
						continue;
					}
				}

				// Acquire the form based on the first member
				var formDom = $(address.address1).parents('form')[0];
				if (!formDom) {
					formDom = $(address.freeform).parents('form')[0];
				}
				var form = new Form(formDom);

				// Persist a reference to the form if it wasn't acquired before
				if (!$(formDom).data(formDataProperty)) {
					// Mark the form as mapped then add it to our list
					$(formDom).data(formDataProperty, 1);
					disableBrowserAutofill(form.dom);
					addDefaultToStateDropdown(form.dom);
					formsFound.push(form);
				} else {
					// Find the form in our list since we already put it there
					for (var i = 0; i < formsFound.length; i++) {
						if (formsFound[i].dom == formDom) {
							form = formsFound[i];
							break;
						}
					}
				}

				// Add this address to the form
				mappedAddressCount++;
				form.addresses.push(new Address(address, form, address.id));

				if (config.debug)
					console.log("Finished mapping address with ID: " + form.addresses[form.addresses.length - 1].id());
			}

			forms = formsFound;
			trigger("FieldsMapped");
		};

		this.disableFields = function (address) {
			// Given an address, disables the input fields for the address, also the submit button
			if (!config.ui)
				return;

			var fields = address.getDomFields();
			for (var field in fields)
				$(fields[field]).prop ? $(fields[field]).prop('disabled', true) : $(fields[field]).attr('disabled', 'disabled');

			// Disable submit buttons
			if (address.form && address.form.dom) {
				var buttons = $(config.submitSelector, address.form.dom);
				buttons.prop ? buttons.prop('disabled', true) : buttons.attr('disabled', 'disabled');
			}
		};

		this.enableFields = function (address) {
			// Given an address, re-enables the input fields for the address
			if (!config.ui)
				return;

			var fields = address.getDomFields();
			for (var field in fields)
				$(fields[field]).prop ? $(fields[field]).prop('disabled', false) : $(fields[field]).removeAttr('disabled');

			// Enable submit buttons
			if (address.form && address.form.dom) {
				var buttons = $(config.submitSelector, address.form.dom);
				buttons.prop ? buttons.prop('disabled', false) : buttons.removeAttr('disabled');
			}
		};

		this.showLoader = function (addr) {
			if (!config.ui || !addr.hasDomFields())
				return;

			// Get position information now instead of earlier in case elements shifted since page load
			var lastFieldCorners = addr.corners(true);
			var loaderUI = $('.smarty-dots.smarty-addr-' + addr.id()).parent();

			loaderUI.css("top", (lastFieldCorners.top + lastFieldCorners.height / 2 - loaderHeight / 2) + "px")
				.css("left", (lastFieldCorners.right - loaderWidth - 10) + "px");
			$('.smarty-dots', loaderUI).show();
		};

		this.hideLoader = function (addr) {
			if (config.ui)
				$('.smarty-dots.smarty-addr-' + addr.id()).hide();
		};

		this.markAsValid = function (addr) {
			if (!config.ui || !addr)
				return;

			var domTag = $('.smarty-tag.smarty-tag-grayed.smarty-addr-' + addr.id());
			domTag.removeClass('smarty-tag-grayed').addClass('smarty-tag-green').attr("title", "Address verified! Click to undo.");
			$('.smarty-tag-text', domTag).text('Verified').hover(function () {
				$(this).text('Undo');
			}, function () {
				$(this).text('Verified');
			}).addClass('smarty-undo');
		};

		this.unmarkAsValid = function (addr) {
			var validSelector = '.smarty-tag.smarty-addr-' + addr.id();
			if (!config.ui || !addr || $(validSelector).length == 0)
				return;

			var domTag = $('.smarty-tag.smarty-tag-green.smarty-addr-' + addr.id());
			domTag.removeClass('smarty-tag-green').addClass('smarty-tag-grayed').attr("title", "Address not verified. Click to verify.");
			$('.smarty-tag-text', domTag).text('Verify').unbind('mouseenter mouseleave').removeClass('smarty-undo');
		};

		this.showAmbiguous = function (data) {
			if (!config.ui || !data.address.hasDomFields())
				return;

			var addr = data.address;
			var response = data.response;
			var corners = addr.corners();
			corners.width = Math.max(corners.width, 300); // minimum width
			corners.height = Math.max(corners.height, response.length * 63 + 127); // minimum height
			if (config.enforceVerification) {
				corners.height -= 49;
			}

			var html = '<div class="smarty-ui" style="top: ' + corners.top + 'px; left: ' + corners.left + 'px; width: ' +
				corners.width + 'px; height: ' + corners.height + 'px;">' + '<div class="smarty-popup smarty-addr-' +
				addr.id() + '" style="width: ' + (corners.width - 6) + 'px; height: ' + (corners.height - 3) + 'px;">' +
				'<div class="smarty-popup-header smarty-popup-ambiguous-header">' + config.ambiguousMessage +
				'<a href="javascript:" class="smarty-popup-close smarty-abort" title="Cancel">x</a></div>' +
				'<div class="smarty-choice-list">';

			if (addr.isDomestic()) {
				for (var i = 0; i < response.raw.length; i++) {
					var line1 = response.raw[i].delivery_line_1,
						city = response.raw[i].components.city_name,
						st = response.raw[i].components.state_abbreviation,
						zip = response.raw[i].components.zipcode + "-" + response.raw[i].components.plus4_code;
					html += '<a href="javascript:" class="smarty-choice" data-index="' + i + '">' + line1 + '<br>' + city + ', ' + st + ' ' + zip + '</a>';
				}
			} else {
				var numCandidates = config.candidates;
				if (response.raw.length < numCandidates) {
					numCandidates = response.raw.length;
				}
				for (var i = 0; i < numCandidates; i++) {
					var ambigAddr = '';
					if (response.raw[i].address1) {
						ambigAddr += response.raw[i].address1;
					}
					if (response.raw[i].address2) {
						ambigAddr = ambigAddr + '<br>' + response.raw[i].address2;
					}
					if (response.raw[i].address3) {
						ambigAddr = ambigAddr + '<br>' + response.raw[i].address3;
					}
					if (response.raw[i].address4) {
						ambigAddr = ambigAddr + '<br>' + response.raw[i].address4;
					}
					if (response.raw[i].address5) {
						ambigAddr = ambigAddr + '<br>' + response.raw[i].address5;
					}
					if (response.raw[i].address6) {
						ambigAddr = ambigAddr + '<br>' + response.raw[i].address6;
					}
					html += '<a href="javascript:" class="smarty-choice" data-index="' + i + '">' + ambigAddr + '</a>';
				}
			}

			html += '</div><div class="smarty-choice-alt">';
			html += '<a href="javascript:" class="smarty-choice smarty-choice-abort smarty-abort">' + config.changeMessage + '</a>';
			if (!config.enforceVerification) {
				html += '<a href="javascript:" class="smarty-choice smarty-choice-override">' + config.certifyMessage + '<br>(' +
					addr.toString() + ')</a>';
			}
			html += '</div></div></div>';
			$(html).hide().appendTo('body').show(defaults.speed);

			// Scroll to it if needed
			if ($(document).scrollTop() > corners.top - 100 || $(document).scrollTop() < corners.top - $(window).height() + 100) {
				$('html, body').stop().animate({
					scrollTop: $('.smarty-popup.smarty-addr-' + addr.id()).offset().top - 100
				}, 500);
			}

			data.selectors = {
				goodAddr: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-choice-list .smarty-choice',
				useOriginal: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-choice-override',
				abort: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-abort'
			};

			// User chose a candidate address
			$('body').delegate(data.selectors.goodAddr, 'click', data, function (e) {
				$('.smarty-popup.smarty-addr-' + addr.id()).slideUp(defaults.speed, function () {
					$(this).parent('.smarty-ui').remove();
					$(this).remove();
				});

				undelegateAllClicks(e.data.selectors);
				delete e.data.selectors;

				trigger("UsedSuggestedAddress", {
					address: e.data.address,
					response: e.data.response,
					invoke: e.data.invoke,
					invokeFn: e.data.invokeFn,
					chosenCandidate: response.raw[$(this).data('index')]
				});
			});

			// User wants to revert to what they typed (forced accept)
			$('body').delegate(data.selectors.useOriginal, 'click', data, function (e) {
				$(this).parents('.smarty-popup').slideUp(defaults.speed, function () {
					$(this).parent('.smarty-ui').remove();
					$(this).remove();
				});

				undelegateAllClicks(e.data.selectors);
				delete e.data.selectors;
				trigger("OriginalInputSelected", e.data);
			});

			// User presses Esc key
			$(document).keyup(data, function (e) {
				if (e.keyCode == 27) { //Esc
					undelegateAllClicks(e.data.selectors);
					delete e.data.selectors;
					userAborted($('.smarty-popup.smarty-addr-' + e.data.address.id()), e);
					suppress(e);
				}
			});

			// User clicks "x" in corner or chooses to try a different address (same effect as Esc key)
			$('body').delegate(data.selectors.abort, 'click', data, function (e) {
				undelegateAllClicks(e.data.selectors);
				delete e.data.selectors;
				userAborted($(this).parents('.smarty-popup'), e);
			});
		};

		this.showInvalid = function (data) {
			if (!config.ui || !data.address.hasDomFields())
				return;

			var addr = data.address;
			var response = data.response;
			var corners = addr.corners();
			corners.width = Math.max(corners.width, 320); // minimum width
			corners.height = Math.max(corners.height, 180); // minimum height
			if (config.enforceVerification) {
				corners.height -= 49;
			}

			var html = '<div class="smarty-ui" style="top: ' + corners.top + 'px; left: ' + corners.left + 'px; width: ' +
				corners.width + 'px; height: ' + corners.height + 'px;">' + '<div class="smarty-popup smarty-addr-' +
				addr.id() + '" style="width: ' + (corners.width - 6) + 'px; height: ' + (corners.height - 3) + 'px;">' +
				'<div class="smarty-popup-header smarty-popup-invalid-header">' + config.invalidMessage +
				'<a href="javascript:" class="smarty-popup-close smarty-abort" title="Cancel">x</a></div>' +
				'<div class="smarty-choice-list"><a href="javascript:" ' +
				'class="smarty-choice smarty-choice-abort smarty-abort">' + config.changeMessage + '</a></div>' +
				'<div class="smarty-choice-alt">';
			if (!config.enforceVerification) {
				html += '<a href="javascript:" class="smarty-choice smarty-choice-override">' +
					config.certifyMessage + '<br>(' + addr.toString() + ')</a>';
			}
			html += '</div></div></div>';

			$(html).hide().appendTo('body').show(defaults.speed);

			data.selectors = {
				useOriginal: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-choice-override ',
				abort: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-abort'
			};

			// Scroll to it if necessary
			if ($(document).scrollTop() > corners.top - 100 || $(document).scrollTop() < corners.top - $(window).height() + 100) {
				$('html, body').stop().animate({
					scrollTop: $('.smarty-popup.smarty-addr-' + addr.id()).offset().top - 100
				}, 500);
			}

			undelegateAllClicks(data.selectors.abort);
			// User rejects original input and agrees to double-check it
			$('body').delegate(data.selectors.abort, 'click', data, function (e) {
				userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				delete e.data.selectors;
				trigger("InvalidAddressRejected", e.data);
			});

			undelegateAllClicks(data.selectors.useOriginal);
			// User certifies that what they typed is correct
			$('body').delegate(data.selectors.useOriginal, 'click', data, function (e) {
				userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				delete e.data.selectors;
				trigger("OriginalInputSelected", e.data);
			});

			// User presses esc key
			$(document).keyup(data, function (e) {
				if (e.keyCode == 27) { //Esc
					undelegateAllClicks(e.data.selectors);
					$(data.selectors.abort).click();
					userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				}
			});
		};

		this.showInvalidCountry = function (data) {
			if (!config.ui || !data.address.hasDomFields())
				return;

			var addr = data.address;
			var response = data.response;
			var corners = addr.corners();
			corners.width = Math.max(corners.width, 250); // minimum width
			corners.height = Math.max(corners.height, 180); // minimum height
			if (config.enforceVerification) {
				corners.height -= 49;
			}

			var html = '<div class="smarty-ui" style="top: ' + corners.top + 'px; left: ' + corners.left + 'px; width: ' +
				corners.width + 'px; height: ' + corners.height + 'px;">' + '<div class="smarty-popup smarty-addr-' +
				addr.id() + '" style="width: ' + (corners.width - 6) + 'px; height: ' + (corners.height - 3) + 'px;">' +
				'<div class="smarty-popup-header smarty-popup-invalid-header">' + config.invalidCountryMessage +
				'<a href="javascript:" class="smarty-popup-close smarty-abort" title="Cancel">x</a></div>' +
				'<div class="smarty-choice-list"><a href="javascript:" ' +
				'class="smarty-choice smarty-choice-abort smarty-abort">' + config.changeMessage + '</a></div>' +
				'<div class="smarty-choice-alt">';
			if (!config.enforceVerification) {
				html += '<a href="javascript:" class="smarty-choice smarty-choice-override">' +
					config.certifyMessage + '<br>(' + addr.toString() + ')</a>';
			}
			html += '</div></div></div>';

			$(html).hide().appendTo('body').show(defaults.speed);

			data.selectors = {
				useOriginal: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-choice-override ',
				abort: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-abort'
			};

			// Scroll to it if necessary
			if ($(document).scrollTop() > corners.top - 100 || $(document).scrollTop() < corners.top - $(window).height() + 100) {
				$('html, body').stop().animate({
					scrollTop: $('.smarty-popup.smarty-addr-' + addr.id()).offset().top - 100
				}, 500);
			}

			undelegateAllClicks(data.selectors.abort);
			// User rejects original input and agrees to double-check it
			$('body').delegate(data.selectors.abort, 'click', data, function (e) {
				userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				delete e.data.selectors;
				trigger("InvalidAddressRejected", e.data);
			});

			undelegateAllClicks(data.selectors.useOriginal);
			// User certifies that what they typed is correct
			$('body').delegate(data.selectors.useOriginal, 'click', data, function (e) {
				userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				delete e.data.selectors;
				trigger("OriginalInputSelected", e.data);
			});

			// User presses esc key
			$(document).keyup(data, function (e) {
				if (e.keyCode == 27) { //Esc
					undelegateAllClicks(e.data.selectors);
					$(data.selectors.abort).click();
					userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				}
			});
		};

		this.showMissingSecondary = function (data) {
			if (!config.ui || !data.address.hasDomFields())
				return;
			var addr = data.address;
			var corners = addr.corners();
			corners.width = Math.max(corners.width, 300);
			corners.height = Math.max(corners.height, 180);
			if (config.enforceVerification) {
				corners.height -= 49;
			}

			var html = '<div class="smarty-ui" style="top: ' + corners.top + 'px; left: ' + corners.left + 'px; width: ' +
				corners.width + 'px; height: ' + corners.height + 'px;">' + '<div class="smarty-popup smarty-addr-' +
				addr.id() + '" style="width: ' + (corners.width - 6) + 'px; height: ' + (corners.height - 3) + 'px;">' +
				'<div class="smarty-popup-header smarty-popup-missing-secondary-header">' + config.missingSecondaryMessage +
				'<a href="javascript:" class="smarty-popup-close smarty-abort" title="Cancel">x</a></div>' +
				'<div class="smarty-choice-list"><a href="javascript:" ' +
				'class="smarty-choice smarty-choice-abort smarty-abort">' + config.changeMessage + '</a></div>' +
				'<div class="smarty-choice-alt">';
			if (!config.enforceVerification) {
				html += '<a href="javascript:" class="smarty-choice smarty-choice-override">' +
					config.certifyMessage + '<br>(' + addr.toString() + ')</a>';
			}
			html += '</div>' + '</div></div>';

			$(html).hide().appendTo('body').show(defaults.speed);

			data.selectors = {
				useOriginal: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-choice-override ',
				abort: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-abort'
			};

			// Scroll to it if necessary
			if ($(document).scrollTop() > corners.top - 100 || $(document).scrollTop() < corners.top - $(window).height() + 100) {
				$('html, body').stop().animate({
					scrollTop: $('.smarty-popup.smarty-addr-' + addr.id()).offset().top - 100
				}, 500);
			}

			undelegateAllClicks(data.selectors.abort);
			// User rejects original input and agrees to double-check it
			$('body').delegate(data.selectors.abort, 'click', data, function (e) {
				userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				delete e.data.selectors;
				trigger("InvalidAddressRejected", e.data);
			});

			undelegateAllClicks(data.selectors.useOriginal);
			// User certifies that what they typed is correct
			$('body').delegate(data.selectors.useOriginal, 'click', data, function (e) {
				userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				delete e.data.selectors;
				trigger("OriginalInputSelected", e.data);
			});

			// User presses esc key
			$(document).keyup(data, function (e) {
				if (e.keyCode == 27) { //Esc
					undelegateAllClicks(e.data.selectors);
					$(data.selectors.abort).click();
					userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				}
			});
		};

		this.showMissingInput = function (data) {
			if (!config.ui || !data.address.hasDomFields())
				return;

			var addr = data.address;
			var missing = data.address.missing;
			var response = data.response;
			var corners = addr.corners();
			corners.width = Math.max(corners.width, 300); // minimum width
			corners.height = Math.max(corners.height, 180); // minimum height
			if (config.enforceVerification) {
				corners.height -= 49;
			}

			var html = '<div class="smarty-ui" style="top: ' + corners.top + 'px; left: ' + corners.left + 'px; width: ' +
				corners.width + 'px; height: ' + corners.height + 'px;">' + '<div class="smarty-popup smarty-addr-' +
				addr.id() + '" style="width: ' + (corners.width - 6) + 'px; height: ' + (corners.height - 3) + 'px;">' +
				'<div class="smarty-popup-header smarty-popup-missing-input-header">' + config.missingInputMessage + missing +
				'<a href="javascript:" class="smarty-popup-close smarty-abort" title="Cancel">x</a></div>' +
				'<div class="smarty-choice-list"><a href="javascript:" ' +
				'class="smarty-choice smarty-choice-abort smarty-abort">' + config.changeMessage + '</a></div>' +
				'<div class="smarty-choice-alt">';
			if (!config.enforceVerification) {
				html += '<a href="javascript:" class="smarty-choice smarty-choice-override">' +
					config.certifyMessage + '<br>(' + addr.toString() + ')</a>';
			}
			html += '</div></div></div>';

			$(html).hide().appendTo('body').show(defaults.speed);

			data.selectors = {
				useOriginal: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-choice-override ',
				abort: '.smarty-popup.smarty-addr-' + addr.id() + ' .smarty-abort'
			};

			// Scroll to it if necessary
			if ($(document).scrollTop() > corners.top - 100 || $(document).scrollTop() < corners.top - $(window).height() + 100) {
				$('html, body').stop().animate({
					scrollTop: $('.smarty-popup.smarty-addr-' + addr.id()).offset().top - 100
				}, 500);
			}

			undelegateAllClicks(data.selectors.abort);
			// User rejects original input and agrees to double-check it
			$('body').delegate(data.selectors.abort, 'click', data, function (e) {
				userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				delete e.data.selectors;
				trigger("InvalidAddressRejected", e.data);
			});

			undelegateAllClicks(data.selectors.useOriginal);
			// User certifies that what they typed is correct
			$('body').delegate(data.selectors.useOriginal, 'click', data, function (e) {
				userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				delete e.data.selectors;
				trigger("OriginalInputSelected", e.data);
			});

			// User presses esc key
			$(document).keyup(data, function (e) {
				if (e.keyCode == 27) { //Esc
					undelegateAllClicks(e.data.selectors);
					$(data.selectors.abort).click();
					userAborted('.smarty-popup.smarty-addr-' + e.data.address.id(), e);
				}
			});
		};

	}

	var allStatesByName = {
		"ALABAMA": "AL",
		"ALASKA": "AK",
		"AMERICAN SAMOA": "AS",
		"ARIZONA": "AZ",
		"ARKANSAS": "AR",
		"CALIFORNIA": "CA",
		"COLORADO": "CO",
		"CONNECTICUT": "CT",
		"DELAWARE": "DE",
		"DISTRICT OF COLUMBIA": "DC",
		"FEDERATED STATES OF MICRONESIA": "FM",
		"FLORIDA": "FL",
		"GEORGIA": "GA",
		"GUAM": "GU",
		"HAWAII": "HI",
		"IDAHO": "ID",
		"ILLINOIS": "IL",
		"INDIANA": "IN",
		"IOWA": "IA",
		"KANSAS": "KS",
		"KENTUCKY": "KY",
		"LOUISIANA": "LA",
		"MAINE": "ME",
		"MARSHALL ISLANDS": "MH",
		"MARYLAND": "MD",
		"MASSACHUSETTS": "MA",
		"MICHIGAN": "MI",
		"MINNESOTA": "MN",
		"MISSISSIPPI": "MS",
		"MISSOURI": "MO",
		"MONTANA": "MT",
		"NEBRASKA": "NE",
		"NEVADA": "NV",
		"NEW HAMPSHIRE": "NH",
		"NEW JERSEY": "NJ",
		"NEW MEXICO": "NM",
		"NEW YORK": "NY",
		"NORTH CAROLINA": "NC",
		"NORTH DAKOTA": "ND",
		"NORTHERN MARIANA ISLANDS": "MP",
		"OHIO": "OH",
		"OKLAHOMA": "OK",
		"OREGON": "OR",
		"PALAU": "PW",
		"PENNSYLVANIA": "PA",
		"PUERTO RICO": "PR",
		"RHODE ISLAND": "RI",
		"SOUTH CAROLINA": "SC",
		"SOUTH DAKOTA": "SD",
		"TENNESSEE": "TN",
		"TEXAS": "TX",
		"UTAH": "UT",
		"VERMONT": "VT",
		"VIRGIN ISLANDS": "VI",
		"VIRGINIA": "VA",
		"WASHINGTON": "WA",
		"WEST VIRGINIA": "WV",
		"WISCONSIN": "WI",
		"WYOMING": "WY",
		"ARMED FORCES EUROPE, THE MIDDLE EAST, AND CANADA": "AE",
		"ARMED FORCES CANADA": "AE",
		"ARMED FORCES THE MIDDLE EAST": "AE",
		"ARMED FORCES EUROPE": "AE",
		"ARMED FORCES PACIFIC": "AP",
		"ARMED FORCES AMERICAS (EXCEPT CANADA)": "AA",
		"ARMED FORCES AMERICAS": "AA"
	};
	// this listing of stateNames has West Virginia before Virginia and the Virgin Islands (most specific to least specific)
	var stateNames = [
		"ALABAMA", "ALASKA", "AMERICAN SAMOA", "ARIZONA", "ARKANSAS", "CALIFORNIA", "COLORADO", "CONNECTICUT", "DELAWARE",
		"DISTRICT OF COLUMBIA", "FEDERATED STATES OF MICRONESIA", "FLORIDA", "GEORGIA", "GUAM", "HAWAII", "IDAHO",
		"ILLINOIS", "INDIANA", "IOWA", "KANSAS", "KENTUCKY", "LOUISIANA", "MAINE", "MARSHALL ISLANDS", "MARYLAND",
		"MASSACHUSETTS", "MICHIGAN", "MINNESOTA", "MISSISSIPPI", "MISSOURI", "MONTANA", "NEBRASKA", "NEVADA",
		"NEW HAMPSHIRE", "NEW JERSEY", "NEW MEXICO", "NEW YORK", "NORTH CAROLINA", "NORTH DAKOTA",
		"NORTHERN MARIANA ISLANDS", "OHIO", "OKLAHOMA", "OREGON", "PALAU", "PENNSYLVANIA", "PUERTO RICO", "RHODE ISLAND",
		"SOUTH CAROLINA", "SOUTH DAKOTA", "TENNESSEE", "TEXAS", "UTAH", "VERMONT", "WEST VIRGINIA", "VIRGINIA",
		"VIRGIN ISLANDS", "WASHINGTON", "WISCONSIN", "WYOMING", "ARMED FORCES EUROPE, THE MIDDLE EAST, AND CANADA",
		"ARMED FORCES CANADA", "ARMED FORCES THE MIDDLE EAST", "ARMED FORCES EUROPE", "ARMED FORCES PACIFIC",
		"ARMED FORCES AMERICAS (EXCEPT CANADA)", "ARMED FORCES AMERICAS"
	];
	var stateAbbreviations = [
		"AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA",
		"KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC",
		"ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV",
		"WI", "WY", "AE", "AP", "AA"
	];

	/*
	 Represents an address inputted by the user, whether it has been verified yet or not.
	 formObj must be a Form OBJECT, not a <form> tag... and the addressID is optional.
	 */
	function Address(domMap, formObj, addressID) {
		// PRIVATE MEMBERS //

		var self = this; // Pointer to self so that internal functions can reference its parent
		var fields; // Data values and references to DOM elements
		var id; // An ID by which to classify this address on the DOM

		var state = "accepted"; // Can be: "accepted" or "changed"
		// Example of a field:  street: { value: "123 main", dom: DOMElement, undo: "123 mai"}
		// Some of the above fields will only be mapped manually, not automatically.

		// Private method that actually changes the address. The keepState parameter is
		// used by the results of verification after an address is chosen; (or an "undo"
		// on a freeform address), otherwise an infinite loop of requests is executed
		// because the address keeps changing! (Set "suppressAutoVerify" to true when coming from the "Undo" link)
		var doSet = function (key, value, updateDomElement, keepState, sourceEvent, suppressAutoVerify) {
			if (!arrayContains(acceptableFields, key)) // Skip "id" and other unacceptable fields
				return false;

			if (!fields[key])
				fields[key] = {};

			if (typeof fields[key].dom !== "undefined" && fields[key].dom.tagName === "SELECT" && key !== "administrative_area") {
				value = fields[key].dom[fields[key].dom.selectedIndex].text.replace(/<|>/g, "");
			} else {
				value = value.replace(/<|>/g, ""); // prevents script injection attacks (< and > aren't in addresses, anyway)
			}

			var differentVal = fields[key].value != value;

			fields[key].undo = fields[key].value || "";
			fields[key].value = value;

			if (fields[key].dom && updateDomElement) {
				if (fields[key].dom.tagName === "INPUT") {
					$(fields[key].dom).val(value);
				} else if (fields[key].dom.tagName === "SELECT" && key === "administrative_area" && self.isDomestic()) {
					$(fields[key].dom).find("option").filter(function () {
						if ($(this).text().toUpperCase() === value) {
							return true;
						} else {
							for (state in allStatesByName) {
								if (allStatesByName[state] === value && state === $(this).text().toUpperCase()) {
									return true;
								}
							}
							return false;
						}
					}).attr('selected', true);
				}
			}

			var eventMeta = {
				sourceEvent: sourceEvent, // may be undefined
				field: key,
				address: self,
				value: value,
				suppressAutoVerification: suppressAutoVerify || false
			};

			if (differentVal && !keepState) {
				ui.unmarkAsValid(self);
				var uiTag = config.ui ? $('.smarty-ui .smarty-tag.smarty-addr-' + id) : undefined;
				if (config.target.indexOf("US") >= 0 && config.target.indexOf("INTERNATIONAL") < 0) {
					if (self.isDomestic()) {
						if (uiTag && !uiTag.is(':visible'))
							uiTag.show(); // Show checkmark tag if address is in US
						self.unaccept();
						trigger("AddressChanged", eventMeta);
					} else {
						if (uiTag && uiTag.is(':visible'))
							uiTag.hide(); // Hide checkmark tag if address is non-US
						self.accept({
							address: self
						}, false);
					}
				} else if (config.target.indexOf("INTERNATIONAL") >= 0 && config.target.indexOf("US") < 0) {
					if (uiTag && !uiTag.is(':visible'))
						uiTag.show(); // Show checkmark tag if address is in US
					self.unaccept();
					trigger("AddressChanged", eventMeta);
				} else if (config.target.indexOf("US") >= 0 && config.target.indexOf("INTERNATIONAL") >= 0) {
					if (uiTag && !uiTag.is(':visible'))
						uiTag.show(); // Show checkmark tag if address is in US
					self.unaccept();
					trigger("AddressChanged", eventMeta);
				}
			}

			return true;
		};

		// PUBLIC MEMBERS //

		this.form = formObj; // Reference to the parent form object (NOT THE DOM ELEMENT)
		this.verifyCount = 0; // Number of times this address was submitted for verification
		this.lastField; // The last field found (last to appear in the DOM) during mapping, or the order given
		this.active = true; // If true, verify the address. If false, pass-thru entirely.
		this.lastStreetInput = ""; // Used by autocomplete to detect changes

		// Constructor-esque functionality (save the fields in this address object)
		this.load = function (domMap, addressID) {
			fields = {};
			id = addressID ? addressID.replace(/[^a-z0-9_\-]/ig, '') : randomInt(1, 99999); // Strips non-selector-friendly characters

			if (typeof domMap === 'object') { // can be an actual map to DOM elements or just field/value data
				// Find the last field likely to appear on the DOM (used for UI attachments)
				this.lastField = domMap[Object.keys(domMap)[Object.keys(domMap).length - 1]];

				var isEmpty = true; // Whether the address has data in it (pre-populated) -- first assume it is empty.

				for (var prop in domMap) {
					if (!arrayContains(acceptableFields, prop)) // Skip "id" and any other unacceptable field
						continue;

					if (typeof domMap[prop] == "object" && domMap[prop].getBoundingClientRect().top > this.lastField.getBoundingClientRect().top) {
						this.lastField = domMap[prop];
					}

					var elem, val, elemArray, isData;
					try {
						elem = $(domMap[prop]);
						elemArray = elem.toArray();
						isData = elemArray ? elemArray.length == 0 : false;
					} catch (e) {
						isData = true;
					}

					if (isData) // Didn't match an HTML element, so treat it as an address string ("street1" data) instead
						val = domMap[prop] || "";
					else
						val = elem.val() || "";

					fields[prop] = {};
					fields[prop].value = val;
					fields[prop].undo = val;

					if (!isData) {
						if (config.debug) {
							elem.css('background', '#FFFFCC');
							elem.attr('placeholder', prop + ":" + id);
						}
						fields[prop].dom = domMap[prop];
					}

					// This has to be passed in at bind-time; they cannot be obtained at run-time
					var data = {
						address: this,
						field: prop,
						value: val
					};

					// Bind the DOM element to needed events, passing in the data above
					// NOTE: When the user types a street, city, and state, then hits Enter without leaving
					// the state field, this change() event fires before the form is submitted, and if autoVerify is
					// on, the verification will not invoke form submit, because it didn't come from a form submit.
					// This is known behavior and is actually proper functioning in this uncommon edge case.
					!isData && $(domMap[prop]).change(data, function (e) {
						e.data.address.set(e.data.field, e.target.value, false, false, e, false);
					});
				}

				state = "changed";
			}
		};

		// Run the "constructor" to load up the address
		this.load(domMap, addressID);

		this.set = function (key, value, updateDomElement, keepState, sourceEvent, suppressAutoVerify) {
			if (typeof key === 'string' && arguments.length >= 2)
				return doSet(key, value, updateDomElement, keepState, sourceEvent, suppressAutoVerify);
			else if (typeof key === 'object') {
				var successful = true;
				for (var prop in key)
					successful = doSet(prop, key[prop], updateDomElement, keepState, sourceEvent, suppressAutoVerify) ? successful : false;
				return successful;
			}
		};

		this.replaceWith = function (resp, updateDomElement, e) {
			// Given the response from an API request associated with this address,
			// replace the values in the address... and if updateDomElement is true,
			// then change the values in the fields on the page accordingly.

			if (typeof resp === 'array' && resp.length > 0)
				resp = resp[0];

			// Sent via US api
			if (typeof resp.candidate_index != 'undefined') {
				if (self.isFreeform()) {
					var singleLineAddr = (resp.addressee ? resp.addressee + ", " : "") +
						(resp.delivery_line_1 ? resp.delivery_line_1 + ", " : "") +
						(resp.delivery_line_2 ? resp.delivery_line_2 + ", " : "") +
						(resp.components.urbanization ? resp.components.urbanization + ", " : "") +
						(resp.last_line ? resp.last_line : "");
					var fieldKey = "freeform";
					if (fields.address1) {
						fieldKey = "address1";
					}
					self.set(fieldKey, singleLineAddr, updateDomElement, true, e, false);
				} else {
					if (resp.addressee)
						self.set("organization", resp.addressee, updateDomElement, true, e, false);
					if (resp.delivery_line_1)
						self.set("address1", resp.delivery_line_1, updateDomElement, true, e, false);
					if (resp.delivery_line_2)
						self.set("address2", resp.delivery_line_2, updateDomElement, true, e, false); // Rarely used; must otherwise be blank.
					else
						self.set("address2", "", updateDomElement, true, e, false);
					if (resp.components.city_name)
						self.set("locality", resp.components.city_name, updateDomElement, true, e, false);
					if (resp.components.state_abbreviation)
						self.set("administrative_area", resp.components.state_abbreviation, updateDomElement, true, e, false);
					if (resp.components.zipcode && resp.components.plus4_code)
						self.set("postal_code", resp.components.zipcode + "-" + resp.components.plus4_code, updateDomElement, true, e, false);
				}
				self.set("address3", "", updateDomElement, true, e, false);
				self.set("address4", "", updateDomElement, true, e, false);
				self.set("country", "USA", updateDomElement, true, e, false);
			} else { // Sent via international API
				if (self.isFreeform()) {
					var singleLineAddr = (resp.organization ? resp.organization + ", " : "") +
						(resp.address1 ? resp.address1 : "") +
						(resp.address2 ? ", " + resp.address2 : "") +
						(resp.address3 ? ", " + resp.address3 : "") +
						(resp.address4 ? ", " + resp.address4 : "") +
						(resp.address5 ? ", " + resp.address5 : "") +
						(resp.address6 ? ", " + resp.address6 : "") +
						(resp.address7 ? ", " + resp.address7 : "") +
						(resp.address8 ? ", " + resp.address8 : "") +
						(resp.address9 ? ", " + resp.address9 : "") +
						(resp.address10 ? ", " + resp.address10 : "") +
						(resp.address11 ? ", " + resp.address11 : "") +
						(resp.address12 ? ", " + resp.address12 : "");
					var countryLine = resp.components.country_iso_3 ? resp.components.country_iso_3 : "";
					self.set("freeform", singleLineAddr, updateDomElement, true, e, false);
					self.set("country", countryLine, updateDomElement, true, e, false);
				} else {
					if (resp.organization)
						self.set("organization", resp.organization, updateDomElement, true, e, false);
					if (resp.components.locality)
						self.set("locality", resp.components.locality, updateDomElement, true, e, false);
					if (resp.components.administrative_area)
						self.set("administrative_area", resp.components.administrative_area, updateDomElement, true, e, false);
					if (resp.components.postal_code_short) {
						var fullPostalCode = resp.components.postal_code_short;
						if (resp.components.postal_code_extra)
							fullPostalCode = fullPostalCode + "-" + resp.components.postal_code_extra;
						self.set("postal_code", fullPostalCode, updateDomElement, true, e, false);
					}
					if (this.getDomFields().address4) {
						if (resp.address1)
							self.set("address1", resp.address1, updateDomElement, true, e, false);
						if (resp.address2)
							self.set("address2", resp.address2, updateDomElement, true, e, false);
						if (resp.address3)
							self.set("address3", resp.address3, updateDomElement, true, e, false);
						var addressLine4 = "";
						addressLine4 = addAddressLine(addressLine4, resp.address4, resp.address5);
						addressLine4 = addAddressLine(addressLine4, resp.address5, resp.address6);
						addressLine4 = addAddressLine(addressLine4, resp.address6, resp.address7);
						addressLine4 = addAddressLine(addressLine4, resp.address7, resp.address8);
						addressLine4 = addAddressLine(addressLine4, resp.address8, resp.address9);
						addressLine4 = addAddressLine(addressLine4, resp.address9, resp.address10);
						addressLine4 = addAddressLine(addressLine4, resp.address10, resp.address11);
						addressLine4 = addAddressLine(addressLine4, resp.address11, resp.address12);
						self.set("address4", addressLine4, updateDomElement, true, e, false);
					} else if (this.getDomFields().address3) {
						if (resp.address1)
							self.set("address1", resp.address1, updateDomElement, true, e, false);
						if (resp.address2)
							self.set("address2", resp.address2, updateDomElement, true, e, false);
						var addressLine3 = "";
						addressLine3 = addAddressLine(addressLine3, resp.address3, resp.address4);
						addressLine3 = addAddressLine(addressLine3, resp.address4, resp.address5);
						addressLine3 = addAddressLine(addressLine3, resp.address5, resp.address6);
						addressLine3 = addAddressLine(addressLine3, resp.address6, resp.address7);
						addressLine3 = addAddressLine(addressLine3, resp.address7, resp.address8);
						addressLine3 = addAddressLine(addressLine3, resp.address8, resp.address9);
						addressLine3 = addAddressLine(addressLine3, resp.address9, resp.address10);
						addressLine3 = addAddressLine(addressLine3, resp.address10, resp.address11);
						addressLine3 = addAddressLine(addressLine3, resp.address11, resp.address12);
						self.set("address3", addressLine3, updateDomElement, true, e, false);
					} else if (this.getDomFields().address2) {
						if (resp.address1)
							self.set("address1", resp.address1, updateDomElement, true, e, false);
						var addressLine2 = "";
						addressLine2 = addAddressLine(addressLine2, resp.address2, resp.address3);
						addressLine2 = addAddressLine(addressLine2, resp.address3, resp.address4);
						addressLine2 = addAddressLine(addressLine2, resp.address4, resp.address5);
						addressLine2 = addAddressLine(addressLine2, resp.address5, resp.address6);
						addressLine2 = addAddressLine(addressLine2, resp.address6, resp.address7);
						addressLine2 = addAddressLine(addressLine2, resp.address7, resp.address8);
						addressLine2 = addAddressLine(addressLine2, resp.address8, resp.address9);
						addressLine2 = addAddressLine(addressLine2, resp.address9, resp.address10);
						addressLine2 = addAddressLine(addressLine2, resp.address10, resp.address11);
						addressLine2 = addAddressLine(addressLine2, resp.address11, resp.address12);
						self.set("address2", addressLine2, updateDomElement, true, e, false);
					} else if (this.getDomFields().address1) {
						var addressLine1 = "";
						addressLine1 = addAddressLine(addressLine1, resp.address1, resp.address2);
						addressLine1 = addAddressLine(addressLine1, resp.address2, resp.address3);
						addressLine1 = addAddressLine(addressLine1, resp.address3, resp.address4);
						addressLine1 = addAddressLine(addressLine1, resp.address4, resp.address5);
						addressLine1 = addAddressLine(addressLine1, resp.address5, resp.address6);
						addressLine1 = addAddressLine(addressLine1, resp.address6, resp.address7);
						addressLine1 = addAddressLine(addressLine1, resp.address7, resp.address8);
						addressLine1 = addAddressLine(addressLine1, resp.address8, resp.address9);
						addressLine1 = addAddressLine(addressLine1, resp.address9, resp.address10);
						addressLine1 = addAddressLine(addressLine1, resp.address10, resp.address11);
						addressLine1 = addAddressLine(addressLine1, resp.address11, resp.address12);
						self.set("address1", addressLine1, updateDomElement, true, e, false);
					}
					if (resp.components.country_iso_3)
						self.set("country", resp.components.country_iso_3, updateDomElement, true, e, false);
				}
			}
		};

		var addAddressLine = function (fullLine, addressLine, nextAddressLine) {
			if (addressLine && nextAddressLine) {
				if (fullLine != "")
					fullLine += ", ";
				fullLine += addressLine;
			}
			return fullLine;
		};

		this.corners = function (lastField) {
			var corners = {};

			if (!lastField) {
				for (var prop in fields) {
					if (!fields[prop].dom || !$(fields[prop].dom).is(':visible'))
						continue;

					var dom = fields[prop].dom;
					var offset = $(dom).offset();
					offset.right = offset.left + $(dom).outerWidth(false);
					offset.bottom = offset.top + $(dom).outerHeight(false);

					corners.top = !corners.top ? offset.top : Math.min(corners.top, offset.top);
					corners.left = !corners.left ? offset.left : Math.min(corners.left, offset.left);
					corners.right = !corners.right ? offset.right : Math.max(corners.right, offset.right);
					corners.bottom = !corners.bottom ? offset.bottom : Math.max(corners.bottom, offset.bottom);
				}
			} else {
				var jqDom = $(self.lastField);
				corners = jqDom.offset();
				corners.right = corners.left + jqDom.outerWidth(false);
				corners.bottom = corners.top + jqDom.outerHeight(false);
			}

			corners.width = corners.right - corners.left;
			corners.height = corners.bottom - corners.top;

			return corners;
		};

		this.verify = function (invoke, invokeFn) {
			// Invoke contains the element to "click" on once we're all done, or is a user-defined callback function (may also be undefined)
			if (!self.enoughInput()) {
				return trigger("AddressWasMissingInput", {
					address: self,
					invoke: invoke,
					invokeFn: invokeFn,
					response: new Response([])
				});
			}

			ui.disableFields(self);
			self.verifyCount++;
			var addrData = self.toRequestIntl();
			var credentials = config.token ? "auth-id=" + encodeURIComponent(config.key) + "&auth-token=" +
			encodeURIComponent(config.token) : "auth-id=" + encodeURIComponent(config.key);
			var requestUrl = config.requestUrlInternational;
			var headers = {};
			if (self.isDomestic() && config.target.indexOf("US") >= 0) {
				requestUrl = config.requestUrlUS;
				addrData = self.toRequestUS();
				headers = {
					"X-Include-Invalid": config.xIncludeInvalid
				};
			}

			var iso = self.countryISO();
			if (typeof iso === "undefined") {
				return trigger("CountryWasInvalid", {
					address: self,
					response: new Response([]),
					invoke: invoke,
					invokeFn: invokeFn
				});
			} else {
				addrData.country = iso;
			}

			$.ajax({
					url: requestUrl + "?" + credentials +
					"&agent=" + encodeURIComponent("plugin:jquery@" + instance.version + "\|" + config.agent) +
					(config.debug ? "_debug" : ""),
					contentType: "jsonp",
					headers: headers,
					data: addrData,
					timeout: config.timeout
				})
				.done(function (response, statusText, xhr) {
					trigger("ResponseReceived", {
						address: self,
						response: new Response(response),
						invoke: invoke,
						invokeFn: invokeFn
					});
				})
				.fail(function (xhr, statusText) {
					trigger("RequestTimedOut", {
						address: self,
						status: statusText,
						invoke: invoke,
						invokeFn: invokeFn
					});
					self.verifyCount--; // Address verification didn't actually work, so don't count it
				});

			// Remember, the above callbacks happen later and this function is
			// executed immediately afterward, probably before a response is received.
			trigger("RequestSubmitted", {
				address: self
			});
		};

		this.enoughInput = function () {
			// Checks for state dropdown
			var stateText;
			if (fields.administrative_area) {
				stateText = fields.administrative_area.value;
				if (fields.administrative_area.dom !== undefined && fields.administrative_area.dom.length !== undefined) {
					if (fields.administrative_area.dom.selectedIndex < 1)
						stateText = "";
					else
						stateText = fields.administrative_area.dom.options[fields.administrative_area.dom.selectedIndex].text;
				}
			}

			self.missing = "(Missing ";
			var baseLength = self.missing.length;
			if (fields.country && !fields.country.value) {
				if (self.missing.length > baseLength)
					self.missing += ", ";
				self.missing += "country";
			}
			if (fields.freeform && !fields.freeform.value) {
				if (self.missing.length > baseLength)
					self.missing += ", ";
				self.missing += "freeform";
			}
			if (fields.address1 && !fields.address1.value) {
				if (self.missing.length > baseLength)
					self.missing += ", ";
				self.missing += "address1";
			}
			if (fields.postal_code && fields.locality && fields.administrative_area && !fields.postal_code.value && !fields.locality.value && !(stateText.length > 0)) {
				if (self.missing.length > baseLength)
					self.missing += ", ";
				self.missing += "postal code or locality and administrative area";
			} else if (fields.postal_code && fields.locality && fields.administrative_area && !fields.postal_code.value && fields.locality.value && !(stateText.length > 0)) {
				if (self.missing.length > baseLength)
					self.missing += ", ";
				self.missing += "postal code or administrative area";
			} else if (fields.postal_code && fields.locality && fields.administrative_area && !fields.postal_code.value && !fields.locality.value && stateText.length > 0) {
				if (self.missing.length > baseLength)
					self.missing += ", ";
				self.missing += "postal code or locality";
			} else if (fields.postal_code && !fields.locality && !fields.administrative_area && !fields.postal_code.value) {
				if (self.missing.length > baseLength)
					self.missing += ", ";
				self.missing += "postal code";
			} else if (!fields.postal_code && fields.locality && fields.administrative_area && (!fields.locality.value || !(stateText.length > 0))) {
				if (self.missing.length > baseLength)
					self.missing += ", ";
				self.missing += "locality and administrative area";
			}
			self.missing += ")";
			return (self.missing.length === baseLength + 1);
		};

		this.toRequestIntl = function () {
			var obj = {};
			if (fields.hasOwnProperty("freeform") &&
				fields.hasOwnProperty("address1") &&
				fields.hasOwnProperty("locality") &&
				fields.hasOwnProperty("administrative_area") &&
				fields.hasOwnProperty("postal_code")) {
				delete fields.address1;
				delete fields.locality;
				delete fields.administrative_area;
				delete fields.postal_code;
			}
			for (var key in fields) {
				var keyval = {};
				if (fields[key].dom && fields[key].dom.tagName === "SELECT") {
					keyval[key] = fields[key].dom[fields[key].dom.selectedIndex].text;
				} else {
					keyval[key] = fields[key].value.replace(/\r|\n/g, " "); // Line breaks to spaces
				}
				$.extend(obj, keyval);
			}
			obj.geocode = config.geocode;
			return obj;
		};

		this.toRequestUS = function () {
			var obj = {};
			if (fields.address1 && fields.address1.dom && fields.address1.dom.value) {
				obj.street = fields.address1.dom.value;
			} else if(fields.address1 && fields.address1.value) { // Covers a special case where the user calls .verify on the instance
				obj.street = fields.address1.value;
			}
			if (fields.address2 && fields.address2.dom && fields.address2.dom.value) {
				obj.street2 = fields.address2.dom.value;
			}
			if (fields.address3 && fields.address3.dom && fields.address3.dom.value) {
				if (typeof obj.street2 === 'undefined') {
					obj.street2 = fields.address3.dom.value;
				} else {
					obj.street2 = obj.street2 += ", " + fields.address3.dom.value;
				}
			}
			if (fields.address4 && fields.address4.dom && fields.address4.dom.value) {
				if (typeof obj.street2 === 'undefined') {
					obj.street2 = fields.address4.dom.value;
				} else {
					obj.street2 = obj.street2 += ", " + fields.address4.dom.value;
				}
			}
			if (fields.locality && fields.locality.dom) {
				if (fields.locality.dom.tagName === "SELECT") {
					obj.city = fields.locality.dom[fields.locality.dom.selectedIndex].text;
				} else {
					obj.city = fields.locality.dom.value;
				}
			}
			if (fields.administrative_area && fields.administrative_area.dom.value) {
				if (fields.administrative_area.dom.tagName === "SELECT") {
					obj.state = fields.administrative_area.dom[fields.administrative_area.dom.selectedIndex].text;
				} else {
					obj.state = fields.administrative_area.dom.value;
				}
			}
			if (fields.postal_code && fields.postal_code.dom.value) {
				obj.zipcode = fields.postal_code.dom.value;
			}
			if (fields.freeform && fields.freeform.dom.value) {
				obj.street = fields.freeform.dom.value;
			}
			obj.candidates = config.candidates;
			return obj;
		};

		this.toString = function () {
			if (fields.freeform) {
				return (fields.freeform ? fields.freeform.value + " " : "") + (fields.country ? fields.country.value : "");
			} else {
				var addrString = (fields.address1 ? fields.address1.value + " " : "") + (fields.address2 ? fields.address2.value + " " : "") +
				(fields.address3 ? fields.address3.value + " " : "") + (fields.address4 ? fields.address4.value + " " : "") +
				(fields.locality ? fields.locality.value + " " : "");
				if (fields.administrative_area) {
					if (fields.administrative_area.dom && fields.administrative_area.dom.tagName === "SELECT") {
						addrString += fields.administrative_area.dom[fields.administrative_area.dom.selectedIndex].text + " ";
					} else {
						addrString  += fields.administrative_area.dom.value + " ";
					}
				}
				addrString += (fields.postal_code ? fields.postal_code.value + " " : "") + (fields.country ? fields.country.value : "");
				return addrString;
			}
		};

		this.abort = function (event, keepAccept) {
			keepAccept = typeof keepAccept === 'undefined' ? false : keepAccept;
			if (!keepAccept)
				self.unaccept();
			delete self.form.processing;
			return suppress(event);
		};

		// Based on the properties in "fields," determines if this is a single-line address
		this.isFreeform = function () {
			return fields.freeform;
		};

		this.get = function (key) {
			return fields[key] ? fields[key].value : null
		};

		this.undo = function (updateDomElement) {
			updateDomElement = typeof updateDomElement === 'undefined' ? true : updateDomElement;
			for (var key in fields)
				this.set(key, fields[key].undo, updateDomElement, false, undefined, true);
		};

		this.accept = function (data, showValid) {
			showValid = typeof showValid === 'undefined' ? true : showValid;
			state = "accepted";
			ui.enableFields(self);
			if (showValid) // If user chooses original input or the request timed out, the address wasn't "verified"
				ui.markAsValid(self);
			trigger("AddressAccepted", data);
		};

		this.unaccept = function () {
			state = "changed";
			ui.unmarkAsValid(self);
			return self;
		};

		this.getUndoValue = function (key) {
			return fields[key].undo;
		};

		this.status = function () {
			return state;
		};

		this.getDomFields = function () {
			// Gets just the DOM elements for each field
			var obj = {};
			for (var prop in fields) {
				var ext = {};
				ext[prop] = fields[prop].dom;
				$.extend(obj, ext);
			}
			return obj;
		};

		this.hasDomFields = function () {
			for (var prop in fields)
				if (fields[prop].dom)
					return true;
		};

		this.isDomestic = function () {
			var countryValue = "";
			if (fields.country && fields.country.dom) {
				countryValue = fields.country.dom.value;
				if (fields.country.dom.selectedOptions)
					countryValue = fields.country.dom.selectedOptions[0].text;
			}
			countryValue = countryValue.toUpperCase().replace(/\.|\s|\(|\)|\\|\/|-/g, "");
			var usa = ["", "0", "1", "US", "USA", "USOFA", "USOFAMERICA", "AMERICAN", // 1 is AmeriCommerce
				"UNITEDSTATES", "UNITEDSTATESAMERICA", "UNITEDSTATESOFAMERICA", "AMERICA",
				"840", "223", "AMERICAUNITEDSTATES", "AMERICAUS", "AMERICAUSA", "UNITEDSTATESUS",
				"AMERICANSAMOA", "AMERIKASĀMOA", "AMERIKASAMOA", "ASM",
				"MICRONESIA", "FEDERALSTATESOFMICRONESIA", "FEDERATEDSTATESOFMICRONESIA", "FSM",
				"GUAM", "GM",
				"MARSHALLISLANDS", "MHL",
				"NORTHERNMARIANAISLANDS", "NMP",
				"PALAU", "REPUBLICOFPALAU", "BELAU", "PLW",
				"PUERTORICO", "COMMONWEALTHOFPUERTORICO", "PRI",
				"UNITEDSTATESVIRGINISLANDS", "VIR"
			]; // 840 is ISO: 3166; and 223 is some shopping carts
			return arrayContains(usa, countryValue) || fields.country.value == "-1";
		};

		this.countryISO = function () {
			if (config.target.indexOf("INTERNATIONAL") >= 0) {
				var countryValue = fields.country.dom.value;
				if (fields.country.dom.selectedOptions)
					countryValue = fields.country.dom.selectedOptions[0].text;
				countryValue = countryValue.toUpperCase().replace(/\.|\s|\(|\)|\\|\/|-|\'|\"|\,|ʻ|\&/g, "");
				var validCountries = {
					"AFGHANISTAN": "AFG",
					"AFGHANESTAN": "AFG",
					"ISLAMICREPUBLICOFAFGHANISTAN": "AFG",
					"AFG": "AFG",

					"ÅLANDISLANDS": "ALA",
					"ALANDISLANDS": "ALA",
					"AALAND": "ALA",
					"ALAND": "ALA",
					"ALA": "ALA",

					"ALBANIA": "ALB",
					"REPUBLICOFALBANIA": "ALB",
					"REPUBLIKAESHQIPËRISË": "ALB",
					"REPUBLIKAESHQIPERISE": "ALB",
					"SHQIPËRIA": "ALB",
					"SHQIPERIA": "ALB",
					"ALB": "ALB",

					"ALGERIA": "DZA",
					"PEOPLESDEMOCRATICREPUBLICOFALGERIA": "DZA",
					"ALJAZAIR": "DZA",
					"DZAYER": "DZA",
					"DZA": "DZA",

					"AMERICANSAMOA": "ASM",
					"AMERIKASĀMOA": "ASM",
					"AMERIKASAMOA": "ASM",
					"ASM": "ASM",

					"ANDORRA": "AND",
					"AND": "AND",

					"ANGOLA": "AGO",
					"AGO": "AGO",

					"ANGUILLA": "AIA",
					"AIA": "AIA",

					"ANTARCTICA": "ATA",
					"ATA": "ATA",

					"ANTIGUABARBUDA": "ATG",
					"ANTIQUA": "ATG",
					"BARBUDA": "ATG",
					"ANTIQUAANDBARBUDA": "ATG",
					"ATG": "ATG",

					"ARGENTINA": "ARG",
					"ARGENTINEREPUBLIC": "ARG",
					"LAARGENTINA": "ARG",
					"ARG": "ARG",

					"ARMENIA": "ARM",
					"HAYASTAN": "ARM",
					"HAYASDAN": "ARM",
					"HAÏASDAN": "ARM",
					"HAIASDAN": "ARM",
					"REPUBLICOFARMENIA": "ARM",
					"ARM": "ARM",

					"ARUBA": "ABW",
					"ABW": "ABW",

					"AUSTRALIA": "AUS",
					"COMMONWEALTHOFAUSTRALIA": "AUS",
					"AUS": "AUS",

					"AUSTRIA": "AUT",
					"OSTERREICH": "AUT",
					"OESTERREICH": "AUT",
					"ÖSTERREICH": "AUT",
					"REPUBLICOFAUSTRIA": "AUT",
					"AUT": "AUT",

					"AZERBAIJAN": "AZE",
					"REPUBLICOFAZERBAIJAN": "AZE",
					"AZƏRBAYCANRESPUBLIKASI": "AZE",
					"AZERBAIJANREPUBLIC": "AZE",
					"AZARBAYCAN": "AZE",
					"AZƏRBAYCAN": "AZE",
					"AZERBAYCAN": "AZE",
					"AZE": "AZE",

					"BAHAMAS": "BHS",
					"BHS": "BHS",

					"BAHRAIN": "BHR",
					"KINGDOMOFBAHRAIN": "BHR",
					"MAMLAKATALBAḤRAYN": "BHR",
					"MAMLAKATALBAHRAYN": "BHR",
					"ALBAḤRAYN": "BHR",
					"BHR": "BHR",

					"BANGLADESH": "BGD",
					"PEOPLESREPUBLICOFBANGLADESH": "BGD",
					"BGD": "BGD",

					"BARBADOS": "BRB",
					"BRB": "BRB",

					"BELARUS": "BLR",
					"REPUBLICOFBELARUS": "BLR",
					"GUDIJA": "BLR",
					"BYELARUS": "BLR",
					"BIELARUŚ": "BLR",
					"BIELARUS": "BLR",
					"BLR": "BLR",

					"BELGIUM": "BEL",
					"BELGIQUE": "BEL",
					"BELGIEN": "BEL",
					"BELGIE": "BEL",
					"BELGIË": "BEL",
					"BEL": "BEL",

					"BELIZE": "BLZ",
					"BLZ": "BLZ",

					"BENIN": "BEN",
					"REPUBLICOFBENIN": "BEN",
					"RÉPUBLIQUEDUBÉNIN": "BEN",
					"REPUBLIQUEDEBENIN": "BEN",
					"BÉNIN": "BEN",
					"BEN": "BEN",

					"BERMUDA": "BMU",
					"BMU": "BMU",

					"BHUTAN": "BTN",
					"DRUKYUL": "BTN",
					"BTN": "BTN",

					"BOLIVIA": "BOL",
					"BULIWYA": "BOL",
					"WULIWYA": "BOL",
					"VOLÍVIA": "BOL",
					"VOLIVIA": "BOL",
					"BOL": "BOL",

					"BONAIRESINTEUSTATIUSANDSABA": "BES",
					"BONAIRESINTEUSTATIUSSABA": "BES",
					"BONAIRE": "BES",
					"SINTEUSTATIUS": "BES",
					"SABA": "BES",
					"SINTEUSTATIUSANDSABA": "BES",
					"BES": "BES",

					"BOSNIAHERZEGOVINA": "BIH",
					"BOSNIA": "BIH",
					"HERZEGOVINA": "BIH",
					"BOSNAIHERCEGOVINA": "BIH",
					"BIH": "BIH",

					"BOTSWANA": "BWA",
					"REPUBLICOFBOTSWANA": "BWA",
					"BWA": "BWA",

					"BRAZIL": "BRA",
					"FEDERATIVEREPUBLICOFBRAZIL": "BRA",
					"BRASIL": "BRA",
					"BRA": "BRA",

					"BRITISHINDIANOCEANTERRITORY": "IOT",
					"IOT": "IOT",

					"BRITISHVIRGINISLANDS": "VGV",
					"VGV": "VGV",

					"BRUNEIDARUSSALAM": "BRN",
					"NEGARABRUNEIDARUSSALAM": "BRN",
					"BRN": "BRN",

					"BULGARIA": "BGR",
					"BULGARIYA": "BGR",
					"BĂLGARIJA": "BGR",
					"BALGARIJA": "BGR",
					"BGR": "BGR",

					"BURKINAFASO": "BFA",
					"BFA": "BFA",

					"BURUNDI": "BDI",
					"BDI": "BDI",

					"CAMBODIA": "KHM",
					"KINGDOMOFCAMBODIA": "KHM",
					"ROYAUMEDUCAMBODGE": "KHM",
					"KAMPUCHEA": "KHM",
					"KHM": "KHM",

					"CAMEROON": "CMR",
					"CAMEROUN": "CMR",
					"CMR": "CMR",

					"CANADA": "CAN",
					"CAN": "CAN",

					"CAPEVERDEISLANDS": "CPV",
					"CAPEVERDE": "CPV",
					"CABOVERDE": "CPV",
					"CPV": "CPV",

					"CAYMANISLANDS": "CYM",
					"CYM": "CYM",

					"CENTRALAFRICANREPUBLIC": "CAF",
					"UBANGISHARI": "CAF",
					"RÉPUBLIQUECENTRAFRICAINE": "CAF",
					"REPUBLIQUECENTRAFRICAINE": "CAF",
					"CENTRALAFRICANEMPIRE": "CAF",
					"KÖDÖRÖSÊSETÎBÊAFRÎKA": "CAF",
					"KODOROSESETIBEAFRIKA": "CAF",
					"CAF": "CAF",

					"CHAD": "TCD",
					"TCHAD": "TCD",
					"TŠĀD": "TCD",
					"TSAD": "TCD",
					"TCD": "TCD",

					"CHILE": "CHL",
					"CHL": "CHL",

					"CHINA": "CHN",
					"PEOPLESREPUBLICOFCHINA": "CHN",
					"ZHONGHUAPEOPLESREPUBLIC": "CHN",
					"ZHONGGUO": "CHN",
					"ZHONGHUA": "CHN",
					"ZHŌNGGUÓ": "CHN",
					"CHN": "CHN",

					"CHRISTMASISLAND": "CXR",
					"CXR": "CXR",

					"COCOSKEELINGISLANDS": "CCK",
					"COCOSISALNDS": "CCK",
					"COCOSISLAND": "CCK",
					"KEELINGISLANDS": "CCK",
					"KEELINGSISLAND": "CCK",
					"CCK": "CCK",

					"COLOMBIA": "COL",
					"COLÓMBIA": "COL",
					"COL": "COL",

					"COMOROS": "COM",
					"COMORES": "COM",
					"KOMORI": "COM",
					"JUZURALQAMAR": "COM",
					"COM": "COM",

					"CONGO": "COD",
					"RÉPUBLIQUEDÉMOCRATIQUEDUCONGO": "COD",
					"REPUBLIQUEDEMOCRATIQUEDUCONGO": "COD",
					"THEDEMOCRATICREPUBLICOFCONGO": "COD",
					"THEDEMOCRATICREPUBLICOFTHECONGO": "COD",
					"REPUBLICOFCONGO": "COD",
					"REPUBLICOFTHECONGO": "COD",
					"RÉPUBLIQUEDUCONGO": "COD",
					"REPUBLIQUEDUCONGO": "COD",
					"COD": "COD",

					"COOKISLANDS": "COK",
					"COK": "COK",

					"COSTARICA": "CRI",
					"CRI": "CRI",

					"CROATIA": "HRV",
					"HRVATSKA": "HRV",
					"HRVAŠKA": "HRV",
					"HRVASKA": "HRV",
					"HRV": "HRV",

					"CUBA": "CUB",
					"CUB": "CUB",

					"CURACAO": "CUW",
					"CUW": "CUW",

					"CYPRUS": "CYP",
					"REPUBLICOFCYPRUS": "CYP",
					"ΚΎΠΡΟΣ": "CYP",
					"KIBRIS": "CYP",
					"CYP": "CYP",

					"CZECHREPUBLIC": "CZE",
					"ČESKÁREPUBLIKA": "CZE",
					"CESKAREPUBLIKA": "CZE",
					"ČESKO": "CZE",
					"CESKO": "CZE",
					"CZE": "CZE",

					"DENMARK": "DNK",
					"KINGDOMOFDENMARK": "DNK",
					"KONGERIGETDANMARK": "DNK",
					"DANMARK": "DNK",
					"DNK": "DNK",

					"DJIBOUTI": "DGI",
					"REPUBLICOFDJIBOUTI": "DGI",
					"RÉPUBLIQUEDEDJIBOUTI": "DGI",
					"REPUBLIQUEDEDJIBOUTI": "DGI",
					"DGI": "DGI",

					"DOMINICA": "DMA",
					"DMA": "DMA",

					"DOMINICANREPUBLIC": "DOM",
					"REPÚBLICADOMINICANA": "DOM",
					"REPUBLICADOMINICANA": "DOM",
					"DOM": "DOM",

					"ECUADOR": "ECU",
					"ECU": "ECU",

					"EGYPT": "EGY",
					"ARABREPUBLICOFEGYPT": "EGY",
					"MIṢR": "EGY",
					"MISR": "EGY",
					"MEṢR": "EGY",
					"MESR": "EGY",
					"KĪMI": "EGY",
					"KIMI": "EGY",
					"EGY": "EGY",

					"ELSALVADOR": "SLV",
					"SLV": "SLV",

					"EQUITORIALGUINEA": "GNQ",
					"GUINEAECUATORIAL": "GNQ",
					"GNQ": "GNQ",

					"ERITREA": "ERI",
					"HAGEREERTRA": "ERI",
					"ERI": "ERI",

					"ESTONIA": "EST",
					"EESTI": "EST",
					"EESTIVABARIIK": "EST",
					"ESTLAND": "EST",
					"IGAUNIJA": "EST",
					"VIRO": "EST",
					"EST": "EST",

					"ETHIOPIA": "ETH",
					"FEDERALDEMOCRATICREPUBLICOFETHIOPIA": "ETH",
					"ITYOPIYA": "ETH",
					"ETH": "ETH",

					"FALKLANDISLANDS": "FLK",
					"ISLASMALVINAS": "FLK",
					"FLK": "FLK",

					"FAROEISLANDS": "FRO",
					"FØROYAR": "FRO",
					"FOROYAR": "FRO",
					"FÆRØERNE": "FRO",
					"FAEROERNE": "FRO",
					"FRO": "FRO",

					"FIJI": "FJI",
					"FJI": "FJI",

					"FINLAND": "FIN",
					"REPUBLICOFFINLAND": "FIN",
					"SUOMI": "FIN",
					"SUOMENTASAVALTA": "FIN",
					"FIN": "FIN",

					"FRANCE": "FRA",
					"RÉPUBLIQUEFRANÇAISE": "FRA",
					"REPUBLIQUEFRANCAISE": "FRA",
					"FRENCHREPUBLIC": "FRA",
					"LAFRANCE": "FRA",
					"FRA": "FRA",

					"FRENCHGUIANA": "GUF",
					"GUYANE": "GUF",
					"GUF": "GUF",

					"FRENCHPOLYNESIA": "PYF",
					"POLYNÉSIEFRANÇAISE": "PYF",
					"POLYNESIEFRANCAISE": "PYF",
					"PYF": "PYF",

					"FRENCHSOUTHERNTERRITORIES": "ATF",
					"TERRESAUSTRALESETANTARCTIQUESFRANÇAISES": "ATF",
					"TERRESAUSTRALESETANTARCTIQUESFRANCAISES": "ATF",
					"ATF": "ATF",

					"GABON": "GAB",
					"GAB": "GAB",

					"GAMBIA": "GMB",
					"GMB": "GMB",

					"GEORGIA": "GEO",
					"SAKARTVELO": "GEO",
					"GEO": "GEO",

					"GERMANY": "DEU",
					"FEDERALREPUBLICOFGERMANY": "DEU",
					"UNDESREPUBLIKDEUTSCHLAND": "DEU",
					"DEUTSCHLAND": "DEU",
					"BRD": "DEU",
					"DEU": "DEU",

					"GHANA": "GHA",
					"GHA": "GHA",

					"GIBRALTAR": "GIB",
					"GIB": "GIB",

					"GREECE": "GRC",
					"ELLENICREPUBLIC": "GRC",
					"ELLAS": "GRC",
					"ΕΛΛΆΔΑ": "GRC",
					"ELLADA": "GRC",
					"GRC": "GRC",

					"GREENLAND": "GRL",
					"GRØNLAND": "GRL",
					"GRONLAND": "GRL",
					"KALAALLITNUNAAT": "GRL",
					"GRL": "GRL",

					"GRENADA": "GRD",
					"GRD": "GRD",

					"GUADELOUPE": "GLP",
					"GLP": "GLP",

					"GUAM": "GUM",
					"GUM": "GUM",

					"GUATEMALA": "GTM",
					"GTM": "GTM",

					"GUERNSEY": "GGY",
					"GGY": "GGY",

					"GUINEA": "GIN",
					"REPUBLICOFGUINEA": "GIN",
					"GUINEE": "GIN",
					"GIN": "GIN",

					"GUINEABISSAU": "GNB",
					"REPUBLICOFGUINEABISSAU": "GNB",
					"GUINEBISSAU": "GNB",
					"GNB": "GNB",

					"GUYANA": "GUY",
					"GUY": "GUY",

					"HAITI": "HTI",
					"HTI": "HTI",

					"HOLYSEE": "VAT",
					"STATUSCIVITATISVATICANÆ": "VAT",
					"THEVATICAN": "VAT",
					"VATICANCITYSTATE": "VAT",
					"VATICANCITY": "VAT",
					"VATICAN": "VAT",
					"VAT": "VAT",

					"HONDURAS": "HND",
					"HND": "HND",

					"HONGKONG": "HKG",
					"XIANGGANG": "HKG",
					"HKG": "HKG",

					"HUNGARY": "HUN",
					"REPUBLICOFHUNGARY": "HUN",
					"MAGYARORSZÁG": "HUN",
					"MAGYARORSZAG": "HUN",
					"HUN": "HUN",

					"ICELAND": "ISL",
					"REPUBLICOFICELAND": "ISL",
					"ÍSLAND": "ISL",
					"ISLAND": "ISL",
					"LYOVELDIOISLAND": "ISL",
					"ISL": "ISL",

					"INDIA": "IND",
					"REPUBLICOFINDIA": "IND",
					"BHĀRAT": "IND",
					"BHARAT": "IND",
					"BHĀRATGAṆARĀJYA": "IND",
					"BHARATGANARAJYA": "IND",
					"IND": "IND",

					"INDONESIA": "IDN",
					"INDONESIË": "IDN",
					"INDONESIE": "IDN",
					"IDN": "IDN",

					"IRAN": "IRN",
					"ISLAMICREPUBLICOFIRAN": "IRN",
					"IRN": "IRN",

					"IRAQ": "IRG",
					"IRQ": "IRG",

					"IRELAND": "IRL",
					"REPUBLICOFIRELAND": "IRL",
					"ÉIRE": "IRL",
					"EIRE": "IRL",
					"IRL": "IRL",

					"ISLEOFMAN": "IMN",
					"IMN": "IMN",

					"ISRAEL": "ISR",
					"STATEOFISRAEL": "ISR",
					"מדינת ישראל": "ISR",
					"DAWLATALHAYAWANAT": "ISR",
					"DAWLATISRAIL": "ISR",
					"YISRAEL": "ISR",
					"ISR": "ISR",

					"ITALY": "ITA",
					"REPUBBLICAITALIANA": "ITA",
					"ITALIA": "ITA",
					"ITA": "ITA",

					"IVORYCOAST": "CIV",
					"CÔTEDIVOIRE": "CIV",
					"COTEDIVOIRE": "CIV",
					"REPUBLICOFCÔTEDIVOIRE": "CIV",
					"REPUBLICOFCOTEDIVOIRE": "CIV",
					"CIV": "CIV",

					"JAMAICA": "JAM",
					"XAMAYCA": "JAM",
					"JAM": "JAM",

					"JAPAN": "JPN",
					"NIPPON": "JPN",
					"JPN": "JPN",

					"JERSEY": "JEY",
					"JEY": "JEY",

					"JORDAN": "JOR",
					"HASHEMITEKINGDOMOFJORDAN": "JOR",
					"ALURDUNN": "JOR",
					"JOR": "JOR",

					"KAZAKHSTAN": "KAZ",
					"REPUBLICOFKAZAKHSTAN": "KAZ",
					"ҚАЗАҚСТАНРЕСПУБЛИКАСЫ": "KAZ",
					"ҚАЗАҚСТАНQAZAQSTAN": "KAZ",
					"KAZ": "KAZ",

					"KENYA": "KEN",
					"REPUBLICOFKENYA": "KEN",
					"JAMHURIYAKENYA": "KEN",
					"KEN": "KEN",

					"KIRIBATI": "KIR",
					"REPUBLICOFKIRIBATI": "KIR",
					"KIR": "KIR",

					"KOREAREPUBLICOF": "KOR",
					"SOUTHKOREA": "KOR",
					"REPUBLICOFKOREA": "KOR",
					"DAEHANMINGUK": "KOR",
					"KOR": "KOR",

					"KUWAIT": "KWT",
					"ALKUWAYT": "KWT",
					"STATEOFKUWAIT": "KWT",
					"KWT": "KWT",

					"KYRGYZSTAN": "KGZ",
					"KYRGYZRESPUBLIKASY": "KGZ",
					"KGZ": "KGZ",

					"LAOS": "LAO",
					"LAO": "LAO",

					"LATVIA": "LVA",
					"LATVIJA": "LVA",
					"LETTLAND": "LVA",
					"LETLAND": "LVA",
					"LVA": "LVA",

					"LEBANON": "LBN",
					"THELEBANESEREPUBLIC": "LBN",
					"ALJUMHURIYYAALLUBNANIYYA": "LBN",
					"LEBNAN": "LBN",
					"LUBNAN": "LBN",
					"LBN": "LBN",

					"LESOTHO": "LSO",
					"KINGDOMOFLESOTHO": "LSO",
					"LSO": "LSO",

					"LIBERIA": "LBR",
					"LBR": "LBR",

					"LIBYA": "LBY",
					"LIBIYAH": "LBY",
					"LBY": "LBY",

					"LIECHTENSTEIN": "LIE",
					"LIE": "LIE",

					"LITHUANIA": "LTU",
					"LIETUVA": "LTU",
					"ЛИТВА": "LTU",
					"LTU": "LTU",

					"LUXEMBOURG": "LUX",
					"LETZEBUERG": "LUX",
					"LUX": "LUX",

					"MACAO": "MAC",
					"MACAU": "MAC",
					"AOMEN": "MAC",
					"MAC": "MAC",

					"MACEDONIA": "MKD",
					"МАКЕДОНИЈА": "MKD",
					"MAKEDONIJA": "MKD",
					"MKD": "MKD",

					"MADAGASCAR": "MDG",
					"MDG": "MDG",

					"MALAWI": "MWI",
					"REPUBLICOFMALAWI": "MWI",
					"MWI": "MWI",

					"MALAYSIA": "MYS",
					"PERSEKUTUANMALAYSIA": "MYS",
					"FEDERATIONOFMALAYSIA": "MYS",
					"MYS": "MYS",

					"MALDIVES": "MDV",
					"DHIVEHIRAAJJE": "MDV",
					"REPUBLICOFMALDIVES": "MDV",
					"MDV": "MDV",

					"MALI": "MLI",
					"MLI": "MLI",

					"MALTA": "MLT",
					"MLT": "MLT",

					"MARSHALLISLANDS": "MHL",
					"MHL": "MHL",

					"MARTINIQUE": "MTQ",
					"MTQ": "MTQ",

					"MAURITANIA": "MRT",
					"ISLAMICREPUBLICOFMAURITANIA": "MRT",
					"MURITANIYAH": "MRT",
					"MRT": "MRT",

					"MAURITIUS": "MUS",
					"MUS": "MUS",

					"MAYOTTE": "MYT",
					"MYT": "MYT",

					"MEXICO": "MEX",
					"ESTADOSUNIDOSMEXICANOS": "MEX",
					"MÉXICO": "MEX",
					"MEX": "MEX",

					"MICRONESIA": "FSM",
					"FEDERALSTATESOFMICRONESIA": "FSM",
					"FSM": "FSM",

					"MOLDOVA": "MDA",
					"REPUBLICOFMOLDOVA": "MDA",
					"REPUBLICAMOLDOVA": "MDA",
					"MDA": "MDA",

					"MONACO": "MCO",
					"MCO": "MCO",

					"MONGOLIA": "MNG",
					"MONGOLULS": "MNG",
					"MNG": "MNG",

					"MONTENEGRO": "MNE",
					"CRNAGORA": "MNE",
					"MNE": "MNE",

					"MONTSERRAT": "MSR",
					"MSR": "MSR",

					"MOROCCO": "MAR",
					"KINGDOMOFMOROCCO": "MAR",
					"ALMAMLAKAALMAGHRIBIYA": "MAR",
					"MAGHREB": "MAR",
					"ALMAĠRIB": "MAR",
					"ALMAGRIB": "MAR",
					"MAR": "MAR",

					"MOZAMBIQUE": "MOZ",
					"MOCAMBIQUE": "MOZ",
					"MOZ": "MOZ",

					"MYANMAR": "MMR",
					"REPUBLICOFTHEUNIONOFMYANMAR": "MMR",
					"MYANMANAINGNGANDAW": "MMR",
					"MYANMA": "MMR",
					"BURMA": "MMR",
					"MMR": "MMR",

					"NAMIBIA": "NAM",
					"NAM": "NAM",

					"NAURU": "NRU",
					"NRU": "NRU",

					"NEPAL": "NPL",
					"NĒPĀLA": "NPL",
					"NEPALA": "NPL",
					"NPL": "NPL",

					"NETHERLANDSANTILLES": "ANT",
					"NEDERLANDSEANTILLEN": "ANT",
					"ANT": "ANT",

					"NETHERLANDS": "NLD",
					"THENETHERLANDS": "NLD",
					"HOLLAND": "NLD",
					"NEDERLAND": "NLD",
					"NLD": "NLD",

					"NEWCALEDONIA": "NCL",
					"CALEDONIA": "NCL",
					"NOUVELLECALÉDONIE": "NCL",
					"NOUVELLECALEDONIE": "NCL",
					"NCL": "NCL",

					"NEWZEALAND": "NZL",
					"AOTEAROA": "NZL",
					"NZL": "NZL",

					"NICARAGUA": "NIC",
					"NIC": "NIC",

					"NIGER": "NER",
					"NER": "NER",

					"NIGERIA": "NGA",
					"NGA": "NGA",

					"NIUE": "NIU",
					"NIU": "NIU",

					"NORFOLKISLAND": "NFK",
					"NFK": "NFK",

					"NORTHKOREA": "PRK",
					"DEMOCRATICPEOPLESREPUBLICOFKOREA": "PRK",
					"CHOSONMINJUJUUIINMINKONGHWAGUK": "PRK",
					"PRK": "PRK",

					"NORTHERNMARIANAISLANDS": "NMP",
					"NMP": "NMP",

					"NORWAY": "NOR",
					"NORGE": "NOR",
					"NOREG": "NOR",
					"NOR": "NOR",

					"OMAN": "OMN",
					"SALṬANATUMĀN": "OMN",
					"SALTANATUMAN": "OMN",
					"OMN": "OMN",

					"PAKISTAN": "PAK",
					"ISLAMICREPUBLICOFPAKISTAN": "PAK",
					"PAK": "PAK",

					"PALAU": "PLW",
					"REPUBLICOFPALAU": "PLW",
					"BELAU": "PLW",
					"PLW": "PLW",

					"PALESTINIANTERRITORY": "PSE",
					"FILASTIN": "PSE",
					"PSE": "PSE",

					"PANAMA": "PAN",
					"PAN": "PAN",

					"PAPUANEWGUINEA": "PNG",
					"PAPUANIUGINI": "PNG",
					"PNG": "PNG",

					"PARAGUAY": "PRY",
					"PRY": "PRY",

					"PERU": "PER",
					"REPUBLICOFPERU": "PER",
					"PERUVIANREPUBLIC": "PER",
					"REPÚBLICADELPERÚ": "PER",
					"REPuBLICADELPERu": "PER",
					"PERÚ": "PER",
					"PER": "PER",

					"PHILIPPINES": "PHL",
					"REPUBLICOFTHEPHILIPPINES": "PHL",
					"REPÚBLIKANGPILIPINAS": "PHL",
					"REPUBLIKANGPILIPINAS": "PHL",
					"PILIPINAS": "PHL",
					"FILIPINAS": "PHL",
					"PHL": "PHL",

					"PITCAIRNISLAND": "PCN",
					"PCN": "PCN",

					"POLAND": "POL",
					"REPUBLICOFPOLAND": "POL",
					"RZECZPOSPOLITAPOLSKA": "POL",
					"POLSKA": "POL",
					"POL": "POL",

					"PORTUGAL": "PRT",
					"PORTUGUESEREPUBLIC": "PRT",
					"LUSITANIA": "PRT",
					"PRT": "PRT",

					"PUERTORICO": "PRI",
					"COMMONWEALTHOFPUERTORICO": "PRI",
					"PRI": "PRI",

					"QATAR": "QAT",
					"DAWLATQAṬAR": "QAT",
					"DAWLATQATAR": "QAT",
					"QAṬAR": "QAT",
					"QAT": "QAT",

					"RÉUNION": "REU",
					"REUNIONISLAND": "REU",
					"ILEDELARÉUNION": "REU",
					"ILEDELAREUNION": "REU",
					"REU": "REU",

					"ROMANIA": "ROU",
					"ROMÂNIA": "ROU",
					"ROU": "ROU",

					"RUSSIA": "RUS",
					"RUSSIANFEDERATION": "RUS",
					"РОССИЯ": "RUS",
					"ROSSIYA": "RUS",
					"RUS": "RUS",

					"RWANDA": "RWA",
					"REPUBLICOFRWANDA": "RWA",
					"RWA": "RWA",

					"SAINTBARTHÉLEMY": "BLM",
					"SAINTBARTHELEMY": "BLM",
					"BLM": "BLM",

					"SAINTHELENA": "SHN",
					"SHN": "SHN",

					"SAINTKITTSANDNEVIS": "KNA",
					"SAINTKITTSNEVIS": "KNA",
					"FEDERATIONOFSAINTKITTSANDNEVIS": "KNA",
					"FEDERATIONOFSAINTKITTSNEVIS": "KNA",
					"SAINTCHRISTOPHERANDNEVIS": "KNA",
					"SAINTCHRISTOPHERNEVIS": "KNA",
					"KNA": "KNA",

					"SAINTLUCIA": "LCA",
					"LCA": "LCA",

					"SAINTMARTIN": "MAF",
					"MAF": "MAF",

					"SAINTPIERREANDMIQUELON": "SPM",
					"SAINTPIERREMIQUELON": "SPM",
					"SPM": "SPM",

					"SAINTVINCENTANDTHEGRENADINES": "VCT",
					"SAINTVINCENTTHEGRENADINES": "VCT",
					"VCT": "VCT",

					"SAMOA": "WSM",
					"WSM": "WSM",

					"SANMARINO": "SMR",
					"SMR": "SMR",

					"SAOTOMEANDPRINCIPE": "STP",
					"SAOTOMEPRINCIPE": "STP",
					"SÃOTOMÉANDPRÍNCIPE": "STP",
					"SÃOTOMÉPRÍNCIPE": "STP",
					"DEMOCRATICREPUBLICOFSÃOTOMÉANDPRÍNCIPE": "STP",
					"DEMOCRATICREPUBLICOFSAOTOMEANDPRINCIPE": "STP",
					"DEMOCRATICREPUBLICOFSÃOTOMÉPRÍNCIPE": "STP",
					"DEMOCRATICREPUBLICOFSAOTOMEPRINCIPE": "STP",
					"STP": "STP",

					"SAUDIARABIA": "SAU",
					"KINGDOMOFSAUDIARABIA": "SAU",
					"SAUDIA": "SAU",
					"ALARABIYAHASSUUDIYAH": "SAU",
					"SAU": "SAU",

					"SENEGAL": "SEN",
					"SEN": "SEN",

					"SERBIA": "SRB",
					"REPUBLICOFSERVIA": "SRB",
					"YUGOSLAVIA": "SRB",
					"SRBIJA": "SRB",
					"SRB": "SRB",

					"SEYCHELLES": "SYC",
					"SYC": "SYC",

					"SIERRALEONE": "SLE",
					"SLE": "SLE",

					"SINGAPORE": "SGP",
					"REPUBLICOFSINGAPORE": "SGP",
					"SINGAPURA": "SGP",
					"SGP": "SGP",

					"SINTMAARTENDUTCH": "SXM",
					"SINTMAARTEN": "SXM",
					"SXM": "SXM",

					"SLOVAKIA": "SVK",
					"SLOVAKREPUBLIC": "SVK",
					"SLOVENSKO": "SVK",
					"SVK": "SVK",

					"SLOVENIA": "SVN",
					"SLOVENIJA": "SVN",
					"SVN": "SVN",

					"SOLOMONISLANDS": "SLB",
					"SLB": "SLB",

					"SOMALIA": "SOM",
					"SOM": "SOM",

					"SOUTHAFRICA": "ZAF",
					"SUIDAFRIKA": "ZAF",
					"ZAF": "ZAF",

					"SOUTHGEORGIAANDTHESOUTHSANDWICHISLANDS": "SGS",
					"SOUTHGEORGIATHESOUTHSANDWICHISLANDS": "SGS",
					"SGS": "SGS",

					"SOUTHSUDAN": "SSD",
					"SSD": "SSD",

					"SPAIN": "ESP",
					"ESPAÑA": "ESP",
					"ESPANA": "ESP",
					"ESP": "ESP",

					"SRILANKA": "LKA",
					"CEYLON": "LKA",
					"DEMOCRATICSOCIALISTREPUBLICOFSRILANKA": "LKA",
					"LKA": "LKA",

					"SUDAN": "SDN",
					"REPUBLICOFTHESUDAN": "SDN",
					"THESUDAN": "SDN",
					"SDN": "SDN",

					"SURINAME": "SUR",
					"DUTCHGUIANA": "SUR",
					"REPUBLICOFSURINAME": "SUR",
					"SUR": "SUR",

					"SVALBARDANDJANMAYENISLANDS": "SJM",
					"SVALBARDJANMAYENISLANDS": "SJM",
					"SJM": "SJM",

					"SWAZILAND": "SWZ",
					"SWZ": "SWZ",

					"SWEDEN": "SWE",
					"SVERIGE": "SWE",
					"KINGDOMOFSWEDEN": "SWE",
					"SWE": "SWE",

					"SWITZERLAND": "CHE",
					"SWISSCONFEDERATION": "CHE",
					"SCHWEIZ": "CHE",
					"SUISSE": "CHE",
					"SVIZZERA": "CHE",
					"SVIZRA": "CHE",
					"CHE": "CHE",

					"SYRIA": "SYR",
					"SŪRIYĀ": "SYR",
					"SURIYA": "SYR",
					"SŪRĪYAH": "SYR",
					"SURIYAH": "SYR",
					"SYR": "SYR",

					"TAIWAN": "TWN",
					"REPUBLICOFCHINA": "TWN",
					"FORMOSA": "TWN",
					"TAIPEI": "TWN",
					"中華民國": "TWN",
					"臺灣": "TWN",
					"TWN": "TWN",

					"TAJIKISTAN": "TJK",
					"TJK": "TJK",

					"TANZANIA": "TZA",
					"UNITEDREPUBLICOFTANZANIA": "TZA",
					"TANGANYIKAANDZANZIBAR": "TZA",
					"TANGANYIKAZANZIBAR": "TZA",
					"TZA": "TZA",

					"THAILAND": "THA",
					"SIAM": "THA",
					"KINGDOMOFTHAILAND": "THA",
					"ประเทศไทย": "THA",
					"PRATHETTHAI": "THA",
					"THA": "THA",

					"TIMORLESTE": "TLP",
					"TIMOR": "TLP",
					"TLP": "TLP",

					"TOGO": "TGO",
					"TOGOLESEREPUBLIC": "TGO",
					"RÉPUBLIQUETOGOLAISE": "TGO",
					"REPUBLIQUETOGOLAISE": "TGO",
					"TGO": "TGO",

					"TOKELAU": "TKL",
					"TKL": "TKL",

					"TONGA": "TON",
					"TON": "TON",

					"TRINIDADANDTOBAGO": "TTO",
					"TRINIDADTOBAGO": "TTO",
					"REPUBLICOFTRINIDADANDTOBAGO": "TTO",
					"REPUBLICOFTRINIDADTOBAGO": "TTO",
					"TRINBAGO": "TTO",
					"TRINIDAD": "TTO",
					"TOBAGO": "TTO",
					"TTO": "TTO",

					"TUNISIA": "TUN",
					"REPUBLICOFTUNISIA": "TUN",
					"الجمهورية التونسية": "TUN",
					"TŪNIS": "TUN",
					"TUN": "TUN",

					"TURKEY": "TUR",
					"TÜRKIYE": "TUR",
					"TURKIYE": "TUR",
					"REPUBLICOFTURKEY": "TUR",
					"TUR": "TUR",

					"TURKMENISTAN": "TKM",
					"TKM": "TKM",

					"TURKSANDCAICOSISLANDS": "TCA",
					"TURKSCAICOSISLANDS": "TCA",
					"TCA": "TCA",

					"TUVALU": "TUV",
					"ELLICEISLANDS": "TUV",
					"TUV": "TUV",

					"UGANDA": "UGA",
					"REPUBLICOFUGANDA": "UGA",
					"UGA": "UGA",

					"UKRAINE": "UKR",
					"UKRAINA": "UKR",
					"УКРАЇНА": "UKR",
					"YКРАIНА": "UKR",
					"UKR": "UKR",

					"UNITEDARABEMIRATES": "ARE",
					"DAWLATALIMĀRĀTALARABĪYAHALMUTTAḤIDAH": "ARE",
					"DAWLATALIMARATALARABIYAHALMUTTAHIDAH": "ARE",
					"UAE": "ARE",
					"EMIRATES": "ARE",
					"ARE": "ARE",

					"UNITEDKINGDOM": "GBR",
					"GREATBRITAIN": "GBR",
					"ENGLAND": "GBR",
					"UK": "GBR",
					"WALES": "GBR",
					"SCOTLAND": "GBR",
					"NORTHERNIRELAND": "GBR",
					"BRITAIN": "GBR",
					"GBR": "GBR",

					"UNITEDSTATESMINOROUTLYINGISLANDS": "UMI",
					"UMI": "UMI",

					"UNITEDSTATESVIRGINISLANDS": "VIR",
					"VIR": "VIR",

					"UNITEDSTATES": "USA",
					"THEUNITEDSTATES": "USA",
					"UNITEDSTATESOFAMERICA": "USA",
					"AMERICA": "USA",
					"THECOLONIES": "USA",
					"USA": "USA",

					"URUGUAY": "URY",
					"EASTERNREPUBLICOFURUGUAY": "URY",
					"REPÚBLICAORIENTALDELURUGUAY": "URY",
					"REPUBLICAORIENTALDELURUGUAY": "URY",
					"URY": "URY",

					"UZBEKISTAN": "UZB",
					"REPUBLICOFUZBEKISTAN": "UZB",
					"OZBEKISTONRESPUBLIKASI": "UZB",
					"UZB": "UZB",

					"VANUATU": "VUT",
					"VUT": "VUT",

					"VENEZUELA": "VEN",
					"VEN": "VEN",

					"VIETNAM": "VNM",
					"SOCIALISTREPUBLICOFVIETNAM": "VNM",
					"VIỆTNAM": "VNM",
					"VNM": "VNM",

					"WALLISANDFUTUNAISLANDS": "WLF",
					"WALLISFUTUNAISLANDS": "WLF",
					"WALLISETFUTUNA": "WLF",
					"WLF": "WLF",

					"WESTERNSAHARA": "ESH",
					"AṢṢAḤRĀALGHARBĪYAH": "ESH",
					"ASSAHRAALGHARBIYAH": "ESH",
					"ESH": "ESH",

					"YEMEN": "YEM",
					"REPUBLICOFYEMEN": "YEM",
					"ALYAMAN": "YEM",
					"YEM": "YEM",

					"ZAMBIA": "ZMB",
					"NORTHERNRHODESIA": "ZMB",
					"REPUBLICOFZAMBIA": "ZMB",
					"ZMB": "ZMB",

					"ZIMBABWE": "ZWE",
					"RHODESIA": "ZWE",
					"REPUBLICOFRHODESIA": "ZWE",
					"REPUBLICOFZIMBABWE": "ZWE",
					"SOUTHERNRHODESIA": "ZWE",
					"ZWE": "ZWE"
				};
				return validCountries[countryValue];
			} else {
				return "USA";
			}
		};

		this.autocompleteVisible = function () {
			return config.ui && config.autocomplete && $('.smarty-autocomplete.smarty-addr-' + self.id()).is(':visible');
		};

		this.id = function () {
			return id;
		};
	}

	/*
	 Represents a <form> tag which contains mapped fields.
	 */
	function Form(domElement) {
		this.addresses = [];
		this.dom = domElement;

		this.activeAddressesNotAccepted = function () {
			var addrs = [];
			for (var i = 0; i < this.addresses.length; i++) {
				var addr = this.addresses[i];
				if (addr.status() != "accepted" && addr.active)
					addrs.push(addr);
			}
			return addrs;
		};

		this.allActiveAddressesAccepted = function () {
			return this.activeAddressesNotAccepted().length == 0;
		};
	}

	/*
	 Wraps output from the API in an easier-to-handle way
	 */

	function Response(json) {
		// PRIVATE MEMBERS //

		var checkBounds = function (idx) {
			// Ensures that an index is within the number of candidates
			if (idx >= json.length || idx < 0) {
				if (json.length == 0)
					throw new Error("Candidate index is out of bounds (no candidates returned; requested " + idx + ")");
				else
					throw new Error("Candidate index is out of bounds (" + json.length + " candidates; indicies 0 through " +
						(json.length - 1) + " available; requested " + idx + ")");
			}
		};

		var maybeDefault = function (idx) {
			// Assigns index to 0, the default value, if no value is passed in
			return typeof idx === 'undefined' ? 0 : idx;
		};

		// PUBLIC-FACING MEMBERS //

		this.raw = json;
		this.length = json.length;

		this.isValid = function () {
			return (this.length == 1 &&
			(this.raw[0].analysis.verification_status == "Verified" ||
			(typeof this.raw[0].analysis.dpv_match_code != 'undefined' && this.raw[0].analysis.dpv_match_code != "N")));
		};

		this.isInvalid = function () {
			return (this.length == 0 ||
			(this.length == 1 &&
			(this.raw[0].analysis.verification_status == "None" ||
			this.raw[0].analysis.verification_status == "Partial" ||
			this.raw[0].analysis.dpv_match_code == "N" ||
			(typeof this.raw[0].analysis.verification_status === 'undefined' &&
			typeof this.raw[0].analysis.dpv_match_code === 'undefined'))));
		};

		this.isAmbiguous = function () {
			return this.length > 1;
		};

		this.isMissingSecondary = function (idx) {
			idx = maybeDefault(idx);
			checkBounds(idx);
			return (this.raw[idx].analysis.dpv_footnotes && this.raw[idx].analysis.dpv_footnotes.indexOf("N1") > -1) ||
				(this.raw[idx].analysis.dpv_footnotes && this.raw[idx].analysis.dpv_footnotes.indexOf("R1") > -1) ||
				(this.raw[idx].analysis.footnotes && this.raw[idx].analysis.footnotes.indexOf("H#") > -1);
		};
	}

	/*
	 *	EVENT HANDLER "SHTUFF"
	 */

	/*
	 Called every time a LiveAddress event is raised.
	 This allows us to maintain the binding even if the
	 callback function is changed later.
	 "event" is the actual event object, and
	 "data" is anything extra to pass to the event handler.
	 */
	function HandleEvent(event, data) {
		var handler = instance.events[event.type];
		if (handler)
			handler(event, data);
	}

	// Submits a form by calling `click` on a button element or `submit` on a form element
	var submitForm = function (invokeOn, invokeFunction) {
		if (invokeOn && typeof invokeOn !== 'function' && invokeFunction) {
			if (invokeFunction == "click") {
				setTimeout(function () {
					$(invokeOn).click(); // Very particular: we MUST fire the native 'click' event!
				}, 5);
			} else if (invokeFunction == "submit")
				$(invokeOn).submit(); // For submit(), we have to use jQuery's, so that all its submit handlers fire.
		}
	};

	/*
	 *	MISCELLANEOUS
	 */

	function arrayContains(array, subject) {
		// See if an array contains a particular value
		for (var i in array)
			if (array[i] === subject) return true;
		return false;
	}

	function randomInt(min, max) {
		// Generate a random integer between min and max
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	function lowercase(string) {
		// Return an empty string if not defined, or a lowercase string with '[]' stripped.
		return string ? string.toLowerCase().replace('[]', '') : '';
	}

	function trigger(eventType, metadata) {
		// Raise an event (in our case, a custom event)
		$(document).triggerHandler(eventType, metadata);
	}

	function bind(eventType) {
		// Bind a custom handler to an event
		$(document).bind(eventType, HandleEvent);
	}

	function suppress(event) {
		// Used to prevent form submits, and stop other events if needed
		if (!event) return false;
		if (event.preventDefault) event.preventDefault();
		if (event.stopPropagation) event.stopPropagation();
		if (event.stopImmediatePropagation) event.stopImmediatePropagation();
		event.cancelBubble = true;
		return false;
	}

})(jQuery, window, document);


/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "car-ic-a8dff35df0787a2834a332dfe4656036.svg";

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScheduleTourModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mobile_views_text_input_modal_helper__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mortgage_jornaya_lead_id__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quick_view_components_payment_constants__ = __webpack_require__(12);





/**
 * Schedule Tour Module
 *
 * Implemented in both the quick-view and LDP.
 * Exported as default in section_schedule_tour.
 * LDP Template: _schedule_tour.html.erb
 * QV Template: schedule-tour.jst.ejs
 *
 * @module ldp/common_platform/views/schedule_tour
 */
var ScheduleTourModule = function ScheduleTourModule(LDP) {

  /**
   * Contact Agent CSS Class
   * @type {string}
   */
  var contactAgentBtn = '.contact-agent-btn';

  /**
   * Day Names
   * @type {string[]}
   */
  var DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];

  /**
   * Element Queries
   * @type {jQuery|HTMLElement}
   */
  var $stWrapper = $('.st-wrapper'),
      $stCarouselWrapper = $('.st-owl-carousel'),
      $stDateCarouselWrapper = $('.st-date-owl-carousel'),
      $stCarouselItem = $('.st-owl-carousel .item'),
      $stDurationItem = $('.st-duration-picker .time-card'),
      $stView1 = $('.st-view-1'),
      $stView2 = $('.st-view-2'),
      $stView3 = $('.st-view-3'),
      $stView2Tabs = $('.st-view-2-tabs p'),
      $stSelectButton = $('.st-select-btn'),
      $stScheduleButton = $('.st-schedule-btn'),
      $stCancelButton = $('.st-cancel-btn'),
      $stTimePicker = $('.st-duration-picker'),
      $st2CallMeBtn = $('.cta-call-btn'),
      $st2TextMeBtn = $('.cta-text-btn'),
      $st2ContactInput = $('.st-contact-input'),
      $stFooter = $('.st-footer'),
      $st3ContactAgent = $(contactAgentBtn),
      $stCloseBtn = $('.st-close-btn'),
      $stViewListingBtn = $('.view-listing-btn'),
      $stGoBackBtn = $('.go-back-btn'),
      $stThankYouText = $('.st-thank-you-text'),
      $stToday = $('.st-today'),
      $stAddress = $('#st-address'),
      $qvAside = $('#qv-aside'),
      $stRequestTourBtn = $('.request-tour-btn'),
      $stMobileError = $('.st-mobile-error'),
      $stMobileText = $('.st-view-2 .schedule-tour'),
      $stMobileAddress = $('.st-address-text');

  /**
   * Cookie Name
   * @type {string}
   */
  var stCookie = 'st-mobile-number';

  /**
   * Cookie Value
   * @type {number}
   */
  var stCookieValue = __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* CommonPlatformUtilities */].getCookie(stCookie);

  /**
   * Schedule tour post request object
   * @type {{}}
   * @private {Object}
   */
  var requestObj = {};

  /**
   * Schedule Tour State
   * @type {{
   *  body: string,
   *  call: boolean,
   *  date: string,
   *  mobile: boolean,
   *  timeSelected: boolean,
   *  dateSelected: boolean,
   *  text: boolean,
   *  time: string,
   *  lazyLoad: boolean,
   *  tablet: boolean
   * }}
   */
  var state = {
    text: true,
    call: false,
    dateSelected: false,
    timeSelected: false,
    date: '',
    time: '',
    address: $stAddress.data('value'),
    body: '',
    lazyLoad: true,
    mobile: $(window).width() <= 414,
    tablet: $(window).width() <= 768 && $(window).width() > 414
  };

  /**
   * Carousel Items
   * @type {number}
   */
  var carouselItems = state.tablet ? 4 : 3;

  /**
   * Owl carousel options
   * @type {{
   *  nav: boolean,
   *  margin: number,
   *  autoHeight: boolean,
   *  slideBy: number,
   *  navText: string[],
   *  items: number,
   * }}
   */
  var options = {
    nav: true,
    items: carouselItems,
    slideBy: carouselItems,
    margin: state.mobile ? -15 : state.tablet ? 0 : 6,
    autoHeight: true,
    navText: ["<span class='st-chevron'>&lsaquo;</span>", "<span class='st-chevron'>&rsaquo;</span>"]
  };

  /**
   * Go to view 2
   * @private
   * @returns {void}
   */
  function goBackToView1() {
    $stGoBackBtn.on('click', function () {
      $stView1.fadeIn(200);
      $stView2.hide();
      $stCancelButton.css('display', 'none');
    });
  }

  /**
   * RDC Tracking
   * @private
   * @returns {void}
   */
  function scheduleTourTracking(property) {
    var propertyStatus = property.propertyStatus,
        listing = property.listing,
        leadDelivery = listing.leadDelivery,
        text = state.text,
        event = text ? 'forSaleCobrokeTextLead' : 'forSaleCobrokePhoneLead',
        linkName = "web:leads:" + (text ? 'text' : 'phone') + ":" + propertyStatus + ":" + leadDelivery,
        leadPlacement = "for_sale:" + (property.pageType === 'ldp-quickview' ? 'ldp_quickview' : 'ldp') + ":" + (MOVE_DATA.isPhone ? 'sticky_footer' : 'primary_top') + ":contact_agent_schedule_tour";


    if (text) {
      var textLeads = linkName;
      RdcTracking.trackEvent(event, {
        textLeads: textLeads,
        linkName: linkName,
        leadPlacement: leadPlacement
      });
    } else {
      var phoneLeads = linkName;
      var rentalDataSource = 'unknown';

      RdcTracking.trackEvent(event, {
        phoneLeads: phoneLeads,
        linkName: linkName,
        leadPlacement: leadPlacement,
        rentalDataSource: rentalDataSource
      });
    }
  }

  /**
   * On mobile number post success - route to thank you page
   * @private
   * @returns {void}
   */
  function requestSuccess() {
    $stView2.hide();
    $stView3.fadeIn(2000);
    $stViewListingBtn.show();
    $stFooter.show();

    if (!state.mobile && !state.tablet) {
      resetState();
    } else {
      resetMobileState(true);
    }
  }

  /**
   * Post request submit handler
   * @param property
   * @private
   * @returns {void}
   */
  function requestSubmitHandler(property) {

    scheduleTourTracking(property);

    var options = {
      isScheduleTour: true,
      mobileNumber: requestObj.mobileNumber,
      stDate: state.date,
      stTime: state.time,
      isStCall: state.call
    };

    document.cookie = stCookie + "=" + requestObj.mobileNumber;
    $.ajax({
      data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__mobile_views_text_input_modal_helper__["a" /* getLeadData */])("", property, options),
      url: "/leads",
      type: 'POST',
      success: requestSuccess(),
      error: function error(err) {
        return console.log(err);
      }
    });
  }

  /**
   * Request tour button event listener.
   * Route to view 3, thank you page.
   * @private
   * @returns {void}
   */
  function requestTourListener() {
    var property = MOVE_DATA.adobeDTM || {};
    $stRequestTourBtn.off('click').on('click', function (e) {
      state.body = "I'm interested in scheduling a tour of " + state.address + " on " + state.date + " " + state.time;
      if (MOVE.Helper.isMobile()) {
        updateDateTimeListener(state);
      }
      e.preventDefault();

      if (__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* CommonPlatformUtilities */].phoneNumberValid(requestObj.mobileNumber)) {
        requestSubmitHandler(property);
        $stMobileError.hide();
      } else {
        $stMobileError.show();
        $stMobileError.text('Please enter a valid phone number');
      }
    });
  }
  /**
   * Select tabs
   * @private
   * @returns {void}
   */
  function selectCTATabs() {
    $stView2Tabs.on('click', function () {
      $stView2Tabs.removeClass('cta-active');
      $(this).addClass('cta-active');
    });
  }

  /**
   * Call Me tab event handler.
   * Set the request-tour-btn element with an href of tel
   * @private
   * @returns {void}
   */
  function callMeListener() {
    $st2CallMeBtn.on('click', function () {
      state.call = true;
      state.text = false;
      $stThankYouText.text('call');
    });
    __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* CommonPlatformUtilities */].formatPhone();
  }

  /**
   * Text Me event handler.
   * Set the request-tour-btn element with an href of sms
   * @private
   * @returns {void}
   */
  function textMeListener() {
    $st2TextMeBtn.on('click', function () {
      state.text = true;
      state.call = false;
      $stThankYouText.text('text');
    });
    __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* CommonPlatformUtilities */].formatPhone();
  }

  /**
   * Input change event handler
   * @private
   * @returns {void}
   */
  function contactInputListener() {
    $st2ContactInput.on('keyup', function (val) {
      $stMobileError.hide();
      requestObj.mobileNumber = val.target.value;
    });
  }

  /**
   * Route to view 2
   */
  function routeToView2() {
    $stView1.hide();
    $stView2.fadeIn(200);
  }

  /**
   * Screen 1a. call to action event
   * @private
   * @returns {void}
   */
  function scheduleBtnListener() {
    $stScheduleButton.on('click', function () {
      if (!MOVE_DATA.leadid_token) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mortgage_jornaya_lead_id__["a" /* generateLeadIdForRCM */])();
      if (!state.mobile && !state.tablet && state.dateSelected) {
        $stFooter.hide();
        $stTimePicker.show();
        $stCancelButton.css('display', 'block');
        $stScheduleButton.hide();
        $stSelectButton.css('display', 'block');
        state.dateSelected = true;
      } else {
        routeToView2();
        if (MOVE.Helper.isMobile()) {
          updateDateTimeListener(state);
        }
      }
    });
  }

  /**
   * Screen 1b. call to action event
   * @private
   * @returns {void}
   */
  function selectBtnListener() {
    $stSelectButton.on('click', function () {
      routeToView2();
    });
  }

  /**
   * Cancel button event listener
   * @private
   * @returns {void}
   */
  function cancelButtonListener() {
    $stCancelButton.on('click', function () {
      resetState();
      selectDefaultDate();
      selectDefaultTime();
    });
  }

  /**
   * Reset state
   * @private
   * @returns {void}
   */
  function resetState() {
    $stFooter.show();
    $stTimePicker.hide();
    $stScheduleButton.show();
    $stSelectButton.hide();
    $stCancelButton.hide();
    $stViewListingBtn.hide();
    if (!LDP) {
      $stCarouselItem.removeClass('st-active');
      $stDurationItem.removeClass('st-active');
    }
  }

  /**
   * Reset mobile state
   * @private
   * @returns {void}
   */
  function resetMobileState(flag) {
    requestObj.mobileNumber = __WEBPACK_IMPORTED_MODULE_3__quick_view_components_payment_constants__["a" /* BLANK */];
    $stFooter.hide();
    $stScheduleButton.show();
    $stSelectButton.hide();
    $stCancelButton.hide();
    $stCarouselItem.removeClass('st-active');
    $stDurationItem.removeClass('st-active');
    if (LDP) {
      selectDefaultDate();
      selectDefaultTime();
    }
    if (!flag) {
      $stView3.hide();
    }
  }

  /**
   * Initialize the mobile view.
   * Add and remove appropriate classes as needed.
   * @private
   * @returns {void}
   */
  function mobileViewInit() {
    if (state.mobile) {
      $qvAside.remove();
      $stFooter.hide();
      $stScheduleButton.val('Select');
      $stTimePicker.show();
      $stWrapper.addClass('st-mobile');
      $stCloseBtn.show();
      $st3ContactAgent.hide();
      addScheduleTourCtaTracking();
    }
  }

  /**
   * Add Schedule Tour cta modalImpression tracking
   * @private
   * @returns {void}
   */
  function addScheduleTourCtaTracking() {
    var modalName = 'for_sale:schedule_tour';
    var modalTrigger = "for_sale:" + (MOVE_DATA.quickview ? 'ldp_quickview' : 'ldp') + ":sticky_footer:contact_agent_schedule_tour";
    $('.ot-schedule-tour').on('click', function () {
      RdcTracking.trackEvent('modalImpression', { modalName: modalName, modalTrigger: modalTrigger });
    });
  }

  /**
   * Close mobile modal
   * @private
   * @returns {void}
   */
  function closeModal() {
    resetMobileState();
    $stView2.hide();
    $stView3.hide();
    $stView1.show();
  }

  function closeMobileSTModal() {
    $stCloseBtn.on('click', function () {
      closeModal();
    });
  }

  function viewListingButton() {
    $stViewListingBtn.on('click', function () {
      closeModal();
    });
  }

  /**
   * Select date event listener
   * @private
   * @returns {void}
   */
  function selectDateListener() {
    $stCarouselItem.on('click', function () {
      $stCarouselItem.removeClass('st-active');
      $(this).addClass('st-active');

      state.date = $(this).data('value');
      state.dateSelected = true;
    });
  }

  /**
   * Select default date
   * @private
   * @returns {void}
   */
  function selectDefaultDate() {
    var item = MOVE.Helper.isMobile() ? $stCarouselItem.eq(0) : $stCarouselItem.eq(1);
    item.addClass('st-active');

    state.date = item.data('value');
    state.dateSelected = true;
  }

  /**
   * Select default time
   * @private
   * @returns {void}
   */
  function selectDefaultTime() {
    var item = $stDurationItem.eq(0);
    item.addClass('st-active');

    state.time = item.data('value');
    state.timeSelected = true;
  }

  /**
   * Select time event listener
   * @private
   * @returns {void}
   */
  function selectTimeListener() {
    $stDurationItem.on('click', function () {
      $stDurationItem.removeClass('st-active');
      $(this).addClass('st-active');

      state.time = $(this).data('value');
      state.timeSelected = true;
    });
  }

  /**
   * Init functions when component is rendered
   * @private
   * @returns {void}
   */
  function componentDidMount() {
    selectDefaultTime();
    selectDefaultDate();
    if (!state.mobile) {
      $stFooter.show();
    }
    var cookieVal = stCookie ? stCookieValue : '';
    $stCarouselWrapper.owlCarousel(options);
    $stDateCarouselWrapper.owlCarousel(options);
    $stWrapper.show();
    $('.st-disabled').removeClass('st-disabled');
    $st2ContactInput.val(cookieVal);
    requestObj.mobileNumber = cookieVal;
  }

  function setDay() {
    var now = new Date();
    var timeThreshold = 23;
    var currentTime = now.getHours() + 7;
    if (currentTime > timeThreshold) {
      $stToday.text(DAY_NAMES[(now.getDay() + 1) % 7]);
    } else {
      $stToday.text('Today');
    }
  }

  function tabletInit() {
    if (state.tablet) {
      $stScheduleButton.val('Select');
      $stFooter.hide();
      $qvAside.remove();
      $stTimePicker.show();
      $stCarouselWrapper.css('width', '82%');
      $stDateCarouselWrapper.css('width', '82%');
    }
  }

  function updateDateTimeListener(state) {
    var scheduleDate = $(".item.st-active").text().replace(/\s /g, '').trim().split('  ');
    var scheduleTime = scheduleDate[1];
    var scheduleData = scheduleDate[0].split(' ')[0];
    scheduleData = scheduleData + ', ' + state.date;
    var scheduleDataFormat = scheduleTime.trim().split(" ");
    if (scheduleDataFormat.length > 1) {
      scheduleDataFormat = scheduleDataFormat[0] + " (" + scheduleDataFormat[1] + ") ";
    }
    $stMobileText.html("Touring " + state.address + "  <br /> " + scheduleData + ", " + (scheduleDataFormat.length > 1 ? scheduleDataFormat : scheduleTime));
    $stMobileAddress.html("Touring " + state.address + "  <br /> " + scheduleData + ", " + scheduleDataFormat);
  }

  /**
   * Init carousel and event listeners.
   * @public
   * @constructor
   * @returns {void}
   */
  function Init() {
    resetState();
    resetMobileState();
    componentDidMount();

    // view-1
    selectDateListener();
    selectTimeListener();
    selectBtnListener();
    scheduleBtnListener();
    cancelButtonListener();
    setDay();

    // view-2
    callMeListener();
    textMeListener();
    contactInputListener();
    requestTourListener();
    selectCTATabs();
    goBackToView1();

    // view-3
    viewListingButton();
    closeMobileSTModal();
    __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* CommonPlatformUtilities */].scrollOnClick(contactAgentBtn);

    mobileViewInit();
    tabletInit();
  }

  if (LDP) {
    LDP.STDatePicker = {
      init: new Init()
    };
  } else {
    new Init();
  }
};
/**
 * Set the MOVE LDP Schedule Tour variable
 * @public
 * @returns {void}_schedule
 */
function setGlobalScheduleTourVar() {
  if (MOVE.LDP) {
    MOVE.LDP.STDatePicker = new ScheduleTourModule(MOVE.LDP || {});
  }
}

setGlobalScheduleTourVar();

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_special_events__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_critical_tracking_shared_clicks__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_car_ic_svg__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_car_ic_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_car_ic_svg__);




MOVE.CommuteTime = function (MOVE) {
  var $ldpCommuteTimePopover, $ldpCommuteTimeClose, $commuteForm, ldpCommuteTimeSelector, ldpCommuteAddressSelector, $ldpCommuteTime, $ldpCommuteAddress, $commuteTrafficOption, $commuteDrive, closeCommuteTimePopover, smartyStreetLiveAddress, $commuteInfo, $commutePopoverInfo, smartyUIInit, scrollPosition, viewport;

  var init = function init() {
    setVariables();
    initLiveAddress();
    checkTrafficOption();
    MOVE.DOMHelper.initPopOver($commuteInfo);
  };

  var setVariables = function setVariables() {
    $ldpCommuteTimePopover = $('#estimate-commute-time-popover');
    $ldpCommuteTimeClose = $('#ldp-commute-time-close');
    $commuteForm = $('#commute-form');
    ldpCommuteTimeSelector = '#ldp-commute-time';
    ldpCommuteAddressSelector = '#ldp-commute-address';
    $ldpCommuteTime = $(ldpCommuteTimeSelector);
    $ldpCommuteAddress = $(ldpCommuteAddressSelector);
    $commuteTrafficOption = $("#commute-traffic");
    $commuteDrive = $('#ldp-commute-time-drive');
    $commuteInfo = $("#estimate-commute-time-popover");
    $commutePopoverInfo = $commuteInfo.find('[rel="popover"]');
    smartyUIInit = false;
    viewport = MOVE.Helper.detectViewPort();
    if ($ldpCommuteTime.length > 0) {
      scrollPosition = $ldpCommuteTime.offset().top;
    }

    // Init SmartyStreet
    smartyStreetLiveAddress = MOVE.SmartyStreetSuggest.liveAddressSuggest({
      addresses: [{
        freeform: ldpCommuteAddressSelector
      }]
    });

    closeCommuteTimePopover = function closeCommuteTimePopover() {
      if (smartyStreetLiveAddress) {
        if ($ldpCommuteTimePopover.hasClass('show-commute') && viewport === 'xx-small') {
          window.scrollTo(0, scrollPosition - 150);
        }
        smartyStreetLiveAddress.deactivate('ldp-commute-address');
        $ldpCommuteTimePopover.removeClass('show-commute');
        clearError();
      }
    };
  };

  var initLiveAddress = function initLiveAddress() {
    $ldpCommuteAddress.focus(function () {
      clearError();
      closeCommuteInfoPopover();
    });

    $commuteForm.submit(function (e) {
      e.preventDefault();
      return false;
    });

    $ldpCommuteTimePopover.on('click', 'button', function () {
      if ($('.ldp-commute-time-search .ldp-commute-address').val() === '') {
        noCommuteResults('EMPTY_VALUE');
      } else {
        estimateCommuteTime(true);
      }
      closeCommuteInfoPopover();
    });

    $ldpCommuteTimePopover.on('click', '.ldp-commute-mode i', function () {
      $('.estimate-commute-time-content i').removeClass('selected');
      $('.estimate-commute-time-content img').removeClass('selected');
      $(this).addClass('selected');
      checkTrafficOption();
    });

    $ldpCommuteTimePopover.on('click', '.ldp-commute-mode img', function () {
      $('.estimate-commute-time-content i').removeClass('selected');
      $('.estimate-commute-time-content img').removeClass('selected');
      $(this).addClass('selected');
      checkTrafficOption();
    });

    $ldpCommuteTimeClose.click(function () {
      closeCommuteTimePopover();
    });

    $('body').on('click', function (e) {
      var container = $('#estimate-commute-time-popover');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        closeCommuteTimePopover();
        closeCommuteInfoPopover();
      }
    }).find('.commute-time-wrapper').on('click', function (event) {
      event.stopPropagation();
    });

    $ldpCommuteTime.on('click', '.estimate-commute-popover-toggle', function () {
      var popoverContainer = $ldpCommuteTimePopover;
      if (popoverContainer.hasClass('show-commute')) {
        closeCommuteTimePopover();
      } else {
        if (MOVE.Helper.hasSessionStorage()) {
          var commuteTimeTraffic = window.sessionStorage.getItem('commutetime-traffic');

          if (commuteTimeTraffic !== null) {
            $('#commutetraffic').prop('checked', commuteTimeTraffic === 'true');
          }
        }

        popoverContainer.addClass('show-commute');
        $ldpCommuteAddress.focus();
        smartyStreetLiveAddress.activate('ldp-commute-address');
        $(window).resize(); // This line helps to make sure the smarty autocomplete goes under the input field
        setDestinations();

        // This allow us to bind only one event to .smarty-ui div,
        // otherwise we will have more click events binded on each click
        if (!smartyUIInit) {
          $('.smarty-ui').on('click', function (event) {
            event.stopPropagation();
          });
          smartyUIInit = true;
        }
      }
      var pageType = MOVE_DATA.adobeDTM.pageType;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_critical_tracking_shared_clicks__["b" /* trackClick */])('property-info:calculate-commute', pageType);
    });

    $ldpCommuteTimePopover.on('change', '#commutetraffic', function () {
      if (MOVE.Helper.hasSessionStorage()) {
        window.sessionStorage.setItem('commutetime-traffic', $('#commutetraffic').is(':checked'));
      }
    });
  };

  var noCommuteResults = function noCommuteResults(errorMessage, mode) {
    var errorLabel = $('.commute-time-invalid-address');
    if (errorMessage === 'ZERO_RESULTS' || errorMessage === 'NOT_FOUND') {
      errorLabel.text('Sorry, we could not calculate ' + mode + ' directions.');
    } else if (errorMessage === 'COOKIES_NOT_ENABLED') {
      errorLabel.text('Your browser has to support cookies.');
    } else if (errorMessage === 'STALE_COOKIES') {
      errorLabel.text('Please refresh the browser.');
    } else if (errorMessage === 'EMPTY_VALUE') {
      errorLabel.text('Please enter a valid address.');
    }
    errorLabel.addClass('error').fadeIn();
  };

  var clearError = function clearError() {
    var errorLabel = $('.commute-time-invalid-address');
    if (errorLabel.hasClass('error')) {
      errorLabel.fadeOut().removeClass('error');
      $('.smarty-ui').removeClass('error');
    }
  };

  var estimateCommuteTime = function estimateCommuteTime(isClick) {
    var origins = MOVE_DATA.propertyDetails.address + ' ' + MOVE_DATA.propertyDetails.city + ' ' + MOVE_DATA.propertyDetails.state_code + ' ' + MOVE_DATA.propertyDetails.postal_code,
        destinations = $('.ldp-commute-time-search .ldp-commute-address').val(),
        element = $('.estimate-commute-time-content i.selected'),
        mode = element.data('commute-mode');

    if (destinations && mode) {
      var commuteMode = element.data('icon'),
          departureTime;

      if (mode === 'driving') {
        departureTime = Math.round(nextWednesday().getTime() / 1000.0);
      }

      $.ajax({
        url: '/commute/time',
        type: 'POST',
        data: $.param({
          origins: origins,
          destinations: destinations,
          mode: mode,
          departure_time: departureTime
        }),
        dataType: 'json',
        success: function success(response) {
          // duration_in_traffic is only available when departure_time present
          var duration = response.rows[0].elements[0].duration_in_traffic || response.rows[0].elements[0].duration;

          if (!_.isUndefined(duration)) {
            var durationTxt = duration.text;
            renderCommuteTime(commuteMode, durationTxt);
            cacheDestinations(destinations);
            closeCommuteTimePopover();

            if (MOVE.Helper.hasSessionStorage()) {
              window.sessionStorage.setItem('commutetime-mode', element.attr('id'));
            }
          } else {
            noCommuteResults(response.rows[0].elements[0].status, mode);
          }
          if (isClick) {
            var commuteOption;
            if (commuteMode === 'car') {
              commuteOption = departureTime ? 'driveWithTraffic' : 'driveWithoutTraffic';
            } else {
              commuteOption = commuteMode;
            }
            MOVE_DATA.adobeDTM.commuteAddress = destinations;
            MOVE_DATA.adobeDTM.commuteOption = commuteOption;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_special_events__["a" /* trackCommuteTime */])(MOVE_DATA.adobeDTM.pageType, destinations, commuteOption);
          }
        },
        error: function error(response) {
          if (response.responseText !== undefined) {
            noCommuteResults(response.responseText, mode);
          } else {
            noCommuteResults();
          }
        }
      });
    }
  };

  var cacheDestinations = function cacheDestinations(destinations) {
    if (MOVE.LocalStorage.isAvailable) {
      localStorage.setItem('commuteDestinations', destinations);
    }
  };

  var setDestinations = function setDestinations() {
    if (MOVE.LocalStorage.isAvailable) {
      var destinations = localStorage.getItem('commuteDestinations');
      if (destinations) {
        $('.ldp-commute-time-search .ldp-commute-address').val(destinations);
      }
    }
  };

  var setMode = function setMode() {
    if (MOVE.Helper.hasSessionStorage()) {
      var modeSelectorId = window.sessionStorage.getItem('commutetime-mode');
      if (modeSelectorId) {
        $('#' + modeSelectorId).addClass('selected').siblings().removeClass('selected');
      }
    }
  };

  var closeCommutePopover = function closeCommutePopover() {
    var commutePopover = $('#estimate-commute-time-popover');
    if (commutePopover.is(":visible")) {
      closeCommuteTimePopover();
    }
  };

  var checkTrafficOption = function checkTrafficOption() {
    if ($commuteDrive.hasClass('selected')) {
      $commuteTrafficOption.removeClass('no-show');
    } else {
      $commuteTrafficOption.addClass('no-show');
      closeCommuteInfoPopover();
    }
  };

  var closeCommuteInfoPopover = function closeCommuteInfoPopover() {
    $commutePopoverInfo.popover('hide');
  };

  var nextWednesday = function nextWednesday() {
    var day = new Date();

    // Set day to next Wednesday and set hours to 8:00 AM
    // if today is already Wednesday, set the day to Wednesday of next week
    day.setDate(day.getDate() + (9 - day.getDay()) % 7 + 1);
    day.setHours(8, 0, 0);

    return day;
  };

  var loadCommuteTime = function loadCommuteTime() {
    if (MOVE.Helper.hasSessionStorage()) {
      setDestinations();
      setMode();
      estimateCommuteTime(false);
    }
  };

  var renderCommuteTime = function renderCommuteTime(mode, duration) {
    var isGraphicalUplift = MOVE_DATA.visual_update_replatform === 'V1' && !MOVE_DATA.ab_vitality;
    var commuteIcon = isGraphicalUplift && mode === 'car' ? '<i class="margin-right"><img src="' + __WEBPACK_IMPORTED_MODULE_2__images_car_ic_svg___default.a + '" ></i>' : '<i class="margin-right ra ra-' + mode + '"></i>';
    $('.ldp-commute-icon').addClass('hide');
    $('.estimate-commute-popover-toggle').html(commuteIcon + duration);
  };

  MOVE.CommuteTime = {
    init: init,
    closeCommutePopover: closeCommutePopover,
    loadCommuteTime: loadCommuteTime
  };

  return MOVE.CommuteTime;
}(MOVE || {});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFromlocalStorage */
/* unused harmony export setAtlocalStorage */
/* unused harmony export getSeenProperties */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return markAsSeen; });
var key = 'rdc_x_map_seen_properties';
var max = 5000;

function getFromlocalStorage(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (err) {
    return null;
  }
}

function setAtlocalStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (err) {
    /** intentionally blank, for now */
  }
}

var getSeenProperties = function getSeenProperties() {
  if (!window) return [];

  return getFromlocalStorage(key) || [];
};

var markAsSeen = function markAsSeen(property_id) {
  if (!window) return;

  var items = getSeenProperties();

  property_id = '' + property_id;
  var index = items.indexOf(property_id);
  if (index > -1) {
    items.splice(index, 1);
  }
  items.unshift(property_id);
  if (items.length > max) {
    items.pop();
  }
  setAtlocalStorage(key, JSON.stringify(items));
};

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

MOVE.LDP = function (MOVE) {
  var init = function init() {
    var topBrowseCarouselOption = {
      items: 2,
      loop: true,
      showNav: 'show',
      moveBy: 'set',
      margin: 20,
      responsive: {
        0: {
          items: 2
        },
        600: {
          items: 3
        },
        996: {
          items: 4
        },
        1280: {
          items: 5
        }
      }
    };
    $("#ldp-top-browse-carousel").RdcHorizontalCarousel(topBrowseCarouselOption);

    if (!MOVE.Medias.ab_test_lb1_v3_check()) {
      $('.ab_test_lb1list_v3').css("display", "none");
      $('.ab_test_lb1map_v3').css("display", "none");
      $('.ab_test_qvlb1_v3').css("display", "none");
      $('.ab_test_fulllb1_v3').css("display", "none");
    }
  };
  MOVE.LDP = {
    init: init
  };
  return MOVE.LDP;
}(MOVE || {});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommonPlatformUtilities; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommonPlatformUtilities = function () {
  function CommonPlatformUtilities() {
    _classCallCheck(this, CommonPlatformUtilities);
  }

  _createClass(CommonPlatformUtilities, null, [{
    key: 'getCookie',

    /**
     * Get cookie utility function
     * @static
     * @public
     * @param cookieName {string}
     * @returns {number}
     */
    value: function getCookie(cookieName) {
      var cookiesArr = document.cookie.split(';');
      var dict = {};
      cookiesArr.forEach(function (cookie) {
        var name = cookie.split('=')[0];
        var value = cookie.split('=')[1];
        dict[name] = value;
      });

      return dict[cookieName];
    }

    /**
     * Get user's device type
     * @public
     * @returns {string}
     */

  }, {
    key: 'getDeviceType',
    value: function getDeviceType() {
      var _$$Device = $.Device,
          isAndroid = _$$Device.isAndroid,
          isIPad = _$$Device.isIPad,
          isMobile = MOVE.Helper.isMobile();


      if (isMobile) return "phone";else if (isIPad) return "ipad";else if (isAndroid) return "android tablet";
      return "other";
    }

    /**
     * Get user's oeprating system
     * @public
     * @returns {string}
     */

  }, {
    key: 'getOSType',
    value: function getOSType() {
      var _navigator = navigator,
          platform = _navigator.platform;

      if (platform.indexOf('iP') > -1) return "ios";else if (platform.indexOf('Android') > -1) return "android";else return "other";
    }

    /**
     * Scroll on click
     * @param eventElement
     * @param targetElement
     * @returns {void}
     */

  }, {
    key: 'scrollOnClick',
    value: function scrollOnClick(eventElement) {
      var ldpForm = '.ldp-full-bleed-form',
          ldpNextElement = '#ldp-additional-info',
          ldpLazyLoadElementWrapper = '#homes-near-street-wrapper',
          qvForm = '.qv-sec-bottom-lead-form',
          is_ldp = $(ldpForm).length > 0 ? true : false;

      $(eventElement).on('click', function () {
        if (is_ldp) {
          if ($(ldpLazyLoadElementWrapper).children().length > 0) {
            $('html, body').animate({
              scrollTop: $(ldpForm).offset().top - 50
            }, 1000);
          } else {
            $('html, body').animate({
              scrollTop: $(ldpNextElement).offset().top - 325
            }, 1000);
          }
        } else {
          $('html, body').animate({
            scrollTop: $(qvForm).offset().top - 50
          }, 1000);
        }
      });
    }

    /**
     * Phone number regular expression validation
     * @param val
     * @returns {boolean}
     */

  }, {
    key: 'phoneNumberValid',
    value: function phoneNumberValid(val) {
      var phoneRegex = '^\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$';
      var regex = new RegExp(phoneRegex);
      return regex.test(val);
    }

    /**
     * Format phone number
     * @returns {void}
     */

  }, {
    key: 'formatPhone',
    value: function formatPhone() {
      var $phoneInput = $('.st-contact-input');
      $phoneInput.on('keyup keypress input change', function () {
        if (/^(?=.*[0-9])[- +()0-9]+$/.test($(this).val()) === false) $(this).val('');
        $(this).val($(this).val().replace(/^(\d{3})(\d{3})(\d)+$/, "($1)$2-$3"));
      });
    }
  }]);

  return CommonPlatformUtilities;
}();

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accordionClick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_clicks__ = __webpack_require__(74);


var accordionClick = function accordionClick() {
  var timeout = 400;
  var moduleType = $(this).data('module-type');
  setTimeout(function () {
    MOVE.LDP.RightRailBC.getAdPosition();
  }, timeout);

  if (moduleType) {
    var propertyStatus = MOVE_DATA.propertyDetails.status || 'unknown';
    var accordionCollaspe = $(this).hasClass('collapsed') ? 'expand' : 'collapse';
    var omtag = propertyStatus + ':ldp:' + moduleType + ':' + accordionCollaspe;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_clicks__["b" /* trackClick */])(omtag, propertyStatus);
  }
};

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateLeadIdForRCM; });
/* This is a 3rd party JS which generates the lead id to be sent for RCM leads. Please don't remove it */
var generateLeadIdForRCM = function generateLeadIdForRCM() {
  if (MOVE_DATA.leadid_token) return;
  var s = document.createElement('script');
  s.id = 'LeadiDscript_campaign';
  s.type = 'text/javascript';
  s.async = true;
  s.src = document.location.protocol + '//d1tprjo2w7krrh.cloudfront.net/campaign/01836014-7527-fd48-9b7f-1a40a9705cfe.js';
  document.body.appendChild(s);
  watchForTokenToLoad();
};

var watchForTokenToLoad = function watchForTokenToLoad() {
  var intervalID = setInterval(function () {
    if (MOVE_DATA.leadid_token) clearInterval(intervalID);
    var $leadToken = $('#leadid_token');
    if ($leadToken && $leadToken.length) {
      MOVE_DATA.leadid_token = $leadToken.val();
    }
  }, 500);

  setTimeout(function () {
    clearInterval(intervalID);
  }, 8000);
};

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_js_tooltip__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_js_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_js_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_popover__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_js_popover__);



/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_property_details__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ldp_common_platform_events_popstate__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_critical_propertySeen__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascripts_shared_non_critical_accordion_tracking_helper__ = __webpack_require__(335);





MOVE.LDP.PropertyDetails = function (LDP) {
  var controller = "property_details";
  var action = "show";
  var onReady;
  var status = MOVE.CONSTANTS.PROPERTY_STATUS;

  var init = function init(options) {
    var data = (options || {}).data || MOVE.DataStore.getData('propertyDetails');
    MOVE.LDP.model = new __WEBPACK_IMPORTED_MODULE_0__models_property_details__["a" /* PropertyDetailsModel */](options || { data: data });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_ldp_common_platform_events_popstate__["a" /* addPopStateListener */])();
    onReady();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_critical_propertySeen__["a" /* markAsSeen */])(data.property_id);

    if (MOVE.DOMHelper.detectPageType() === 'ldp' && (MOVE_DATA.full_ldp_modules === 'V1' || MOVE_DATA.full_ldp_modules === 'V2')) {
      handleFullLdpAccordionClicks();
    }
  };

  var handleFullLdpAccordionClicks = function handleFullLdpAccordionClicks() {
    var accordionsClasses = $('div.full-ldp-collasped-accordion');

    accordionsClasses.each(function () {
      var accordion = $(this);
      if (accordion) {
        accordion.on('click', function () {
          __WEBPACK_IMPORTED_MODULE_3__javascripts_shared_non_critical_accordion_tracking_helper__["a" /* accordionClick */].call(this);
        });
      }
    });
  };

  var getPropertyStatus = function getPropertyStatus(data) {
    return isSameDomain() ? getPropertyStatusByReferrer(data) : getPropertyStatusByData(data);
  };

  // Check if current and referrer URL is the same domain
  var isSameDomain = function isSameDomain() {
    var referrer = document.referrer;

    return referrer.length && referrer.indexOf(window.location.protocol + "//" + window.location.host) === 0;
  };

  // Infer property search status by referrer
  var getPropertyStatusByReferrer = function getPropertyStatusByReferrer(data) {
    switch (document.referrer.split('/')[3]) {
      case 'realestateandhomes-search':
        return status.forSale;
      case 'foreclosures':
        return status.foreclosure;
      case 'soldhomeprices':
        return status.recentlySold;
      case 'propertyrecord-search':
        return status.propertyRecords;
      case 'newhomesconstruction':
        return status.newPlan;
      default:
        return getPropertyStatusByData(data, true);
    }
  };

  // Infer property search status by data
  var getPropertyStatusByData = function getPropertyStatusByData(data, isValidreferrer) {
    var isForeclosure = data.is_foreclosure,
        isRecentlySold = (data.status_display || '').toLowerCase() === 'recently sold',
        isOffMarket = (data.status_display || '').toLowerCase() === 'off market';

    if (isForeclosure) {
      return status.foreclosure;
    } else if (isRecentlySold) {
      return status.recentlySold;
    } else if (isOffMarket) {
      if (isValidreferrer && isHomePageOrPropertyRecordSRP()) {
        // If user is coming from home estimates tab or has visited property records SRP previously,
        // then direct it to property records SRP
        return status.propertyRecords;
      } else {
        // If user is not coming from property records SRP / home estimates tab from Home page,
        // defaulting it to FOR SALE
        return status.forSale;
      }
    } else {
      return data.status;
    }
  };

  var isHomePageOrPropertyRecordSRP = function isHomePageOrPropertyRecordSRP() {
    var criteria = MOVE.Helper.getSearchCriteriaFromCookie();
    var isHomePage = document.referrer.split('/')[3].length === 0;
    var isFROMPropertyRecordSRP = criteria !== undefined && criteria.status === "8";
    return isHomePage || isFROMPropertyRecordSRP;
  };

  onReady = function onReady() {
    var ldpPage = $("." + controller + '.' + action);
    if (ldpPage.length === 1) {
      ldpPage.ready(monitorDom);
    }
  };

  var dragPhotoEvent = function dragPhotoEvent() {
    $('#ldpPhotoMrect').addClass('hide');
    // Close commute time popover on photo gallery swipe
    MOVE.CommuteTime.closeCommutePopover();
  };

  var fillSearchBox = function fillSearchBox(searchBoxValue) {
    if (!isSameDomain() || _.isEmpty(searchBoxValue)) {
      var propertyDetails = MOVE.DataStore.getData('propertyDetails');
      if (!_.isEmpty(propertyDetails) && !_.isEmpty(propertyDetails.city) && !_.isEmpty(propertyDetails.state_code)) {
        $('#searchBox').val(propertyDetails.city + ', ' + propertyDetails.state_code);
      } else if (_.isEmpty(propertyDetails.city) && !_.isEmpty(propertyDetails.postal_code)) {
        $('#searchBox').val(propertyDetails.postal_code);
      } else if (_.isEmpty(propertyDetails.postal_code)) {
        $('#searchBox').val("");
      }
    } else if (searchBoxValue[0].areaType === 'address') {
      var recAddress = searchBoxValue[0].location.split(",");
      var address_str = recAddress[1] + ',' + recAddress[2];
      $('#searchBox').val(address_str);
    } else {
      $('#searchBox').val(searchBoxValue[0].location);
    }
  };

  var monitorDom = function monitorDom() {

    MOVE.LDP.CrabWalk.init();

    MOVE.Helper.pageLinking();

    // commute address search by smarty st
    MOVE.CommuteTime.init();

    // Set property status for LDP Search
    $.fn.autocomplete.setPropertyStatus(getPropertyStatus(LDP.model.data));

    MOVE.CommuteTime.loadCommuteTime();

    //Do any page specific custom NR tracking
    MOVE.LDP.NrCustomPageViewTracking.init();
  };

  LDP.PropertyDetails = {
    init: init,
    dragPhotoEvent: dragPhotoEvent,
    fillSearchBox: fillSearchBox
  };
  return LDP.PropertyDetails;
}(MOVE.LDP || {});

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

/*global window*/
MOVE.LDP.Photos = function (LDP) {
  "use strict";

  var goToImage, preloadPhotos, loadPhoto, initAdsCloseButton, photoGallery;

  var init = function init(options, onChangedCallBack, onDragCallBack) {
    photoGallery = options.target;
    photoGallery.owlCarousel({
      items: options.items,
      loop: true,
      margin: options.margin,
      startPosition: options.currentIndex,
      navSpeed: 100,
      lazyLoad: true,
      dots: false,
      nav: true,
      touchDrag: options.touchDrag,
      mouseDrag: options.mouseDrag,
      responsiveClass: options.responsiveClass,
      responsive: options.responsive,
      navText: ["<div class='gallery-arrows arrow-left hidden-xs hidden-xxs' data-omtag='edw:ldp:photo:prev'><i class='ra ra-chevron-left' data-omtag='edw:ldp:photo:prev'></i></div>", "<div class='gallery-arrows arrow-right hidden-xs hidden-xxs' data-omtag='edw:ldp:photo:next'><i class='ra ra-chevron-right' data-omtag='edw:ldp:photo:next'></i></div>"],
      navContainer: options.navigationContainer && $(options.navigationContainer).length > 0 ? options.navigationContainer : '',
      onDrag: function onDrag() {
        if (onDragCallBack) {
          onDragCallBack();
        }
      },
      onChanged: function onChanged(e) {
        if (!e.namespace || e.property.name !== 'position') {
          return;
        }
        var index = e.relatedTarget.relative(e.item.index);
        preloadPhotos(photoGallery, index);
        onChangedCallBack(e.item.count, index);
        // Update the url only when index is undefined.
        if (index !== undefined) {
          window.history.replaceState("", "RdcNext", '#photo' + index);
        }
      }
    });
    initAdsCloseButton();
  };

  var closePhotoMrectAds = function closePhotoMrectAds(photos) {
    var items = photos.find("div.owl-item:not('.cloned')");
    if (items.length > 0) {
      photos.trigger('remove.owl.carousel', items.length - 1); //remove owl carousel container item for the ads
      photos.trigger('prev.owl.carousel'); // stay at last photo
    }
  };

  initAdsCloseButton = function initAdsCloseButton() {
    $('.ldp-photo-wrap #photomrect1AdsClose').off('click').click(function (event) {
      $(event.target).parents('.fsgallery-ad').remove(); //remove the ads div
      closePhotoMrectAds($('#ldpPhotos'));
    });
    $('.ldp-photo-cta #photomrect2AdsClose').off('click').click(function (event) {
      $(event.target).parents('.fsgallery-ad').remove(); //remove the ads div
      closePhotoMrectAds($('#ldpPhotoGallery'));
    });
  };

  $(document).keydown(function (e) {
    var photos = $('.ldp-photos', e.target);
    if (0 === photos.length) {
      return;
    }
    if (e.keyCode === 37) {
      photos.trigger('prev.owl.carousel');
    } else if (e.keyCode === 39) {
      photos.trigger('next.owl.carousel');
    }
  });

  //preload previous and next photos that has not been alrady loaded
  preloadPhotos = function preloadPhotos(photos, index) {
    var items = photos.find("div.owl-item:not('.cloned')");
    loadPhoto(items.eq(index).next());
    loadPhoto(items.eq(index).prev());
  };

  loadPhoto = function loadPhoto(photoDiv) {
    if (photoDiv) {
      var photo = photoDiv.find("img");
      if (photo.length === 1) {
        if (photo.attr("src") === "") {
          photo.attr("src", photo.data("src"));
        }
        return;
      }
      photo.each(function () {
        if ($(this).attr("src") === "") {
          $(this).attr("src", $(this).data("src"));
        }
      });
    }
  };

  LDP.Photos = {
    init: init,
    goToImage: goToImage,
    preloadPhotos: preloadPhotos
  };

  return LDP.Photos;
}(MOVE.LDP || {});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validationForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return submitFromKeypad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return textInputModalOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return closeTutorial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return phoneFieldMask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLeadData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_modal_impression__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_critical_tracking_shared_leads__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_critical_helper_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mortgage_jornaya_lead_id__ = __webpack_require__(38);





var validationForm = function validationForm(modalContainer, property) {
  var $textNumberForm = $(modalContainer).find('form');
  $textNumberForm.validate({
    rules: {
      "phone": {
        required: true,
        phoneUS: true
      }
    },
    messages: {
      "phone": {
        required: "Please enter your phone number",
        phoneUS: "Please enter a valid phone number"
      }
    },
    errorPlacement: function errorPlacement(error, element) {
      error.insertAfter(element);
    },
    submitHandler: function submitHandler() {
      submitTextLead(modalContainer, property);
    }
  });
};

var submitFromKeypad = function submitFromKeypad(inputContainer, submitContainer) {
  $(inputContainer).keydown(function (e) {
    if (e.keyCode == 13) {
      $(submitContainer).submit();
    }
  });

  $(submitContainer).on('click', function () {
    $(submitContainer).submit();
  });
};

var textInputModalOpen = function textInputModalOpen(modalContainer, omtag) {
  $(modalContainer).on('shown.bs.modal', function () {
    $('body').addClass('modal-open');
    $(this).off('shown.bs.modal');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_modal_impression__["a" /* trackModalImpression */])('web:ldp:text-connection', omtag);
  });
};

var closeTutorial = function closeTutorial(closeButton, modalContainer) {
  $(closeButton).on('click', function () {
    $(modalContainer).modal('hide');
  });
};

var textLeadSubmited = false;

var submitTextLead = function submitTextLead(modalContainer, property) {
  if (textLeadSubmited) return;

  textLeadSubmited = true;

  /* track text lead button position for ldp and qv */
  var leadPlacement = null;

  if (modalContainer === '#textInputModal') {
    leadPlacement = leadSubmittionTracking(modalContainer);
  } else {
    /* LGWEB-159 */
    leadPlacement = $(modalContainer).find('.submit').data('lead-position');
    /* end LGWEB-159 */
  }

  if (leadPlacement) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_critical_tracking_shared_leads__["a" /* trackLeadText */])({ property: property, leadPlacement: leadPlacement }); // track text lead when data-lead-position is present
  }

  if (!MOVE_DATA.leadid_token) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__mortgage_jornaya_lead_id__["a" /* generateLeadIdForRCM */])();

  $.ajax({
    data: getLeadData(modalContainer, property, {}),
    url: "/leads",
    type: 'POST',
    success: function success(response) {
      parseResponseAndDisplayThankYou(response, property);
      var hlt_txt_vs_email_ab = MOVE_DATA.ab_hlt_text_vs_email;
      if (hlt_txt_vs_email_ab === "V1" || hlt_txt_vs_email_ab === "V2" || MOVE_DATA.ab_only_txt_mweb === 'V1') {
        $('.email-button').text("Texted").addClass("texted");
      } else {
        $('.text-button').text("Texted").addClass("texted");
      }
      /* LGWEB-978 */
      $('#qv-sticky-text-cta').removeClass('ab-text-gallery');
      $('#qv-sticky-text-cta').removeClass('ab-text');
      /* END LGWEB-978 */
      textLeadSubmited = false;
      /* LGWEB-159 */
      $('.lf-text-wrapper').addClass('texted');
      /* END LGWEB-159 */
    },
    error: function error(_error) {
      MOVE.Common.addNewRelicLog('textLeadFailure', { error: _error });
      showThankyouModal(null, property);
      textLeadSubmited = false;
    }
  });
};

var parseResponseAndDisplayThankYou = function parseResponseAndDisplayThankYou(response, property) {
  try {
    var data = JSON.parse(response.data);
    if (!data.meta || !data.meta.success) {
      MOVE.Common.addNewRelicLog('textLeadFailure', MOVE.Common.leadErrorMsg(data));
    }
    showThankyouModal(data, property);
  } catch (e) {
    MOVE.Common.addNewRelicLog('textLeadFailure', { exception_msg: e.message });
    showThankyouModal(null, property);
  }
};

function phoneFormatterUS(event) {
  event.preventDefault();
  var mask = "(___) ___-____";
  var eventValue = event.target.value;
  var text = "";
  var numbers = [];
  var output = "";
  text = eventValue;
  var theLastPos = 1;
  //get numbers
  for (var i = 0; i < text.length; i++) {
    if (!isNaN(text.charAt(i)) && text.charAt(i) != " ") {
      numbers.push(text.charAt(i));
    }
  }
  //write over mask
  for (var j = 0; j < mask.length; j++) {
    if (mask.charAt(j) == "_") {
      //replace "_" by a number 
      if (numbers.length == 0) {
        output = output + mask.charAt(j);
      } else {
        output = output + numbers.shift();
        theLastPos = j + 1;
      }
    } else {
      output = output + mask.charAt(j);
    }
  }
  $(this).val(output);
  if (event.which >= 48 && event.which <= 57 || event.which == 8) {
    $(this)[0].setSelectionRange(theLastPos, theLastPos);
  }
}

var phoneFieldMask = function phoneFieldMask(event) {
  $(".phone").addClass("phoneField");
  phoneFormatterUS.call(this, event);
  $(this).keyup(phoneFormatterUS);
};

var getLeadData = function getLeadData(modalContainer, property, options) {
  var pageType = property.pageType,
      appVersion = property.appVersion,
      mprID = property.mprID,
      property_id = property.property_id,
      propertyStatus = property.propertyStatus,
      listing_id = property.listing_id,
      listingID = property.listingID,
      listingAddress = property.listingAddress,
      isScheduleTour = options.isScheduleTour,
      mobileNumber = options.mobileNumber,
      stDate = options.stDate,
      stTime = options.stTime,
      isStCall = options.isStCall,
      $phoneInput = $(modalContainer).find('.form-control.phone'),
      phone = isScheduleTour ? mobileNumber : $phoneInput.val(),
      leadData = {
    lead: {
      appVersion: appVersion,
      os: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_critical_helper_js__["a" /* getMobileOSType */])(),
      deviceType: getDeviceType(),
      mprID: property_id || mprID,
      phone: phone,
      time: new Date().toISOString(),
      listingId: listing_id || listingID,
      propertyStatus: propertyStatus || "",
      listingAddress: listingAddress || "",
      referral: pageType === 'ldp-quickview' ? 'quick_view' : '',
      recentSearches: JSON.stringify(MOVE.UserActivity.getRecentSearches()),
      recentViews: JSON.stringify(MOVE.UserActivity.getRecentViews()),
      isStCall: isStCall,
      isScheduleTour: isScheduleTour,
      stDate: stDate,
      stTime: stTime,
      rcm_lead_id: MOVE_DATA.leadid_token
    },
    text_lead: true
  };


  MOVE.Common.cacheInputs('', '', $phoneInput);
  $('.phone').val($phoneInput.val());
  return $.param(leadData);
};

var getDeviceType = function getDeviceType() {
  var _MOVE_DATA = MOVE_DATA,
      isAndroid = _MOVE_DATA.isAndroid,
      isIPad = _MOVE_DATA.isIPad,
      isMobile = MOVE.Helper.isMobile();


  switch (true) {
    case isMobile:
      return "phone";
    case isIPad:
      return "ipad";
    case isAndroid:
      return "android tablet";
    default:
      return "other";
  }
};

var showThankyouModal = function showThankyouModal(data, property) {
  var monthlyEstimate = $('#monthly_payment_estimate').text();
  $('.mortgage-thankyou-modal-payment .payment').html(monthlyEstimate);
  $("#textThankyouModal").modal("show");
  MOVE.LEAD.Common.dismissModalLeadForm($("#textInputModal"));
  crossSellInit(data, property);
};

var crossSellInit = function crossSellInit(data, property) {
  if (data) {
    var ld = data.meta.params.lead.lead_data;
    var lead_id = data.lead.id;
  } else {
    ld = {};
    lead_id = '';
  }
  var alternate_ld = MOVE.Common.getCachedInputsData() || {};
  var crossSellDidSubmit = false;
  if (!crossSellDidSubmit) {
    MOVE.MORTGAGE.CrossSellThankyouModal.init(Object.assign({}, {
      selector: '#textThankyouModal',
      after_submit: function after_submit() {
        crossSellDidSubmit = true;
      },
      lead_id: lead_id,
      email: ld.email || alternate_ld.email,
      phone: ld.phone || alternate_ld.phone,
      first_name: ld.first_name || alternate_ld.fullName,
      last_name: ld.last_name || ''
    }, propertyCrossSellValues(property)));
  }
};

var propertyCrossSellValues = function propertyCrossSellValues(property) {
  return {
    listing_id: property.listing_id || property.listingID || property.id,
    property_type: property.propertyType,
    price: property.listingPrice,
    street: property.address,
    city: property.listingCity,
    state: property.listingState,
    zip_code: property.listingZip
  };
};

var leadSubmittionTracking = function leadSubmittionTracking() {
  var _MOVE_DATA$adobeDTM = MOVE_DATA.adobeDTM,
      pageType = _MOVE_DATA$adobeDTM.pageType,
      propertyStatus = _MOVE_DATA$adobeDTM.propertyStatus;

  var leadPosition = '';
  if (pageType === "ldp-quickview") {
    var qvWrapClasses = $('#qv-wrap').attr("class");
    if (qvWrapClasses.includes('qv-full-view-gallery')) {
      leadPosition = 'photo_gallery';
    } else if (qvWrapClasses.includes('qv-list-gallery')) {
      leadPosition = 'photo_list_gallery';
    }
  } else if (pageType === 'ldp') {
    var $galleryModal = $('#ldp-fullscreen-gallery');
    var $galleryCarousel = $galleryModal.find('#mobileFsGalleryCarousel');
    if ($galleryModal.hasClass('in')) {
      if ($galleryCarousel.hasClass('shown')) {
        leadPosition = 'photo_gallery';
      } else {
        leadPosition = 'photo_list_gallery';
      }
    }
  }
  return propertyStatus + ':' + pageType + ':' + (leadPosition ? leadPosition : 'sticky_footer') + ':contact_agent_text';
};

/***/ }),

/***/ 771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addPopStateListener; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_non_critical_events_popstate__ = __webpack_require__(156);


// The event is triggered when browser back button is clicked
// redirects back to srp when window.history.state has srp flag and path
var addPopStateListener = function addPopStateListener() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_non_critical_events_popstate__["b" /* onPopState */])({
    type: __WEBPACK_IMPORTED_MODULE_0_shared_non_critical_events_popstate__["d" /* REDIRECT */],
    condition: function condition(_ref) {
      var srp = _ref.srp,
          path = _ref.path;
      return srp && path;
    },
    handler: function handler(_ref2) {
      var path = _ref2.path;
      return path;
    }
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_non_critical_events_popstate__["b" /* onPopState */])({
    type: __WEBPACK_IMPORTED_MODULE_0_shared_non_critical_events_popstate__["d" /* REDIRECT */],
    condition: function condition(_ref3) {
      var isQuickView = _ref3.isQuickView,
          path = _ref3.path;
      return isQuickView && path;
    },
    handler: function handler(_ref4) {
      var path = _ref4.path;
      return path;
    }
  });
};

/***/ })

},[1785]);


// WEBPACK FOOTER //
// ldp_critical-a8471d2db6080484dea1.js